var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64, _path65, _path66, _path67, _path68, _path69, _path70, _path71, _path72, _path73, _path74, _path75, _path76, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _path332, _path333, _path334, _path335, _path336, _path337, _path338, _path339, _path340, _path341, _path342, _path343, _path344, _path345, _path346, _path347, _path348, _path349, _path350, _path351, _path352, _path353, _path354, _path355, _path356, _path357, _path358, _path359, _path360, _path361, _path362, _path363, _path364, _path365, _path366, _path367, _path368, _path369, _path370, _path371, _path372, _path373, _path374, _path375, _path376, _path377, _path378, _path379, _path380, _path381, _path382, _path383, _path384, _path385, _path386, _path387, _path388, _path389, _path390, _path391, _path392, _path393, _path394, _path395, _path396, _path397, _path398, _path399, _path400, _path401, _path402, _path403, _path404, _path405, _path406, _path407, _path408, _path409, _path410, _path411, _path412, _path413, _path414, _path415, _path416, _path417, _path418, _path419, _path420, _path421, _path422, _path423, _path424, _path425, _path426, _path427, _path428, _path429, _path430, _path431, _path432, _path433, _path434, _path435, _path436, _path437, _path438, _path439, _path440, _path441, _path442, _path443, _path444, _path445, _path446, _path447, _path448, _path449, _path450, _path451, _path452, _path453, _path454, _path455, _path456, _path457, _path458, _path459, _path460, _path461, _path462, _path463, _path464, _path465, _path466, _path467, _path468, _path469, _path470, _path471, _path472, _path473, _path474, _path475, _path476, _path477, _path478, _path479, _path480, _path481, _path482, _path483, _path484, _path485, _path486, _path487, _path488, _path489, _path490, _path491, _path492, _path493, _path494, _path495, _path496, _path497, _path498, _path499, _path500, _path501, _path502, _path503, _path504, _path505, _path506, _path507, _path508, _path509, _path510, _path511, _path512, _path513, _path514, _path515, _path516, _path517, _path518, _path519, _path520, _path521, _path522, _path523, _path524, _path525, _path526, _path527, _path528, _path529, _path530, _path531, _path532, _path533, _path534, _path535, _path536, _path537, _path538, _path539, _path540, _path541, _path542, _path543, _path544, _path545, _path546, _path547, _path548, _path549, _path550, _path551, _path552, _path553, _path554, _path555, _path556, _path557, _path558, _path559, _path560, _path561, _path562, _path563, _path564, _path565, _path566, _path567, _path568, _path569, _path570, _path571, _path572, _path573, _path574, _path575, _path576, _path577, _path578, _path579, _path580, _path581, _path582, _path583, _path584, _path585, _path586, _path587, _path588, _path589, _path590, _path591, _path592, _path593, _path594, _path595, _path596, _path597, _path598, _path599, _path600, _path601, _path602, _path603, _path604, _path605, _path606, _path607, _path608, _path609, _path610, _path611, _path612, _path613, _path614, _path615, _path616, _path617, _path618, _path619, _path620, _path621, _path622, _path623, _path624, _path625, _path626, _path627, _path628, _path629, _path630, _path631, _path632, _path633, _path634, _path635, _path636, _path637, _path638, _path639, _path640, _path641, _path642, _path643, _path644, _path645, _path646, _path647, _path648, _path649, _path650, _path651, _path652, _path653, _path654, _path655, _path656, _path657, _path658, _path659, _path660, _path661, _path662, _path663, _path664, _path665, _path666, _path667, _path668, _path669, _path670, _path671, _path672, _path673, _path674, _path675, _path676, _path677, _path678, _path679, _path680, _path681, _path682, _path683, _path684, _path685, _path686, _path687, _path688, _path689, _path690, _path691, _path692, _path693, _path694, _path695, _path696, _path697, _path698, _path699, _path700, _path701, _path702, _path703, _path704, _path705, _path706, _path707, _path708, _path709, _path710, _path711, _path712, _path713, _path714, _path715, _path716, _path717, _path718, _path719, _path720, _path721, _path722, _path723, _path724, _path725, _path726, _path727, _path728, _path729, _path730, _path731, _path732, _path733, _path734, _path735, _path736, _path737, _path738, _path739, _path740, _path741, _path742, _path743, _path744, _path745, _path746, _path747, _path748, _path749, _path750, _path751, _path752, _path753, _path754, _path755, _path756, _path757, _path758, _path759, _path760, _path761, _path762, _path763, _path764, _path765, _path766, _path767, _path768, _path769, _path770, _path771, _path772, _path773, _path774, _path775, _path776, _path777, _path778, _path779, _path780, _path781, _path782, _path783, _path784, _path785, _path786, _path787, _path788, _path789, _path790, _path791, _path792, _path793, _path794, _path795, _path796, _path797, _path798, _path799, _path800, _path801, _path802, _path803, _path804, _path805, _path806, _path807, _path808, _path809, _path810, _path811, _path812, _path813, _path814, _path815, _g, _path816, _g2, _g3, _path817, _path818, _path819, _path820, _path821, _path822, _path823, _path824, _path825, _path826, _path827, _path828, _path829, _path830, _path831, _path832, _path833, _path834, _path835, _path836, _path837, _path838, _path839, _path840, _path841, _path842, _path843, _path844;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSv(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1005,
    height: 567,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h1005v567H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#0047ab",
    d: "M0 378h1005v189H0zM0 0h1005v189H0z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m463.041 354.917-.035.035.802 5.406c-1.46-.524-2.786.345-3.417 1.5-1.004 2.032-.149 3.565 1.812 4.57l2.617 1.29 4.812-9.417-1.917-1.012-1.884 3.837h-.07l-.418-5.058-2.302-1.15zm.453 7.22c.387-.051.822.073 1.29.28l.28.139-1.36 2.581-.28-.14c-.872-.501-1.443-1.026-.941-2.092.294-.503.624-.716 1.011-.768zm-8.872-2.295 1.287-1.875-2.9-1.943 1.004-1.433 2.811 1.875 1.592-2.378-2.966-1.942 1.004-1.501 4.773 3.18-5.928 8.852-4.71-3.18 1.004-1.44 2.964 1.874m-1.91-12.444v.035l-2.617 2.965-.766-.628c-1.723-1.524-3.41-1.449-4.849.21-1.591 1.875-1.007 3.48.802 4.987l2.163 1.883 6.871-8.056zm-5.65 3.487c.462-.101.933.144 1.464.595l.314.278-1.883 2.163-.35-.176c-.763-.652-1.168-1.328-.383-2.265.302-.352.56-.532.838-.595zm-7.395-.921-1.438-1.59 4.425-3.99c.937-.871 2.245-2.244 1.003-3.556-1.221-1.373-2.682-.195-3.684.637l-4.34 3.99-1.438-1.596 4.709-4.27c1.875-1.723 4.12-2.159 6.083 0 2.026 2.16 1.286 4.336-.633 6.084l-4.622 4.27m-4.146-20.02a2.489 2.489 0 0 0-.454.035c-.416.068-.86.234-1.29.523-.938.653-1.614 1.812-1.047 3.035-.806-.285-1.635-.049-2.267.454-1.722 1.155-1.643 2.606-.488 4.325l1.5 2.163 8.685-6-1.884-2.721c-.715-1.072-1.688-1.788-2.755-1.814zm.14 2.268c.642-.052 1.109.445 1.534 1.081l.28.35v.068l-2.269 1.5-.174-.28c-.48-.807-1.071-1.76-.069-2.475.256-.165.483-.226.697-.244zm-3.105 3.069c.387.003.733.282 1.046.732l.105.21-2.023 1.43-.175-.174c-.435-.653-.57-1.315.28-1.884.302-.22.534-.315.767-.313zm-.148-9.818-1.438-2.684 1.503-.848 2.529 4.554-9.352 5.056-1.068-1.87 7.826-4.208m-1.59-7.545.784 2.026-9.701 4.275-.85-2.026 9.788-4.275m-10.987-7.322c-.502.714-.567 1.719-.349 2.68.72 1.874 2.748 2.46 4.556 1.874 1.657-.502 2.965-2.244 2.311-4.118-.197-.938-1.003-1.591-1.809-2.032l2.31-.714c.633.63 1.155 1.284 1.439 2.154.938 2.963-.785 5.932-3.553 6.892-2.9.848-6.083-.351-7.107-3.465-.283-.788-.283-1.658-.196-2.534l2.377-.72m5.087-14.223-9.941 6 .314 1.674 11.44 2.302-.419-2.232-2.301-.523h-.07l-.698-3.767 2.093-1.221zm-3.14 4.395.419 2.511-3.977-.487zm-2.964-24.206c-2.508.214-4.391 2.063-4.64 4.848L414 284.53l10.464.872.279-3.035c.218-3.117-1.848-5.524-4.813-5.72a6.046 6.046 0 0 0-1.117 0zm.175 2.372c.23-.02.47-.017.732 0 1.896.152 3.09 1.18 2.895 3.557v.35l-6.349-.524.07-.349c.134-1.907 1.026-2.905 2.65-3.034zm-1.513-8.272 2.246.414.718-3.335 1.723.348-.633 3.336 2.813.632.719-3.466 1.743.283-1.155 5.647-10.355-2.159 1.069-5.58 1.808.348-.718 3.467m4.076-13.933 2.18.854 1.221-3.188 1.656.638-1.22 3.18 2.681 1.004 1.287-3.248 1.656.63-2.092 5.275-9.941-3.834 2.18-5.273 1.657.563-1.286 3.337m10.115-5.385 1.373-2.685 1.657.787-2.376 4.62-9.483-4.837 1.003-1.875 7.826 3.99m2.964-16.614c-.631 0-1.286.195-1.656.787-.415.569-.415 1.373.065 1.808 1.44 1.004 3.466-2.963 6.366-.781 1.657 1.284 2.027 3.27.72 5.055-.939 1.223-2.246 1.591-3.686 1.502l-.194-1.936c.849.279 1.874.061 2.375-.637.566-.63.283-1.59-.348-2.026-.851-.63-1.723 0-2.53.502-1.22.787-2.463 1.223-3.77.196-1.44-1.004-1.724-2.963-.634-4.425.567-.782 1.723-1.591 2.748-1.719l.566 1.651m4.713-9.361-1.151 1.22 4.849 10.674 1.569-1.64-1.011-2.162.034-.07 2.686-2.721 2.162.907 1.57-1.64zm1.64 3.068h.07v.036l3.312 1.5-1.64 1.744zm11.261-2.468 2.377-1.875 1.068 1.35-4.055 3.271-6.67-8.26 1.722-1.373 5.494 6.887m6.735-6.825.066-.062-1.81-7.327 2.027-1.217 2.159 11.53-1.068.63-9.418-6.953 1.963-1.223 6.081 4.622m7.773-12.54-1.5.732.56 11.65 2.022-.942-.07-2.372h.036l3.487-1.605 1.64 1.64 2.162-.838zm.419 3.487 2.582 2.652-2.163.94zm10.883-7.116a6.646 6.646 0 0 0-1.15.244l-2.896.769 2.964 10.219 2.93-.837c3.052-.892 4.447-3.696 3.663-6.592-.783-2.56-2.902-4.09-5.511-3.802zm.523 2.163c1.305.049 2.155.814 2.58 2.338.59 1.83.01 3.38-2.3 4.01l-.28.105-1.814-6.139.35-.14a4.795 4.795 0 0 1 1.464-.174zm12.766-5.301c-.197.005-.39.01-.594.035-3.117.435-5.053 3.349-4.638 6.312.436 2.97 2.99 5.192 6.174 4.78 3.182-.436 5.017-3.28 4.603-6.245-.347-2.783-2.59-4.96-5.546-4.882zm-.244 2.372c1.678-.219 3.152 1.225 3.348 2.755.131 1.433-.886 3.378-2.477 3.662-1.666.216-3.169-1.428-3.383-2.86-.153-1.613.789-3.363 2.511-3.557zm9.138-2.86-.14 10.673h2.163v-4.291h.07l2.616 4.29 2.581.069v-.034l-3.035-4.569c1.461-.218 2.268-1.522 2.268-2.896.065-2.248-1.448-3.182-3.628-3.244zm2.092 1.883h.28c1.025 0 1.814.243 1.814 1.465 0 1.155-.78 1.43-1.85 1.43h-.209l-.035.035zm20.415 2.392-.567 2.249 3.333.781-.413 1.808-3.334-.847-.634 2.745 3.404.937-.419 1.724-5.49-1.44 2.528-10.29 5.58 1.373-.436 1.814-3.465-.854m7.98 0 1.435.568 2.617 9.07h.067l2.68-6.586 1.963.787-3.99 10.006-1.44-.569-2.678-9.07-2.662 6.737-2.026-.781 4.058-10.14m14.186 16.893 2.533 1.595-.937 1.502-4.426-2.68 5.642-9.068 1.814 1.155-4.627 7.457m12.874-2.003-10.22 5.826 1.708 1.36 2.094-1.151.034.034 2.965 2.442-.732 2.232 1.813 1.43 3.627-11.092zm-1.64 3.14-1.22 3.453-1.78-1.43zm17.614 13.498-11.37 2.965 1.29 1.814 2.372-.593h.035l2.232 3.138-1.29 2.024 1.29 1.813 6.384-9.8zm-2.371 2.616-2.093 3.035-1.361-1.884zm7.555 14.642-7.172.715-.284-.63 4.839-5.146v-.061l-6.301 2.092-.999-1.941 10.57-3.25.72 1.375-4.99 5.58 7.389-.787.721 1.373-9.07 6.368-.937-1.942 5.492-3.684m5.19 6.976-2.183.787 1.072 3.18-1.725.569-1.065-3.186-2.684.855 1.132 3.4-1.719.566-1.808-5.428 10.007-3.4 1.87 5.425-1.72.57-1.155-3.4m3.996 6.844-10.36 2.163.42 2.163 4.115-.943h.07l-3.628 3.558.488 2.511.07.035 3.768-3.907c.524 1.374 2.029 1.784 3.313 1.5 2.243-.435 2.84-2.097 2.337-4.255zm-1.36 2.582v.173c.224 1.025.21 1.897-1.012 2.093-1.178.218-1.619-.432-1.814-1.5v-.21zm-7.083 11.15-.195-2.092 10.507-1.221.28 2.092-10.57 1.222m8.236 10.311c.721-.567 1.072-1.504 1.072-2.464-.067-2.093-1.875-3.182-3.682-3.182-1.815 0-3.556 1.286-3.556 3.336 0 .85.503 1.809 1.155 2.376l-2.461.065c-.351-.85-.636-1.656-.636-2.529-.062-3.117 2.466-5.428 5.43-5.494 3.03 0 5.648 2.158 5.709 5.364 0 .85-.129 1.722-.564 2.462l-2.467.066m-7.838 1.976-.208 2.233 2.057 1.15-.487 3.838-2.303.488-.278 2.337 11.3-2.825.21-1.64zm3.559 4.36 3.348 1.5v.105l-3.628.767zm-3.193 26.101c.938-.284 1.59-1.004 1.936-1.808.787-1.943-.501-3.773-2.16-4.426-1.65-.63-3.766-.133-4.553 1.658a3.828 3.828 0 0 0 .195 2.746l-2.31-.848c-.067-.938 0-1.724.285-2.596 1.154-2.901 4.424-4.118 7.104-2.962 2.813 1.065 4.492 4.117 3.337 7.103a6.101 6.101 0 0 1-1.5 2.094l-2.317-.938m-1.764 5.709-2.027-1.067-1.655 2.964-1.508-.782 1.574-3.03-2.528-1.373-1.724 3.182-1.507-.849 2.684-5.061 9.354 5.061-2.685 4.99-1.59-.848 1.657-3.12m-2.07 7.762-.854 1.223-9.415.278-.067.068 5.798 4.208-1.283 1.725-8.7-6.369.854-1.222 9.414-.346h.068l-5.866-4.275 1.284-1.724 8.767 6.457m-18.946 6.016 1.506-1.59 6.362 6.144 1.507-1.658 1.284 1.223-4.554 4.776-1.284-1.221 1.5-1.591-6.366-6.083m-3.1 3.131-1.674 1.29 2.757 3.35v.068l-4.85-1.604-1.952 1.64.035.07 5.197 1.43c-.96 1.088-.729 2.625.21 3.696 1.372 1.719 3.19 1.408 4.847.036l2.162-1.85-6.731-8.127zm2.06 5.929 1.882 2.268-.21.104c-.807.697-1.519 1.007-2.301.07-.72-.87-.36-1.582.488-2.302zm-8.616-.419-1.953 1.187.419 2.37h-.036l-3.243 2.024-1.885-1.43-1.952 1.22 9.382 7.012 1.36-.838-2.092-11.544zm-1.257 5.58.943 3.488h-.07l-2.895-2.266zm-10.45 3.174-2.813 1.222-.72-1.59 4.71-2.249 4.56 9.638-1.965.847-3.773-7.89m50.076-101.153 2.126 2.784h1.686l-1.466-2.784zm-154.113 88.699 3.476-.429 1.18 1.204-3.015.9z",
    fill: "#fc0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.595 2.443-3.03.566-.413 10.572-5.274 17.048-6.301 6.364-.999 16.394-4.839 18.487-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64 0-7.675-.937-13.91-2.092-18.922-1.156-4.993-9.7-19.64-14.934-26.12 0 0 11.752 18.205 13.778 25.247 2.026 7.173 2.595 15.87 2.461 20.884-.129 4.12-3.488 19.142-8.477 30.17-3.968 8.85-7.455 9.855-13.629 14.783-2.896 2.31-8.476 6.016-13.187 8.416-4.709 2.309-14.715 5.273-17.33 5.642-2.681.502-16.023 4.425-17.767 5.28-1.722.87-6.301 4.837-7.456 6.144",
    fill: "#090"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M484.357 359.842s3.772-.285 4.425-.285c.567 0 1.876-2.595 2.443-3.03.566-.413 10.572-5.274 17.048-6.301 6.364-.999 16.394-4.839 18.487-5.86 10.726-5.145 22.691-14.716 25.376-18.64 2.745-4.118 5.708-13.628 7.014-18.79.57-2.378 3.84-12.035 3.84-18.64 0-7.675-.937-13.91-2.092-18.922-1.156-4.993-9.7-19.64-14.934-26.12 0 0 11.752 18.205 13.778 25.247 2.026 7.173 2.595 15.87 2.461 20.884-.129 4.12-3.488 19.142-8.477 30.17-3.968 8.85-7.455 9.855-13.629 14.783-2.896 2.31-8.476 6.016-13.187 8.416-4.709 2.309-14.715 5.273-17.33 5.642-2.681.502-16.023 4.425-17.767 5.28-1.722.87-6.301 4.837-7.456 6.144z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81c-.284-1.373-.413-2.371-.937-2.745-.347-.503-1.875-2.244-2.16-3.4-.279-1.155 0-2.092 0-2.683 0-.564-.412-2.59-.412-2.59s.72-2.467 1.288-2.969c.564-.346 2.093-2.461 2.311-3.03 0 0-.067 1.155.279 1.725.502.563.636 2.093.636 2.962 0 .855-.285 2.903 0 3.902.28 1.155.72 2.092.435 3.404-.194 1.065-1.44 5.425-1.44 5.425",
    fill: "#090"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81c-.284-1.373-.413-2.371-.937-2.745-.347-.503-1.875-2.244-2.16-3.4-.279-1.155 0-2.092 0-2.683 0-.564-.412-2.59-.412-2.59s.72-2.467 1.288-2.969c.564-.346 2.093-2.461 2.311-3.03 0 0-.067 1.155.279 1.725.502.563.636 2.093.636 2.962 0 .855-.285 2.903 0 3.902.28 1.155.72 2.092.435 3.404-.194 1.065-1.44 5.425-1.44 5.425",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M551.696 324.377s3.403-4.276 3.403-6.084c0-1.724.285-2.746.563-3.186.286-.413 2.25-2.68.503-5.425-.781-1.155-.938-1.072-1.374-2.31-.562-1.591-1.718-1.591-1.874-3.185 0 0-.413 1.873-.564 3.468-.133 1.592.129 2.155.28 3.026.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.59 0 .418.564 6.016-.636 7.828",
    fill: "#090"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M551.696 324.377s3.403-4.276 3.403-6.084c0-1.724.285-2.746.563-3.186.286-.413 2.25-2.68.503-5.425-.781-1.155-.938-1.072-1.374-2.31-.562-1.591-1.718-1.591-1.874-3.185 0 0-.413 1.873-.564 3.468-.133 1.592.129 2.155.28 3.026.133.937-.413 1.941-.413 3.254 0 1.283.133 1.808.133 2.59 0 .418.564 6.016-.636 7.828z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M514.092 347.285s2.813-.284 3.903-.502c.718-.062 2.463-.502 3.466-.848.785-.286 2.464-1.156 3.904-2.685 2.679-2.896 2.371-4.425 2.896-4.554 1.005-.128-1.501-.413-2.679-.195-1.222.129-2.746.937-3.838 1.941-1.069 1-2.747 2.155-3.336 2.59-.567.42-1.003.637-1.656 1.44-.633.854-.633 1.373-2.681 2.813",
    fill: "#090"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M514.092 347.285s2.813-.284 3.903-.502c.718-.062 2.463-.502 3.466-.848.785-.286 2.464-1.156 3.904-2.685 2.679-2.896 2.371-4.425 2.896-4.554 1.005-.128-1.501-.413-2.679-.195-1.222.129-2.746.937-3.838 1.941-1.069 1-2.747 2.155-3.336 2.59-.567.42-1.003.637-1.656 1.44-.633.854-.633 1.373-2.681 2.813z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M510.255 349.333s7.107-3.18 7.76-3.772c.786-.497 1.941-1.652 2.683-2.462.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.497-4.71 2.31-1.439 1.067-2.398 2.026-2.747 2.813-.567 1.217-1.22 3.465-1.874 4.554-.567 1.155-1.657 2.595-3.903 4.772",
    fill: "#090"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M510.255 349.333s7.107-3.18 7.76-3.772c.786-.497 1.941-1.652 2.683-2.462.784-.786 3.768-2.31 4.27-3.336.351-.632 2.16-3.182 3.248-5.207.57-1.072-4.705.284-4.705.284-4.34 1.719-2.312.497-4.71 2.31-1.439 1.067-2.398 2.026-2.747 2.813-.567 1.217-1.22 3.465-1.874 4.554-.567 1.155-1.657 2.595-3.903 4.772z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M506.418 350.21s5.777-1.508 8.48-5.146c1.876-2.467 1.941-1.724 2.748-2.528.937-1.071 2.463-2.25 3.77-4.342-.13.195 1.594-5.798 1.594-6.451-.068-.413-2.247.284-4.057 1.004-1.504.653-2.376 1.875-3.683 2.679-1.592 1.004-1.723 3.555-2.464 4.71-1.003 1.72-1.155 2.595-1.155 3.466 0 1.284-.72 1.724-1.156 2.812-.501 1.284-2.028 1.066-4.055 3.773",
    fill: "#090"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M506.418 350.21s5.777-1.508 8.48-5.146c1.876-2.467 1.941-1.724 2.748-2.528.937-1.071 2.463-2.25 3.77-4.342-.13.195 1.594-5.798 1.594-6.451-.068-.413-2.247.284-4.057 1.004-1.504.653-2.376 1.875-3.683 2.679-1.592 1.004-1.723 3.555-2.464 4.71-1.003 1.72-1.155 2.595-1.155 3.466 0 1.284-.72 1.724-1.156 2.812-.501 1.284-2.028 1.066-4.055 3.773z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1.003-.57 2.03-.848.848-.2 1.59-.854 3.682-.419.849.2 4.489 1.004 5.426.57.853-.413-1.306 2.46-2.395 3.12-1.003.563-2.745.847-4.208.713-1.506-.127-3.554 0-4.273 0-.72 0-1.22.135-2.246-.127-1.003-.286-1.285-.787-3.771-.57",
    fill: "#090"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M515.77 348.312s4.993-2.25 5.712-2.4c.719-.128 1.003-.57 2.03-.848.848-.2 1.59-.854 3.682-.419.849.2 4.489 1.004 5.426.57.853-.413-1.306 2.46-2.395 3.12-1.003.563-2.745.847-4.208.713-1.506-.127-3.554 0-4.273 0-.72 0-1.22.135-2.246-.127-1.003-.286-1.285-.787-3.771-.57z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M512.37 348.312s5.58-1.44 6.518-1.44c.938 0 3.619.195 4.624.413 1.066.134 4.403-.195 5.424.285 1.005.502 5.43 1.065 6.586.78 1.155-.194-2.311 3.187-3.773 3.556-4.492 1.29-3.114 1.072-6.016.351-1.808-.418-4.338-.569-5.21-.72-.873-.133-.72-.63-1.875-1.155-1.22-.502-3.182-1.808-6.3-2.093",
    fill: "#090"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M512.37 348.312s5.58-1.44 6.518-1.44c.938 0 3.619.195 4.624.413 1.066.134 4.403-.195 5.424.285 1.005.502 5.43 1.065 6.586.78 1.155-.194-2.311 3.187-3.773 3.556-4.492 1.29-3.114 1.072-6.016.351-1.808-.418-4.338-.569-5.21-.72-.873-.133-.72-.63-1.875-1.155-1.22-.502-3.182-1.808-6.3-2.093z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M507.792 350.645s5.581-2.31 9.92-1.155c3.029.847 2.963.72 4.12.937 1.35.194 2.528-.502 4.839.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.85-10.791.063-1.876-.715-2.966-1.218-3.903-1.502-.937-.35-1.439-1.222-2.005-1.59-.567-.503-.938-1.59-4.273-2.528",
    fill: "#090"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M507.792 350.645s5.581-2.31 9.92-1.155c3.029.847 2.963.72 4.12.937 1.35.194 2.528-.502 4.839.435 1.155.413 6.016 2.372 7.327 2.31 1.217-.066-3.84 3.249-5.212 3.03-4.493-.636-8.764.85-10.791.063-1.876-.715-2.966-1.218-3.903-1.502-.937-.35-1.439-1.222-2.005-1.59-.567-.503-.938-1.59-4.273-2.528z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M537.614 337.781s3.249-3.555 3.834-3.99c.637-.503 2.16-1.59 2.97-2.31.563-.57 1.283-1.876 3.331-2.378.937-.194 3.12-.63 3.69-1.373.63-.782-.069 2.813-.788 3.773-.652 1.004-2.092 2.026-3.466 2.528-1.373.502-3.185 1.507-3.839 1.808-.63.284-.938.636-2.026.787-1.066.195-1.506-.067-3.683 1.155",
    fill: "#090"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M537.614 337.781s3.249-3.555 3.834-3.99c.637-.503 2.16-1.59 2.97-2.31.563-.57 1.283-1.876 3.331-2.378.937-.194 3.12-.63 3.69-1.373.63-.782-.069 2.813-.788 3.773-.652 1.004-2.092 2.026-3.466 2.528-1.373.502-3.185 1.507-3.839 1.808-.63.284-.938.636-2.026.787-1.066.195-1.506-.067-3.683 1.155z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M534.584 339.242s5.492-3.838 6.301-4.207c.848-.413 2.4-.937 3.398-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.622-3.549 3.114-1.066 2.153-4.051 2.746-1.725.346-4.12 1.372-4.928 1.59-.938.285-1.005-.285-2.243-.195-1.29.067-3.622-.195-6.586.787",
    fill: "#090"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M534.584 339.242s5.492-3.838 6.301-4.207c.848-.413 2.4-.937 3.398-1.289 1.072-.28 3.84-2.243 4.928-2.243 1.072 0 3.181-.129 4.12-.787.853-.782.065 2.595-.939 3.622-3.549 3.114-1.066 2.153-4.051 2.746-1.725.346-4.12 1.372-4.928 1.59-.938.285-1.005-.285-2.243-.195-1.29.067-3.622-.195-6.586.787z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M533.256 340.265s2.243-1.44 6.669-2.155c3.03-.568 2.963-.72 4.057-1.004 1.374-.413 1.652-.413 4.119-.502 1.221-.13 6.083 1.44 7.238.787 1-.57-1.223 1.433-2.528 1.936-1.943.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25",
    fill: "#090"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M533.256 340.265s2.243-1.44 6.669-2.155c3.03-.568 2.963-.72 4.057-1.004 1.374-.413 1.652-.413 4.119-.502 1.221-.13 6.083 1.44 7.238.787 1-.57-1.223 1.433-2.528 1.936-1.943.72-1.724 1.942-3.84 2.684-2.22.72-4.553 1.59-5.926 1.284-.938-.129-1.814-.63-3.187-.781-1.373-.135-3.834-2.16-6.58-2.25z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M532.82 339.176s-1.071-5.363-.133-6.585c.351-.564 1.004-1.44 1.155-2.813.134-1.283 1.005-3.466 1.59-4.208.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989-.128 1.875-.128 1.44 0 2.317.134.847-.715 3.833-1.284 4.705-.63.853-.284 3.554-.938 4.056-.569.63-4.056 2.964-4.776 2.528",
    fill: "#090"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M532.82 339.176s-1.071-5.363-.133-6.585c.351-.564 1.004-1.44 1.155-2.813.134-1.283 1.005-3.466 1.59-4.208.57-.714 1.814-4.119 1.44-4.989 0 0 3.12 3.03 2.964 4.989-.128 1.875-.128 1.44 0 2.317.134.847-.715 3.833-1.284 4.705-.63.853-.284 3.554-.938 4.056-.569.63-4.056 2.964-4.776 2.528z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M533.256 340.265c-.285.195 1.875-1.658 2.897-2.094 1.071-.412 5.145-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492.068-.631.659-2.026.57-2.746-.128-.72-.413-2.466-.848-3.465-.42-1.071-1.508-3.556-2.535-3.99 0 0-.847 2.745-1.155 3.772-.278 1.066-.563 2.243-.998 2.813-.413.564-1.875 3.332-2.094 4.426-.066.998-.786 4.424-1.003 5.078-.068.72-2.813 3.772-4.053 4.336",
    fill: "#090"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M533.256 340.265c-.285.195 1.875-1.658 2.897-2.094 1.071-.412 5.145-1.59 5.43-2.594.284-1.066 3.682-4.555 3.833-5.492.068-.631.659-2.026.57-2.746-.128-.72-.413-2.466-.848-3.465-.42-1.071-1.508-3.556-2.535-3.99 0 0-.847 2.745-1.155 3.772-.278 1.066-.563 2.243-.998 2.813-.413.564-1.875 3.332-2.094 4.426-.066.998-.786 4.424-1.003 5.078-.068.72-2.813 3.772-4.053 4.336z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.596-2.812.497-.278 2.087-2.896 2.528-4.335.435-1.502 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847-2.59 1.726-2.745 1.29-3.331 1.598-.57.279-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705",
    fill: "#090"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81c-.194.787 2.16-.714 3.338-.714 1.217 0 4.705.413 5.58-.42.848-.847 2.155-2.526 2.596-2.812.497-.278 2.087-2.896 2.528-4.335.435-1.502 3.549-4.12 3.9-4.426 0 0-4.208-.848-6.892.847-2.59 1.726-2.745 1.29-3.331 1.598-.57.279-5.146 4.118-5.43 5.58-.285 1.434-2.244 3.984-2.311 4.705z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.896 5.273-4.772.134-1.003 2.094-2.466 2.534-3.119 1-1.74 1.59-5.708 3.03-6.736 0 0-3.99 1.004-4.994 1.155-1.875.285-3.466.57-4.276 2.25-.63 1.59-1.283 2.896-1.875 3.03-.563.128-1.434 2.154-1.719 4.269-.284 2.026-2.595 6.452-2.595 6.452",
    fill: "#090"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M551.326 325.81s3.773-2.678 4.622-2.528c.937.134 5.056-2.896 5.273-4.772.134-1.003 2.094-2.466 2.534-3.119 1-1.72 1.59-5.708 3.03-6.736 0 0-3.99 1.004-4.994 1.155-1.875.285-3.466.57-4.276 2.25-.63 1.59-1.283 2.896-1.875 3.03-.563.128-1.434 2.154-1.74 4.269-.285 2.026-2.596 6.452-2.596 6.452z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M558.52 305.798c-.63 1.005-.57-5.86-.938-6.515-.284-.72-1.004-2.246-1.59-2.812-.57-.567-.57-2.594-.848-3.183-.285-.567-.134-4.557.279-5.582 0 0 1.155.85 1.814 1.592.563.72 1.59 1.004 1.875 1.876.279.85.87.85 1.283 1.808.435.851.848 2.311.57 3.468-.285 1.154-.135 1.59-.135 2.68 0 1.004-1.44 5.362-2.31 6.668",
    fill: "#090"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M558.52 305.798c-.63 1.005-.57-5.86-.938-6.515-.284-.72-1.004-2.246-1.59-2.812-.57-.567-.57-2.594-.848-3.183-.285-.567-.134-4.557.279-5.582 0 0 1.155.85 1.814 1.592.563.72 1.59 1.004 1.875 1.876.279.85.87.85 1.283 1.808.435.851.848 2.311.57 3.468-.285 1.154-.135 1.59-.135 2.68 0 1.004-1.44 5.362-2.31 6.668",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1.003-.502-1.59-.285-.568-.938-1.593-1.005-2.093-.28-1.592-1.155-3.337-.413-5.058 0 0 1.657.501 2.026.85.42.283 1.813 1.44 1.942 2.593.134 1.286.284 1.505.72 2.246.413.72 1.004 2.9.284 4.207a8.241 8.241 0 0 0-.853 2.683",
    fill: "#090"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M558.369 306.456s.285-1.941-.418-2.683c-.714-.719-1.434-.719-1.719-1.155-.284-.414-.195-1.003-.502-1.59-.285-.568-.938-1.593-1.005-2.093-.28-1.592-1.155-3.337-.413-5.058 0 0 1.657.501 2.026.85.42.283 1.813 1.44 1.942 2.593.134 1.286.284 1.505.72 2.246.413.72 1.004 2.9.284 4.207a8.241 8.241 0 0 0-.853 2.683z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145 0 0 .195 1.068 0 1.81-.067.632-.345 2.747 0 3.466.503.72 1.943 2.027 1.943 2.681 0 .566.998 2.028 1.718 2.31.721.283 1.29.415 1.29.415",
    fill: "#090"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 283.958s.28-4.274-.786-5.581c-1.223-1.286-1.507-3.771-4.209-5.145 0 0 .195 1.068 0 1.81-.067.632-.345 2.747 0 3.466.503.72 1.943 2.027 1.943 2.681 0 .566.998 2.028 1.718 2.31.721.283 1.29.415 1.29.415z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 286.268s0-3.03-.786-3.902c-.938-.85-1.351-1.374-1.787-1.874-.435-.567-.877-2.094-1.875-2.682-1.072-.567-2.812-2.093-2.968-2.594 0 0-.413 3.619.569 5.58 1.004 1.875 1.004 2.9 2.243 3.336 1.155.414 1.29.72 1.747 1.003.413.348 1.155.719 1.724.719.564 0 1.155.415 1.155.415",
    fill: "#090"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 286.268s0-3.03-.786-3.902c-.938-.85-1.351-1.374-1.787-1.874-.435-.567-.877-2.094-1.875-2.682-1.072-.567-2.812-2.093-2.968-2.594 0 0-.413 3.619.569 5.58 1.004 1.875 1.004 2.9 2.243 3.336 1.155.414 1.29.72 1.747 1.003.413.348 1.155.719 1.724.719.564 0 1.155.415 1.155.415z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M559.24 306.3c-.128.855-.72-1.875 2.31-1.875 3.12 0 5.581-1.218 6.585-2.243 1.066-1.003 1.658-1.722 2.093-2.245.413-.35 1.568-2.159 1.72-3.03.133-.85 1.004-4.12.853-4.71 0 0-1.59.284-2.31.85-.721.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.725 2.027-.413.414-1.718.414-2.31 1.286-.57.873-1.657 2.812-1.808 3.684-.067.85-1.155 1.722-1.875 2.159-.72.414-.57 2.156-.72 2.966",
    fill: "#090"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M559.24 306.3c-.128.855-.72-1.875 2.31-1.875 3.12 0 5.581-1.218 6.585-2.243 1.066-1.003 1.658-1.722 2.093-2.245.413-.35 1.568-2.159 1.72-3.03.133-.85 1.004-4.12.853-4.71 0 0-1.59.284-2.31.85-.721.634-2.093.634-2.813 1.07-.72.413-1.312 1.59-1.747 2.027-.413.414-1.718.414-2.31 1.286-.564.873-1.658 2.812-1.809 3.684-.066.85-1.154 1.722-1.874 2.159-.721.414-.57 2.156-.721 2.966z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.68 3.834-3.77.134-1.222 1.004-3.4 1.59-3.838.637-.414 1.658-1.439 1.508-3.248-.196-1.722-.196-4.621-.196-4.621s-.57 1.722-1.44 2.157c-.847.414-2.46 1.004-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159-.284.566-1 1.286-1.284 2.462-.285 1.221-1.875 4.273-1.59 7.236",
    fill: "#090"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M559.525 305.145s2.026-2.527 3.03-2.527c1.066 0 3.683-2.68 3.834-3.77.134-1.222 1.004-3.4 1.59-3.838.637-.414 1.658-1.439 1.508-3.248-.196-1.722-.196-4.621-.196-4.621s-.57 1.722-1.44 2.157c-.847.414-2.46 1.004-2.746 1.592-.285.567-1.44.567-1.964 2.376-.346 1.722-.346 1.592-.72 2.159-.284.566-1 1.286-1.284 2.462-.285 1.221-1.875 4.273-1.59 7.236z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 288.884c.061.785-1.155-1.504 1.59-2.377 2.813-.85 4.772-2.593 5.425-3.836.636-1.155.938-2.026 1.222-2.528.285-.502.854-2.465.72-3.249-.067-.85-.195-4.054-.502-4.556 0 0-1.373.719-1.875 1.439-.502.785-1.658 1.155-2.243 1.722-.503.567-.72 1.81-1.006 2.376-.278.502-1.44.85-1.718 1.81-.285.937-.72 2.965-.569 3.837.066.785-.564 1.875-1.155 2.528-.503.567.133 2.093.133 2.813",
    fill: "#090"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 288.884c.061.785-1.155-1.504 1.59-2.377 2.813-.85 4.772-2.593 5.425-3.836.636-1.155.938-2.026 1.222-2.528.285-.502.854-2.465.72-3.249-.067-.85-.195-4.054-.502-4.556 0 0-1.373.719-1.875 1.439-.502.785-1.658 1.155-2.243 1.722-.503.567-.72 1.81-1.006 2.376-.278.502-1.44.85-1.718 1.81-.285.937-.72 2.965-.569 3.837.066.785-.564 1.875-1.155 2.528-.503.567.133 2.093.133 2.813z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 287.729s1.155-2.812 2.093-3.117c.938-.283 2.461-2.681 2.529-3.771.06-1.222.284-3.401.72-3.903.345-.567 1.155-2.377.562-3.903-.63-1.59-1.59-3.684-1.59-3.684s-.938 1.374-1.283 2.159c-.787 1.504-1.508 1.592-1.657 2.158-.069.633-1.072 1.003-1.374 2.224-.419 1.656.061 1.59-.066 2.245-.068.567-.57 1.44-.503 2.593.067 1.157-.564 4.34.569 6.956",
    fill: "#090"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M562.577 287.729s1.155-2.812 2.093-3.117c.938-.283 2.461-2.681 2.529-3.771.06-1.222.284-3.401.72-3.903.345-.567 1.155-2.377.562-3.903-.63-1.59-1.59-3.684-1.59-3.684s-.938 1.374-1.283 2.159c-.787 1.504-1.508 1.592-1.657 2.158-.069.633-1.072 1.003-1.374 2.224-.419 1.656.061 1.59-.066 2.245-.068.567-.57 1.44-.503 2.593.067 1.157-.564 4.34.569 6.956z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-.998-.284-2.657-2.594-3.331-3.183-.72-.633-1.072-1.504-1.942-2.028-.849-.501-1.507-2.31-1.724-4.119 0 0 2.466.565 3.185.721.721.128 2.155 1.066 2.814 1.719.563.72 1.155 1.941 1.718 2.225.57.283 1.29 2.027 1.29 3.247v2.596",
    fill: "#090"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M560.267 270.028c-.134-.415-1.005-.851-2.032-1.221-.998-.284-2.657-2.594-3.331-3.183-.72-.633-1.072-1.504-1.942-2.028-.849-.501-1.507-2.31-1.748-4.119 0 0 2.468.565 3.188.721.72.128 2.153 1.066 2.812 1.719.564.72 1.155 1.941 1.719 2.225.57.283 1.29 2.027 1.29 3.247v2.596z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M560.395 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.146-.854-1.282-4.124-3.771-4.994-3.9 0 0-.57 2.31-.413 3.03.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556",
    fill: "#090"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M560.395 268.719s.128-1.722.128-2.528c0-.85.57-3.248-.714-5.146-.854-1.282-4.124-3.771-4.994-3.9 0 0-.57 2.31-.413 3.03.127.72.937 3.683 1.59 3.988.72.283 2.377 3.772 4.425 4.556z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M561.137 270.028c.346.632.129-2.225 1-2.9.937-.785 1.003-1.81 1.003-2.965 0-1.22-.283-2.03-.345-2.81-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.808-1.59 3.616-.413 1.005.284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.402",
    fill: "#090"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M561.137 270.028c.346.632.129-2.225 1-2.9.937-.785 1.003-1.81 1.003-2.965 0-1.22-.283-2.03-.345-2.81-.195-.72-2.377-3.773-2.25-4.621 0 0-1.216 2.808-1.59 3.616-.413 1.005.284 2.093.134 2.963-.134.852-.854 2.465-.284 3.337.434.785 1.718 2.377 2.31 3.402z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.834-.714-.568-.569-1.59-1.288-2.159-1.595-.564-.28-1.658-1.591-1.72-2.244-.2-.564-1.221-1.72-1.657-1.72 0 0 1.657-.133 3.4.348 1.723.345 4.208 1.283 4.776 2.46.63 1.156 2.68 3.907 2.68 3.907",
    fill: "#090"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M553.352 254.857s-.128-.442-1.44-.442c-1.283 0-3.248-.061-3.834-.714-.568-.569-1.59-1.288-2.159-1.595-.564-.28-1.658-1.591-1.741-2.244-.196-.564-1.223-1.72-1.658-1.72 0 0 1.658-.133 3.399.348 1.724.345 4.208 1.283 4.777 2.46.63 1.156 2.679 3.907 2.679 3.907z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M552.917 254.572c-.345 1.005-2.813-1.004-3.4-1.724-.567-.72-1.439-1.875-1.439-1.875s-1.44-1.658-1.724-2.372c-.848-1.596-.631-4.493-.28-4.275.414.284 2.027 1.222 2.463 1.374.413.126 1.282.412 1.59 1.132.285.72.57 1.724 1.071 2.243.413.442 3.03 1.875 1.742 5.497",
    fill: "#090"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M552.917 254.572c-.345 1.005-2.813-1.004-3.4-1.724-.567-.72-1.439-1.875-1.439-1.875s-1.44-1.658-1.724-2.372c-.848-1.596-.631-4.493-.28-4.275.414.284 2.027 1.222 2.463 1.374.413.126 1.282.412 1.59 1.132.285.72.57 1.724 1.071 2.243.413.442 3.03 1.875 1.742 5.497z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M553.787 254.572s-2.093-1.44-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.154-2.812.284-.848.853-3.331.853-3.331s1.065.936 1.808 1.718c.72.72.848 1.289 1.155 2.182.285.937.848 1.501 1.155 2.243.285.72 0 2.16-.134 3.03-.128.854 0 1.724 0 1.724",
    fill: "#090"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M553.787 254.572s-2.093-1.44-2.745-2.16c-.938-.847-.413-2.026-.938-2.595-.346-.564-1.44-1.936-1.154-2.812.284-.848.853-3.331.853-3.331s1.065.936 1.808 1.718c.72.72.848 1.289 1.155 2.182.285.937.848 1.501 1.155 2.243.285.72 0 2.16-.134 3.03-.128.854 0 1.724 0 1.724",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M530.878 337.278c-.502 0-.848-.345-.848-.847 0-.503.346-.854.848-.854s.85.35.85.853-.347.848-.85.848",
    fill: "#e60000"
  })), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M530.878 337.278c-.502 0-.848-.345-.848-.847 0-.503.346-.854.848-.854s.85.35.85.853-.347.848-.85.848",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    d: "M535.867 343.45c-.496 0-.847-.35-.847-.853 0-.413.35-.848.847-.848.442 0 .877.413.877.847 0 .503-.413.855-.877.855",
    fill: "#e60000"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M535.867 343.45c-.496 0-.847-.35-.847-.853 0-.413.35-.848.847-.848.442 0 .877.413.877.847 0 .503-.413.855-.877.855",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M547.492 324.091c-.502 0-.937-.413-.937-.853 0-.497.413-.848.937-.848.413 0 .849.35.849.847 0 .419-.413.854-.848.854",
    fill: "#e60000"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    d: "M547.492 324.091c-.502 0-.937-.413-.937-.853 0-.497.413-.848.937-.848.413 0 .849.35.849.847 0 .419-.413.854-.848.854",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M554.664 327.708c-.57 0-1.005-.414-1.005-1 0-.502.413-.936 1.004-.936.497 0 .938.412.938.937 0 .564-.419.999-.937.999",
    fill: "#e60000"
  })), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M554.664 327.708c-.57 0-1.005-.414-1.005-1 0-.502.413-.936 1.004-.936.497 0 .938.412.938.937 0 .564-.419.999-.937.999",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    d: "M555.97 305.932c-.502 0-1.004-.413-1.004-.938 0-.502.502-1.002 1.003-1.002.503 0 .938.5.938 1.003a.943.943 0 0 1-.938.937",
    fill: "#e60000"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M555.97 305.932c-.502 0-1.004-.413-1.004-.938 0-.502.502-1.002 1.003-1.002.503 0 .938.5.938 1.003a.943.943 0 0 1-.938.937",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M561.986 307.762c-.564 0-.937-.413-.937-1.004 0-.497.35-.938.937-.938.502 0 .937.419.937.938 0 .569-.412 1.003-.937 1.003",
    fill: "#e60000"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    d: "M561.986 307.762c-.564 0-.937-.413-.937-1.004 0-.497.35-.938.937-.938.502 0 .937.419.937.938 0 .569-.412 1.003-.937 1.003",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M558.933 288.383c-.564 0-.999-.501-.999-1.003 0-.501.413-.937.999-.937.502 0 .938.414.938.937 0 .502-.413 1.003-.938 1.003",
    fill: "#e60000"
  })), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M558.933 288.383c-.564 0-.999-.501-.999-1.003 0-.501.413-.937.999-.937.502 0 .938.414.938.937 0 .502-.413 1.003-.938 1.003",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    d: "M564.319 270.53c-.503 0-.938-.35-.938-.851 0-.567.413-1.004.938-1.004.569 0 1.003.415 1.003 1.003 0 .502-.434.851-1.003.851",
    fill: "#e60000"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M564.319 270.53c-.503 0-.938-.35-.938-.851 0-.567.413-1.004.938-1.004.569 0 1.003.415 1.003 1.003 0 .502-.434.851-1.003.851",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M557.431 272.337c-.501 0-.937-.413-.937-1.001 0-.502.413-.938.937-.938.564 0 1 .415 1 .938 0 .566-.413 1.002-1 1.002",
    fill: "#e60000"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M557.431 272.337c-.501 0-.937-.413-.937-1.001 0-.502.413-.938.937-.938.564 0 1 .415 1 .938 0 .566-.413 1.002-1 1.002",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M550.673 257.469c-.502 0-1.003-.436-1.003-.938 0-.496.501-.938 1.003-.938.502 0 .938.42.938.938a.943.943 0 0 1-.937.938",
    fill: "#e60000"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M550.673 257.469c-.502 0-1.003-.436-1.003-.938 0-.496.501-.938 1.003-.938.502 0 .938.42.938.938a.943.943 0 0 1-.937.938",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M555.82 253.417c-.57 0-.939-.413-.939-1.004 0-.503.346-.939.938-.939.502 0 .937.436.937.939 0 .569-.418 1.004-.937 1.004",
    fill: "#e60000"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M555.82 253.417c-.57 0-.939-.413-.939-1.004 0-.503.346-.939.938-.939.502 0 .937.436.937.939 0 .569-.418 1.004-.937 1.004",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M545.528 243.41a.959.959 0 0 1-.938-.937c0-.569.413-1.004.938-1.004.502 0 1.005.413 1.005 1.003 0 .503-.503.938-1.005.938",
    fill: "#e60000"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M545.528 243.41a.959.959 0 0 1-.938-.937c0-.569.413-1.004.938-1.004.502 0 1.005.413 1.005 1.003 0 .503-.503.938-1.005.938",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 288.449c-.502 0-.937-.35-.937-.85 0-.502.413-.939.938-.939a.945.945 0 0 1 .937.938c0 .502-.413.85-.937.85",
    fill: "#e60000"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M566.5 288.449c-.502 0-.937-.35-.937-.85 0-.502.413-.939.938-.939a.945.945 0 0 1 .937.938c0 .502-.413.85-.937.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M530.008 340.918s.72-3.03.564-3.768c0 0-.285 0-.721-.569m1.312 5.559s2.813.067 3.683.35c0 0 0 .196.285.783m13.076-15.13s.134-3.684-.564-3.985c0 0-.72-.284-1.155-.876m4.554 3.705s2.032-.278 2.596 0c0 0 .128.57.568.721m.737-22.279.72.352c.787.346 2.25 3.834 2.25 3.834s2.31-1.724 3.33-1.875h1.005m4.755-19.641s-.569.567-1.155.283c0 0-2.969 1.876-3.03 2.595 0 0-3.12-3.03-3.69-2.748 0 0-.279.415-.847-.13m5.514-18.072s-.347.436-.938.72c0 0-1.284 1.875-1.284 3.335 0 0-2.46-2.158-3.18-2.027 0 0-.855.283-1.44 0m-.397-18.945s-.564.72-1 .134c0 0-1.746 2.154-.72 3.834 0 0-2.466-.564-3.18-.129 0 0-.285 1-1.223.413m-4.117-14.761s.434 1.005-1.29.636",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M521.373 347.068s9.634-.068 10.572-1.284m-16.174 2.528s6.3 1.72 9.633 1.284c3.404-.413 4.994.284 5.714.284.788 0 4.426-1.507 4.426-1.507m-26.225 2.272s4.838.847 5.863 1.155c1.004.279 6.017 2.153 7.455 2.153 1.154 0 4.056-.06 4.842 0 1.435.286 5.274 0 6.145-.412m-5.95-14.515s-3.681 2.153-4.274 2.896c-.564.787-3.836 3.404-4.425 3.404m8.7-10.882s-6.302 5.43-7.392 6.15c-1.003.78-7.172 6.736-7.89 7.695m10.135-16.156s-4.991 3.99-5.581 5.582c-.566 1.59-2.026 3.465-2.026 3.465s-2.093 4.124-2.812 4.71c-.72.569-2.16 2.182-3.903 3.248m42.836-20.711s-5.296 4.426-6.736 5.274m8.918-2.438s-5.274 3.616-7.607 4.553c-2.4.787-4.274 1.597-9.42 2.31m-2.07 2.054s5.865-.284 6.887 0c1.004.28 5.58-.72 6.735-1.004 1.156-.284 5.865-1.156 6.457-1.289m-11.078-17.502s.285 3.182-.195 4.555c-.413 1.288-2.461 5.056-2.31 6.016.128.853-1.156 4.837-2.311 5.58m-1.289-15.587s1.072 3.187.569 4.275c-.346 1.004-1.155 2.896-1.155 4.119 0 1.155-.72 2.902-1.004 3.622-.28.72.134 3.248-.565 3.9-.719.787-1.59 2.094-1.59 2.094m35.181-25.465s-4.62 1.724-5.273 2.901c-.57 1.155-1.373 1.501-1.875 2.093m-10.136-9.42s-1.155 4.71-.853 5.865c.284 1.156.284 3.556.284 4.426 0 .854 1.29 4.425 1.072 4.994m1.395-19.208s.413 2.745.564 3.906c.128 1.156 0 3.115.284 3.835.285.72.72 4.62 0 6.45m12.077-10.267s-3.84 3.247-4.71 4.123c-.848.848-4.771 5.056-4.99 6.144-.067 1.005-2.901 4.209-3.771 4.995m19.922-31.676s-3.772 3.771-4.119 4.621c-.284.939-1.874 2.311-2.594 2.813m-11.207-5.82s1.44 2.157 1.44 2.9c0 .718.57 2.68 1.223 3.4.346.5 1.59 2.595 1.44 3.9m-2.947-16.37s.569 2.027.854 3.467c.346 1.439.999 2.964 1.373 3.836.278.85 1.434 5.145.998 7.762m10.119-15.217s-.352 2.026-1.44 3.03c-1.005 1.003-2.595 2.529-2.746 3.335-.135.937-1.44 5.275-2.964 6.802-1.44 1.439-1.595 2.964-1.595 2.964m10.267-31.085s-.501 2.462-.72 3.181c-.278.72-1.522 3.99-2.679 4.993m-9.218-7.52s.72 2.026.848 2.964c.128.85 1.005 1.875 1.155 2.31.128.414.721 1.941.721 1.941m-5.409-5.188c.135.937 1.725 3.552 1.943 3.989.067.501.998 2.529 1.875 3.117.87.567 3.465 2.463 3.332 3.249m4.32-16.002s.128 3.183-.414 4.338c-.569 1.221-1.289 2.966-1.597 3.836-.278.852-.278 2.312-.412 3.337-.128 1.068-.565 2.965-1.155 3.683m-11.53-25.202s2.092 2.377 3.03 3.404c1 .936 4.705 4.991 4.84 5.71m-4.382-11.29s2.093 4.487 2.529 5.206c.413.787.847 1.942.847 1.942m1.92-7.305s-.129 3.555 0 4.425c.128.787.128 2.314 0 2.75-.129.414.435 3.618.569 4.425m-17.552-20.73s4.622 2.812 5.364 3.55m-2.662-7.194 3.248 4.627.72 1.372m-.279-6.435s1.066 2.467 1.217 3.466c.133 1.072 1.59 4.275 2.16 5.43",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M472.454 337.278c.502 0 .851-.345.851-.847 0-.503-.349-.854-.85-.854-.415 0-.85.35-.85.853a.85.85 0 0 0 .85.848",
    fill: "#e60000"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M472.454 337.278c.502 0 .851-.345.851-.847 0-.503-.349-.854-.85-.854-.415 0-.85.35-.85.853a.85.85 0 0 0 .85.848",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M467.463 343.45c.5 0 .937-.35.937-.853 0-.413-.415-.848-.937-.848-.415 0-.85.413-.85.847 0 .503.414.855.85.855",
    fill: "#e60000"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M467.463 343.45c.5 0 .937-.35.937-.853 0-.413-.415-.848-.937-.848-.415 0-.85.413-.85.847 0 .503.414.855.85.855",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M455.908 324.091c.437 0 .85-.413.85-.853a.852.852 0 0 0-.85-.848c-.501 0-.937.35-.937.847 0 .419.414.854.937.854",
    fill: "#e60000"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M455.908 324.091c.437 0 .85-.413.85-.853a.852.852 0 0 0-.85-.848c-.501 0-.937.35-.937.847 0 .419.414.854.937.854",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M448.737 327.708c.5 0 .937-.414.937-1a.959.959 0 0 0-.937-.936c-.567 0-1.004.412-1.004.937 0 .564.437.999 1.004.999",
    fill: "#e60000"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M448.737 327.708c.5 0 .937-.414.937-1a.959.959 0 0 0-.937-.936c-.567 0-1.004.412-1.004.937 0 .564.437.999 1.004.999",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M447.428 305.932a.944.944 0 0 0 .937-.938c0-.502-.413-1.002-.937-1.002-.567 0-1.003.5-1.003 1.003 0 .502.415.937 1.003.937",
    fill: "#e60000"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M447.428 305.932a.944.944 0 0 0 .937-.938c0-.502-.413-1.002-.937-1.002-.567 0-1.003.5-1.003 1.003 0 .502.415.937 1.003.937",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M441.346 307.762c.567 0 1.004-.413 1.004-1.004 0-.497-.416-.938-1.004-.938a.947.947 0 0 0-.938.938c0 .569.415 1.003.938 1.003",
    fill: "#e60000"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M441.346 307.762c.567 0 1.004-.413 1.004-1.004 0-.497-.416-.938-1.004-.938a.947.947 0 0 0-.938.938c0 .569.415 1.003.938 1.003",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M444.464 288.383c.5 0 .937-.501.937-1.003a.945.945 0 0 0-.937-.937c-.567 0-1.004.414-1.004.937 0 .502.415 1.003 1.004 1.003",
    fill: "#e60000"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M444.464 288.383c.5 0 .937-.501.937-1.003a.945.945 0 0 0-.937-.937c-.567 0-1.004.414-1.004.937 0 .502.415 1.003 1.004 1.003",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M439.014 270.53c.5 0 1.003-.35 1.003-.851 0-.567-.503-1.004-1.003-1.004-.501 0-.938.415-.938 1.003 0 .502.414.851.938.851",
    fill: "#e60000"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M439.014 270.53c.5 0 1.003-.35 1.003-.851 0-.567-.503-1.004-1.003-1.004-.501 0-.938.415-.938 1.003 0 .502.414.851.938.851",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M445.902 272.337c.567 0 1.003-.413 1.003-1.001 0-.502-.415-.938-1.003-.938a.945.945 0 0 0-.937.938c0 .566.414 1.002.938 1.002",
    fill: "#e60000"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M445.902 272.337c.567 0 1.003-.413 1.003-1.001 0-.502-.415-.938-1.003-.938a.945.945 0 0 0-.937.938c0 .566.414 1.002.938 1.002",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M452.66 257.469c.502 0 1.004-.436 1.004-.938 0-.496-.502-.938-1.003-.938a.948.948 0 0 0-.938.938.96.96 0 0 0 .938.938",
    fill: "#e60000"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M452.66 257.469c.502 0 1.004-.436 1.004-.938 0-.496-.502-.938-1.003-.938a.948.948 0 0 0-.938.938.96.96 0 0 0 .938.938",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M447.494 253.417c.567 0 1.003-.413 1.003-1.004 0-.503-.415-.939-1.003-.939a.959.959 0 0 0-.938.939c0 .569.414 1.004.938 1.004",
    fill: "#e60000"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M447.494 253.417c.567 0 1.003-.413 1.003-1.004 0-.503-.415-.939-1.003-.939a.959.959 0 0 0-.938.939c0 .569.414 1.004.938 1.004",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M457.805 243.41c.567 0 .937-.435.937-.937 0-.569-.348-1.004-.937-1.004-.567 0-.937.413-.937 1.003 0 .503.349.938.937.938",
    fill: "#e60000"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M457.805 243.41c.567 0 .937-.435.937-.937 0-.569-.348-1.004-.937-1.004-.567 0-.937.413-.937 1.003 0 .503.349.938.937.938",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M436.833 288.449c.502 0 .938-.35.938-.85a.945.945 0 0 0-.938-.939.945.945 0 0 0-.937.938c0 .502.414.85.937.85",
    fill: "#e60000"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M436.833 288.449c.502 0 .938-.35.938-.85a.945.945 0 0 0-.938-.939.945.945 0 0 0-.937.938c0 .502.414.85.937.85",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M473.326 340.918s-.72-3.03-.567-3.768c0 0 .284 0 .72-.569m-1.308 5.559s-2.747.067-3.684.35c0 0 0 .196-.283.783m-13.08-15.13s-.131-3.684.566-3.985c0 0 .72-.284 1.156-.876m-4.469 3.705s-2.093-.278-2.68 0c0 0-.132.57-.569.721m-.763-22.279-.718.352c-.72.346-2.18 3.834-2.18 3.834s-2.377-1.724-3.4-1.875h-1.004m-4.731-19.641s.567.567 1.156.283c0 0 2.9 1.876 3.117 2.595 0 0 3.03-3.03 3.618-2.748 0 0 .349.415.938-.13m-5.559-18.072s.282.436.785.72c0 0 1.374 1.875 1.374 3.335 0 0 2.441-2.158 3.182-2.027 0 0 .937.283 1.504 0m.327-18.945s.567.72 1.003.134c0 0 1.744 2.154.72 3.834 0 0 2.464-.564 3.27-.129 0 0 .282 1 1.155.413m4.077-14.761s-.415 1.005 1.373.636",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M518.976 359.842s-3.772-.285-4.339-.285c-.567 0-1.962-2.595-2.528-3.03-.567-.413-10.509-5.274-17.048-6.301-6.453-.999-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.377-3.77-12.035-3.77-18.64 0-7.675.849-13.91 2.026-18.922 1.156-4.993 9.702-19.64 14.998-26.12 0 0-11.815 18.205-13.842 25.247-2.028 7.173-2.595 15.871-2.464 20.884.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.691 14.783 2.9 2.31 8.48 6.016 13.123 8.416 4.709 2.309 14.714 5.273 17.331 5.642 2.594.502 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144",
    fill: "#090"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M518.976 359.842s-3.772-.285-4.339-.285c-.567 0-1.962-2.595-2.528-3.03-.567-.413-10.509-5.274-17.048-6.301-6.453-.999-16.393-4.839-18.422-5.86-10.725-5.145-22.758-14.716-25.461-18.64-2.747-4.118-5.712-13.628-7.02-18.79-.567-2.377-3.77-12.035-3.77-18.64 0-7.675.849-13.91 2.026-18.922 1.156-4.993 9.702-19.64 14.998-26.12 0 0-11.815 18.205-13.842 25.247-2.028 7.173-2.595 15.871-2.464 20.884.065 4.12 3.554 19.142 8.48 30.17 3.99 8.85 7.456 9.855 13.691 14.783 2.9 2.31 8.48 6.016 13.123 8.416 4.709 2.309 14.714 5.273 17.331 5.642 2.594.502 16.023 4.425 17.767 5.28 1.809.87 6.3 4.837 7.455 6.144z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81c.283-1.373.349-2.371.85-2.745.415-.503 1.876-2.244 2.16-3.4.282-1.155 0-2.092 0-2.683 0-.564.413-2.59.413-2.59s-.72-2.467-1.286-2.969c-.566-.346-2.092-2.461-2.377-3.03 0 0 .197 1.155-.282 1.725-.437.563-.568 2.093-.568 2.962 0 .855.284 2.903 0 3.902-.282 1.155-.719 2.092-.414 3.404a890.76 890.76 0 0 0 1.505 5.425",
    fill: "#090"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81c.283-1.373.349-2.371.85-2.745.415-.503 1.876-2.244 2.16-3.4.282-1.155 0-2.092 0-2.683 0-.564.413-2.59.413-2.59s-.72-2.467-1.286-2.969c-.566-.346-2.092-2.461-2.377-3.03 0 0 .197 1.155-.282 1.725-.437.563-.568 2.093-.568 2.962 0 .855.284 2.903 0 3.902-.282 1.155-.719 2.092-.414 3.404a890.76 890.76 0 0 0 1.505 5.425",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M451.57 324.377s-3.335-4.276-3.335-6.084c0-1.724-.283-2.746-.567-3.186-.283-.413-2.18-2.68-.435-5.425.719-1.155.85-1.072 1.285-2.31.567-1.591 1.744-1.591 1.962-3.185 0 0 .349 1.873.501 3.468.131 1.592-.13 2.155-.194 3.026-.197.937.347 1.941.347 3.254 0 1.283-.13 1.808-.13 2.59 0 .418-.502 6.016.567 7.828",
    fill: "#090"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M451.57 324.377s-3.335-4.276-3.335-6.084c0-1.724-.283-2.746-.567-3.186-.283-.413-2.18-2.68-.435-5.425.719-1.155.85-1.072 1.285-2.31.567-1.591 1.744-1.591 1.962-3.185 0 0 .349 1.873.501 3.468.131 1.592-.13 2.155-.194 3.026-.197.937.347 1.941.347 3.254 0 1.283-.13 1.808-.13 2.59 0 .418-.502 6.016.567 7.828z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M489.219 347.285s-2.813-.284-3.903-.502c-.719-.062-2.462-.502-3.4-.848-.85-.286-2.53-1.156-3.99-2.685-2.66-2.896-2.377-4.425-2.9-4.554-.936-.128 1.505-.413 2.66-.195 1.156.129 2.747.937 3.838 1.941 1.068 1 2.747 2.155 3.4 2.59.567.42 1.003.637 1.591 1.44.633.854.567 1.373 2.681 2.813",
    fill: "#090"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M489.219 347.285s-2.813-.284-3.903-.502c-.719-.062-2.462-.502-3.4-.848-.85-.286-2.53-1.156-3.99-2.685-2.66-2.896-2.377-4.425-2.9-4.554-.936-.128 1.505-.413 2.66-.195 1.156.129 2.747.937 3.838 1.941 1.068 1 2.747 2.155 3.4 2.59.567.42 1.003.637 1.591 1.44.633.854.567 1.373 2.681 2.813z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M493.143 349.333s-7.107-3.18-7.827-3.772c-.785-.497-1.94-1.652-2.747-2.462-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.567-1.072 4.709.284 4.709.284 4.272 1.719 2.398.497 4.709 2.31 1.438 1.067 2.464 2.026 2.812 2.813.502 1.217 1.155 3.465 1.81 4.554.566 1.155 1.743 2.595 3.988 4.772",
    fill: "#090"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M493.143 349.333s-7.107-3.18-7.827-3.772c-.785-.497-1.94-1.652-2.747-2.462-.632-.786-3.684-2.31-4.206-3.336-.284-.632-2.159-3.182-3.271-5.207-.567-1.072 4.709.284 4.709.284 4.272 1.719 2.398.497 4.709 2.31 1.438 1.067 2.464 2.026 2.812 2.813.502 1.217 1.155 3.465 1.81 4.554.566 1.155 1.743 2.595 3.988 4.772z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M496.98 350.21s-5.866-1.508-8.546-5.146c-1.876-2.467-1.876-1.724-2.681-2.528-1.004-1.071-2.53-2.25-3.772-4.342.065.195-1.723-5.798-1.591-6.451 0-.413 2.158.284 3.989 1.004 1.505.653 2.377 1.875 3.685 2.679 1.568 1.004 1.787 3.555 2.528 4.71 1.004 1.72 1.068 2.595 1.068 3.466 0 1.284.72 1.724 1.155 2.812.502 1.284 2.093 1.066 4.121 3.773",
    fill: "#090"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M496.98 350.21s-5.866-1.508-8.546-5.146c-1.876-2.467-1.876-1.724-2.681-2.528-1.004-1.071-2.53-2.25-3.772-4.342.065.195-1.744-5.798-1.591-6.451 0-.413 2.158.284 3.989 1.004 1.505.653 2.377 1.875 3.685 2.679 1.568 1.004 1.787 3.555 2.528 4.71 1.004 1.72 1.068 2.595 1.068 3.466 0 1.284.72 1.724 1.155 2.812.502 1.284 2.093 1.066 4.121 3.773z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M487.562 348.312s-4.993-2.25-5.647-2.4c-.784-.128-1.067-.57-2.092-.848-.85-.2-1.57-.854-3.684-.419-.85.2-4.491 1.004-5.363.57-.938-.413 1.286 2.46 2.31 3.12 1.004.563 2.748.847 4.274.713 1.438-.127 3.465 0 4.207 0 .719 0 1.155.135 2.223-.127 1.003-.286 1.308-.787 3.772-.57",
    fill: "#090"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M487.562 348.312s-4.993-2.25-5.647-2.4c-.784-.128-1.067-.57-2.092-.848-.85-.2-1.57-.854-3.684-.419-.85.2-4.491 1.004-5.363.57-.938-.413 1.286 2.46 2.31 3.12 1.004.563 2.748.847 4.274.713 1.438-.127 3.465 0 4.207 0 .719 0 1.155.135 2.223-.127 1.003-.286 1.308-.787 3.772-.57z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M490.963 348.312s-5.582-1.44-6.518-1.44c-.938 0-3.554.195-4.71.413-1.002.134-4.338-.195-5.363.285-1.003.502-5.428 1.065-6.583.78-1.155-.194 2.377 3.187 3.771 3.556 4.491 1.29 3.118 1.072 6.083.351 1.743-.418 4.272-.569 5.145-.72.936-.133.72-.63 1.94-1.155 1.155-.502 3.117-1.808 6.235-2.093",
    fill: "#090"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M490.963 348.312s-5.582-1.44-6.518-1.44c-.938 0-3.554.195-4.71.413-1.002.134-4.338-.195-5.363.285-1.003.502-5.428 1.065-6.583.78-1.155-.194 2.377 3.187 3.771 3.556 4.491 1.29 3.118 1.072 6.083.351 1.743-.418 4.272-.569 5.145-.72.936-.133.72-.63 1.94-1.155 1.155-.502 3.117-1.808 6.235-2.093z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M495.54 350.645s-5.58-2.31-9.918-1.155c-3.03.847-2.9.72-4.12.937-1.374.194-2.53-.502-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.903 3.249 5.275 3.03 4.491-.636 8.7.85 10.726.063 1.875-.715 2.965-1.218 3.902-1.502.938-.35 1.44-1.222 2.028-1.59.567-.503.937-1.59 4.272-2.528",
    fill: "#090"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M495.54 350.645s-5.58-2.31-9.918-1.155c-3.03.847-2.9.72-4.12.937-1.374.194-2.53-.502-4.84.435-1.068.413-5.952 2.372-7.325 2.31-1.22-.066 3.903 3.249 5.275 3.03 4.491-.636 8.7.85 10.726.063 1.875-.715 2.965-1.218 3.902-1.502.938-.35 1.44-1.222 2.028-1.59.567-.503.937-1.59 4.272-2.528",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M465.718 337.781s-3.183-3.555-3.836-3.99c-.567-.503-2.093-1.59-2.9-2.31-.719-.57-1.374-1.876-3.466-2.378-.872-.194-3.03-.63-3.618-1.373-.568-.782.13 2.813.784 3.773.633 1.004 2.093 2.026 3.466 2.528 1.374.502 3.183 1.507 3.837 1.808.632.284 1.003.636 2.027.787 1.068.195 1.505-.067 3.685 1.155",
    fill: "#090"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M465.718 337.781s-3.183-3.555-3.836-3.99c-.567-.503-2.093-1.59-2.9-2.31-.719-.57-1.374-1.876-3.466-2.378-.872-.194-3.03-.63-3.618-1.373-.568-.782.13 2.813.784 3.773.633 1.004 2.093 2.026 3.466 2.528 1.374.502 3.183 1.507 3.837 1.808.632.284 1.003.636 2.027.787 1.068.195 1.505-.067 3.685 1.155z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M468.749 339.242s-5.428-3.838-6.301-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1.003-.782-.131 2.595.937 3.622 3.467 3.114 1.068 2.153 3.99 2.746 1.722.346 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195 1.22.067 3.618-.195 6.517.787",
    fill: "#090"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M468.749 339.242s-5.428-3.838-6.301-4.207c-.85-.413-2.376-.937-3.4-1.289-1.069-.28-3.838-2.243-4.927-2.243-1.069 0-3.118-.129-4.055-.787-1.003-.782-.131 2.595.937 3.622 3.467 3.114 1.068 2.153 3.99 2.746 1.722.346 4.12 1.372 4.992 1.59.85.285.937-.285 2.246-.195 1.22.067 3.618-.195 6.517.787z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M470.056 340.265s-2.244-1.44-6.67-2.155c-3.03-.568-2.899-.72-4.055-1.004-1.374-.413-1.657-.413-4.121-.502-1.22-.13-6.082 1.44-7.17.787-1.07-.57 1.154 1.433 2.527 1.936 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1.003-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25",
    fill: "#090"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M470.056 340.265s-2.244-1.44-6.67-2.155c-3.03-.568-2.899-.72-4.055-1.004-1.374-.413-1.657-.413-4.121-.502-1.22-.13-6.082 1.44-7.17.787-1.07-.57 1.154 1.433 2.527 1.936 1.875.72 1.657 1.942 3.772 2.684 2.245.72 4.621 1.59 5.93 1.284 1.003-.129 1.743-.63 3.182-.781 1.374-.135 3.837-2.16 6.584-2.25z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M470.514 339.176s1.156-5.363.197-6.585c-.502-.564-1.069-1.44-1.222-2.813-.065-1.283-1.003-3.466-1.59-4.208-.567-.714-1.723-4.119-1.44-4.989 0 0-3.117 3.03-2.898 4.989.065 1.875.065 1.44 0 2.317-.197.847.719 3.833 1.285 4.705.567.853.284 3.554.872 4.056.567.63 4.055 2.964 4.774 2.528",
    fill: "#090"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M470.514 339.176s1.156-5.363.197-6.585c-.502-.564-1.069-1.44-1.222-2.813-.065-1.283-1.003-3.466-1.59-4.208-.567-.714-1.744-4.119-1.44-4.989 0 0-3.117 3.03-2.898 4.989.065 1.875.065 1.44 0 2.317-.197.847.719 3.833 1.285 4.705.567.853.284 3.554.872 4.056.567.63 4.055 2.964 4.774 2.528z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M470.056 340.265c.349.195-1.874-1.658-2.9-2.094-1.002-.412-5.144-1.59-5.427-2.594-.283-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746.065-.72.349-2.466.85-3.465.415-1.071 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772.282 1.066.567 2.243 1.003 2.813.415.564 1.962 3.332 2.027 4.426.196.998.938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336",
    fill: "#090"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M470.056 340.265c.349.195-1.874-1.658-2.9-2.094-1.002-.412-5.144-1.59-5.427-2.594-.283-1.066-3.684-4.555-3.772-5.492-.13-.631-.784-2.026-.566-2.746.065-.72.349-2.466.85-3.465.415-1.071 1.438-3.556 2.442-3.99 0 0 .85 2.745 1.155 3.772.282 1.066.567 2.243 1.003 2.813.415.564 1.962 3.332 2.027 4.426.196.998.938 4.424 1.068 5.078.13.72 2.9 3.772 4.055 4.336z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81c.066.787-2.244-.714-3.4-.714-1.156 0-4.709.413-5.582-.42-.85-.847-2.156-2.526-2.68-2.812-.35-.278-2.028-2.896-2.463-4.335-.415-1.502-3.467-4.12-3.903-4.426 0 0 4.187-.848 6.89.847 2.593 1.726 2.746 1.29 3.334 1.598.633.279 5.145 4.118 5.43 5.58.281 1.434 2.157 3.984 2.374 4.705",
    fill: "#090"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81c.066.787-2.244-.714-3.4-.714-1.156 0-4.709.413-5.582-.42-.85-.847-2.156-2.526-2.68-2.812-.35-.278-2.028-2.896-2.463-4.335-.415-1.502-3.467-4.12-3.903-4.426 0 0 4.187-.848 6.89.847 2.593 1.726 2.746 1.29 3.334 1.598.633.279 5.145 4.118 5.43 5.58.281 1.434 2.157 3.984 2.374 4.705z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.896-5.276-4.772-.13-1.003-2.158-2.466-2.463-3.119-1.068-1.74-1.657-5.708-3.117-6.736 0 0 3.99 1.004 4.991 1.155 1.875.285 3.467.57 4.208 2.25.784 1.59 1.374 2.896 1.962 3.03.567.128 1.439 2.154 1.722 4.269.284 2.026 2.66 6.452 2.66 6.452",
    fill: "#090"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M452.071 325.81s-3.836-2.678-4.708-2.528c-.85.134-4.993-2.896-5.276-4.772-.13-1.003-2.158-2.466-2.463-3.119-1.068-1.72-1.657-5.708-3.117-6.736 0 0 3.99 1.004 4.991 1.155 1.875.285 3.467.57 4.208 2.25.784 1.59 1.374 2.896 1.962 3.03.567.128 1.439 2.154 1.722 4.269.284 2.026 2.66 6.452 2.66 6.452z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M444.9 305.798c.566 1.005.566-5.86.784-6.515.283-.72 1.068-2.246 1.657-2.812.567-.567.567-2.594.85-3.183.284-.567.132-4.557-.282-5.582 0 0-1.157.85-1.723 1.592-.633.72-1.592 1.004-1.94 1.876-.283.85-.85.85-1.286 1.808-.415.851-.85 2.311-.567 3.468.282 1.154.13 1.59.13 2.68 0 1.004 1.44 5.362 2.378 6.668",
    fill: "#090"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M444.9 305.798c.566 1.005.566-5.86.784-6.515.283-.72 1.068-2.246 1.657-2.812.567-.567.567-2.594.85-3.183.284-.567.132-4.557-.282-5.582 0 0-1.157.85-1.723 1.592-.633.72-1.592 1.004-1.94 1.876-.283.85-.85.85-1.286 1.808-.415.851-.85 2.311-.567 3.468.282 1.154.13 1.59.13 2.68 0 1.004 1.44 5.362 2.378 6.668",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M444.965 306.456s-.283-1.941.501-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1.003.436-1.59.283-.568.936-1.593 1.002-2.093.283-1.592 1.156-3.337.415-5.058 0 0-1.592.501-2.028.85-.501.283-1.809 1.44-1.874 2.593-.197 1.286-.283 1.505-.786 2.246-.414.72-1.003 2.9-.283 4.207.786 1.372.85 2.683.85 2.683",
    fill: "#090"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M444.965 306.456s-.283-1.941.501-2.683c.72-.719 1.44-.719 1.723-1.155.282-.414.13-1.003.436-1.59.283-.568.936-1.593 1.002-2.093.283-1.592 1.156-3.337.415-5.058 0 0-1.592.501-2.028.85-.501.283-1.809 1.44-1.874 2.593-.197 1.286-.283 1.505-.786 2.246-.414.72-1.003 2.9-.283 4.207.786 1.372.85 2.683.85 2.683z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M440.692 283.958s-.282-4.274.938-5.581c1.156-1.286 1.439-3.771 4.054-5.145 0 0-.13 1.068 0 1.81.196.632.502 2.747 0 3.466-.413.72-1.875 2.027-1.875 2.681 0 .566-1.003 2.028-1.722 2.31-.719.283-1.374.415-1.374.415",
    fill: "#090"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M440.692 283.958s-.282-4.274.938-5.581c1.156-1.286 1.439-3.771 4.054-5.145 0 0-.13 1.068 0 1.81.196.632.502 2.747 0 3.466-.413.72-1.875 2.027-1.875 2.681 0 .566-1.003 2.028-1.722 2.31-.719.283-1.374.415-1.374.415z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M440.692 286.268s0-3.03.938-3.902c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682 1.003-.567 2.812-2.093 2.964-2.594 0 0 .415 3.619-.566 5.58-1.069 1.875-1.069 2.9-2.181 3.336-1.22.414-1.374.72-1.81 1.003-.413.348-1.154.719-1.721.719-.567 0-1.221.415-1.221.415",
    fill: "#090"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M440.692 286.268s0-3.03.938-3.902c.85-.85 1.286-1.374 1.721-1.874.415-.567.85-2.094 1.876-2.682 1.003-.567 2.812-2.093 2.964-2.594 0 0 .415 3.619-.566 5.58-1.069 1.875-1.069 2.9-2.181 3.336-1.22.414-1.374.72-1.81 1.003-.413.348-1.154.719-1.743.719-.567 0-1.22.415-1.22.415z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M444.093 306.3c.13.855.785-1.875-2.31-1.875-3.118 0-5.582-1.218-6.606-2.243-1.003-1.003-1.657-1.722-2.006-2.245-.501-.35-1.657-2.159-1.81-3.03-.13-.85-1.003-4.12-.849-4.71 0 0 1.656.284 2.31.85.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.311 1.286.633.873 1.657 2.812 1.81 3.684.131.85 1.133 1.722 1.874 2.159.72.414.567 2.156.72 2.966",
    fill: "#090"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M444.093 306.3c.13.855.785-1.875-2.31-1.875-3.118 0-5.582-1.218-6.606-2.243-1.003-1.003-1.657-1.722-2.006-2.245-.501-.35-1.657-2.159-1.81-3.03-.13-.85-1.003-4.12-.849-4.71 0 0 1.656.284 2.31.85.72.634 2.093.634 2.812 1.07.72.413 1.286 1.59 1.744 2.027.415.414 1.722.414 2.311 1.286.633.873 1.657 2.812 1.81 3.684.131.85 1.133 1.722 1.874 2.159.72.414.567 2.156.72 2.966z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M443.81 305.145s-2.027-2.527-3.118-2.527c-1.003 0-3.619-2.68-3.771-3.77-.13-1.222-1.003-3.4-1.592-3.838-.567-.414-1.59-1.439-1.504-3.248.218-1.722.218-4.621.218-4.621s.567 1.722 1.44 2.157c.849.414 2.463 1.004 2.747 1.592.282.567 1.437.567 1.96 2.376.415 1.722.415 1.592.72 2.159.283.566 1.004 1.286 1.286 2.462.284 1.221 1.875 4.273 1.592 7.236",
    fill: "#090"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M443.81 305.145s-2.027-2.527-3.118-2.527c-1.003 0-3.619-2.68-3.771-3.77-.13-1.222-1.003-3.4-1.592-3.838-.567-.414-1.59-1.439-1.504-3.248.218-1.722.218-4.621.218-4.621s.567 1.722 1.44 2.157c.849.414 2.463 1.004 2.747 1.592.282.567 1.437.567 1.96 2.376.415 1.722.415 1.592.72 2.159.283.566 1.004 1.286 1.286 2.462.284 1.221 1.875 4.273 1.592 7.236z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M440.758 288.884c-.066.785 1.155-1.504-1.593-2.377-2.811-.85-4.773-2.593-5.427-3.836-.567-1.155-.938-2.026-1.221-2.528-.282-.502-.85-2.465-.72-3.249.066-.85.197-4.054.502-4.556 0 0 1.374.719 1.875 1.439.501.785 1.656 1.155 2.245 1.722.502.567.72 1.81 1.004 2.376.282.502 1.438.85 1.721 1.81.349.937.72 2.965.567 3.837-.065.785.567 1.875 1.155 2.528.502.567-.065 2.093-.13 2.813",
    fill: "#090"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M440.758 288.884c-.066.785 1.155-1.504-1.593-2.377-2.811-.85-4.773-2.593-5.427-3.836-.567-1.155-.938-2.026-1.221-2.528-.282-.502-.85-2.465-.72-3.249.066-.85.197-4.054.502-4.556 0 0 1.374.719 1.875 1.439.501.785 1.656 1.155 2.245 1.722.502.567.72 1.81 1.004 2.376.282.502 1.438.85 1.721 1.81.349.937.72 2.965.567 3.837-.065.785.567 1.875 1.155 2.528.502.567-.065 2.093-.13 2.813z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M440.823 287.729s-1.221-2.812-2.18-3.117c-.85-.283-2.377-2.681-2.442-3.771-.13-1.222-.349-3.401-.719-3.903-.414-.567-1.221-2.377-.633-3.903.633-1.59 1.658-3.684 1.658-3.684s.784 1.374 1.286 2.159c.72 1.504 1.504 1.592 1.59 2.158.131.633 1.004 1.003 1.374 2.224.437 1.656-.065 1.59.065 2.245.065.567.567 1.44.502 2.593-.065 1.157.567 4.34-.501 6.956",
    fill: "#090"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M440.823 287.729s-1.221-2.812-2.18-3.117c-.85-.283-2.377-2.681-2.442-3.771-.13-1.222-.349-3.401-.719-3.903-.414-.567-1.221-2.377-.633-3.903.633-1.59 1.658-3.684 1.658-3.684s.784 1.374 1.286 2.159c.72 1.504 1.504 1.592 1.59 2.158.131.633 1.004 1.003 1.374 2.224.437 1.656-.065 1.59.065 2.245.065.567.567 1.44.502 2.593-.065 1.157.567 4.34-.501 6.956z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M443.069 270.028c.13-.415 1.001-.851 2.092-1.221 1.003-.284 2.595-2.594 3.335-3.183.655-.633 1.003-1.504 1.963-2.028.85-.501 1.374-2.31 1.656-4.119 0 0-2.464.565-3.183.721-.72.128-2.158 1.066-2.747 1.719-.63.72-1.22 1.941-1.809 2.225-.567.283-1.286 2.027-1.286 3.247v2.596",
    fill: "#090"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M443.069 270.028c.13-.415 1.001-.851 2.092-1.221 1.003-.284 2.595-2.594 3.335-3.183.655-.633 1.003-1.504 1.963-2.028.85-.501 1.374-2.31 1.656-4.119 0 0-2.464.565-3.183.721-.72.128-2.158 1.066-2.747 1.719-.63.72-1.22 1.941-1.809 2.225-.567.283-1.286 2.027-1.286 3.247v2.596z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.146.85-1.282 4.12-3.771 4.993-3.9 0 0 .567 2.31.435 3.03-.13.72-.937 3.683-1.59 3.988-.634.283-2.378 3.772-4.426 4.556",
    fill: "#090"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M442.937 268.719s-.13-1.722-.13-2.528c0-.85-.567-3.248.719-5.146.85-1.282 4.12-3.771 4.993-3.9 0 0 .567 2.31.435 3.03-.13.72-.937 3.683-1.59 3.988-.634.283-2.378 3.772-4.426 4.556",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M442.196 270.028c-.349.632-.13-2.225-1.003-2.9-.85-.785-1.003-1.81-1.003-2.965 0-1.22.197-2.03.415-2.81.066-.72 2.31-3.773 2.158-4.621 0 0 1.286 2.808 1.59 3.616.503 1.005-.282 2.093-.13 2.963.13.852.85 2.465.349 3.337-.502.785-1.81 2.377-2.397 3.402",
    fill: "#090"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M442.196 270.028c-.349.632-.13-2.225-1.003-2.9-.85-.785-1.003-1.81-1.003-2.965 0-1.22.197-2.03.415-2.81.066-.72 2.31-3.773 2.158-4.621 0 0 1.286 2.808 1.59 3.616.503 1.005-.282 2.093-.13 2.963.13.852.85 2.465.349 3.337-.502.785-1.81 2.377-2.397 3.402z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M449.979 254.857s.131-.442 1.504-.442c1.286 0 3.183-.061 3.772-.714.566-.569 1.59-1.288 2.157-1.595.567-.28 1.592-1.591 1.81-2.244.131-.564 1.155-1.72 1.591-1.72 0 0-1.59-.133-3.4.348-1.723.345-4.208 1.283-4.775 2.46-.567 1.156-2.68 3.907-2.68 3.907",
    fill: "#090"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M449.979 254.857s.131-.442 1.504-.442c1.286 0 3.183-.061 3.772-.714.566-.569 1.59-1.288 2.157-1.595.567-.28 1.592-1.591 1.81-2.244.131-.564 1.155-1.72 1.591-1.72 0 0-1.59-.133-3.4.348-1.723.345-4.208 1.283-4.775 2.46-.567 1.156-2.68 3.907-2.68 3.907z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M450.48 254.572c.284 1.005 2.748-1.004 3.336-1.724a155.43 155.43 0 0 0 1.439-1.875s1.373-1.658 1.722-2.372c.937-1.596.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374-.414.126-1.286.412-1.592 1.132-.282.72-.567 1.724-1.068 2.243-.348.442-3.03 1.875-1.656 5.497",
    fill: "#090"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M450.48 254.572c.284 1.005 2.748-1.004 3.336-1.724a155.43 155.43 0 0 0 1.439-1.875s1.373-1.658 1.722-2.372c.937-1.596.719-4.493.348-4.275-.5.284-2.093 1.222-2.528 1.374-.414.126-1.286.412-1.592 1.132-.282.72-.567 1.724-1.068 2.243-.348.442-3.03 1.875-1.656 5.497",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    d: "M449.543 254.572s2.027-1.44 2.811-2.16c.851-.847.415-2.026.851-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.848-.85-3.331-.85-3.331s-1.068.936-1.721 1.718c-.786.72-.938 1.289-1.222 2.182-.282.937-.85 1.501-1.155 2.243-.283.72 0 2.16.131 3.03.13.854 0 1.724 0 1.724",
    fill: "#090"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M449.543 254.572s2.027-1.44 2.811-2.16c.851-.847.415-2.026.851-2.595.349-.564 1.439-1.936 1.155-2.812-.282-.848-.85-3.331-.85-3.331s-1.068.936-1.743 1.718c-.786.72-.938 1.289-1.222 2.182-.283.937-.85 1.501-1.155 2.243-.282.72 0 2.16.131 3.03.13.854 0 1.724 0 1.724z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.347215
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    d: "M481.96 347.068s-9.636-.068-10.508-1.284m16.11 2.528s-6.3 1.72-9.635 1.284c-3.401-.413-4.993.284-5.712.284-.72 0-4.426-1.507-4.426-1.507m26.226 2.272s-4.84.847-5.865 1.155c-1.003.279-5.93 2.153-7.455 2.153-1.155 0-4.055-.06-4.84 0-1.439.286-5.276 0-6.147-.412m5.951-14.515s3.685 2.153 4.272 2.896c.568.787 3.837 3.404 4.426 3.404m-8.698-10.882s6.3 5.43 7.325 6.15c1.068.78 7.238 6.736 7.979 7.695m-10.16-16.156s4.993 3.99 5.582 5.582c.566 1.59 2.006 3.465 2.006 3.465s2.092 4.124 2.811 4.71c.72.569 2.18 2.182 3.99 3.248m-42.815-20.711s5.21 4.426 6.67 5.274m-8.937-2.438s5.297 3.616 7.608 4.553c2.397.787 4.273 1.597 9.418 2.31m2.048 2.054s-5.864-.284-6.888 0c-1.003.28-5.58-.72-6.736-1.004-1.156-.284-5.865-1.156-6.453-1.289m11.162-17.502s-.284 3.182.13 4.555c.414 1.288 2.441 5.056 2.31 6.016-.13.853 1.156 4.837 2.378 5.58m1.198-15.587s-1.003 3.187-.567 4.275c.415 1.004 1.134 2.896 1.134 4.119 0 1.155.719 2.902 1.003 3.622.283.72-.131 3.248.565 3.9.721.787 1.658 2.094 1.658 2.094m-35.206-25.465s4.708 1.724 5.297 2.901c.501 1.155 1.439 1.501 1.875 2.093m10.092-9.42s1.222 4.71.938 5.865c-.282 1.155-.282 3.556-.282 4.425 0 .855-1.287 4.426-1.221 4.995m-1.309-19.209s-.435 2.746-.566 3.907c-.131 1.155 0 3.114-.284 3.834-.283.72-.72 4.62 0 6.451m-12.077-10.267s3.836 3.247 4.709 4.124c.85.847 4.84 5.056 4.991 6.144.131 1.004 2.9 4.208 3.772 4.994m-19.925-31.676s3.837 3.771 4.12 4.621c.283.939 1.875 2.311 2.681 2.813m11.119-5.82s-1.44 2.157-1.44 2.9c0 .718-.566 2.68-1.154 3.4-.437.5-1.592 2.595-1.505 3.9m2.942-16.37s-.566 2.027-.85 3.467c-.282 1.439-1.068 2.964-1.285 3.836-.283.85-1.505 5.145-1.069 7.762m-10.137-15.217s.415 2.026 1.44 3.03c1.003 1.003 2.593 2.529 2.746 3.335.13.937 1.504 5.275 2.964 6.802 1.44 1.439 1.592 2.964 1.592 2.964m-10.267-31.085s.435 2.462.719 3.181c.283.72 1.504 3.99 2.681 4.993m9.287-7.52s-.785 2.026-.85 2.964c-.195.85-1.068 1.875-1.221 2.31-.13.414-.72 1.941-.72 1.941m5.407-5.188c-.131.937-1.81 3.552-1.874 3.989-.197.501-1.004 2.529-1.941 3.117-.85.567-3.466 2.463-3.335 3.249m-4.317-16.002s-.13 3.183.414 4.338c.655 1.221 1.308 2.966 1.592 3.836.348.852.348 2.312.414 3.337.196 1.068.567 2.965 1.221 3.683m11.532-25.202s-2.158 2.377-3.117 3.404c-.938.936-4.709 4.991-4.84 5.71m4.404-11.29s-2.027 4.487-2.53 5.206c-.413.787-.783 1.942-.783 1.942m-1.985-7.305s.132 3.555 0 4.425c-.13.787-.13 2.314 0 2.75.132.414-.414 3.618-.567 4.425m17.615-20.73s-4.71 2.812-5.428 3.55m2.594-7.194-3.184 4.627-.718 1.372m.283-6.435s-1.068 2.467-1.155 3.466c-.196 1.072-1.592 4.275-2.246 5.43",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17286999999999997
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M501.273 348.027s.633-1.808 2.159-.194c0 0 1.743 4.117.414 4.268-1.286.134-2.594.42-2.747-.28-.195-.72.131-3.771.131-3.771",
    fill: "#004bb3"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    d: "M503.148 347.375s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.592 1.35.13 7.824-.414 8.477-.567.57-1.44 2.378-4.84 1.942l-.414-1.59s1.721-.134 2.9-.787c1.22-.564 1.59-1.066 1.503-1.72-.131-.853-.065-4.123-1.003-4.424-.85-.286-2.245-.721-2.245-.721s-1.287 4.928-1.591 6.301l-.283-.419m-2.072 4.364s-6.082 3.467-2.964 8.763c0 0-1.286 0-2.093-1.284 0 0-1.068 2.093-.066 3.248 0 0-4.12-3.688-.937-8.047 3.248-4.426 5.865-4.118 5.865-4.118l.195 1.44",
    fill: "#004bb3"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 351.8s-6.082 3.466-2.964 8.762c0 0-1.286 0-2.093-1.284 0 0-1.069 2.093-.066 3.248 0 0-4.12-3.688-.937-8.047 3.248-4.426 5.864-4.118 5.864-4.118l.196 1.44",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-2.66-1.809-6.43-.78c0 0-1.744-5.432-1.069-7.179.282-.781.85-.847.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.196-1.44",
    fill: "#004bb3"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-2.66-1.809-6.43-.78c0 0-1.744-5.432-1.069-7.179.282-.781.85-.847.85-.847s-1.874-1.156-1.285 3.99c.566 5.145 1.59 6.585 1.59 6.585s4.993.279 6.148-.285l.196-1.44z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-5.275-8.85-6.67-8.85c0 0-1.504-.196 1.874-.565 1.221-.133 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927 0 0-1.003.284-1.155 1.808",
    fill: "#004bb3"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-5.275-8.85-6.67-8.85c0 0-1.504-.196 1.874-.565 1.221-.133 3.118 0 3.99 1.658.937 1.59 1.591 5.358 1.94 5.927 0 0-1.003.284-1.155 1.808z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-3.553-1.658-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1.003 2.46.283 1.815.72 4.493 1.221 5.582 0 0 2.748-1.066 6.431.787",
    fill: "#003"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 348.898s-3.553-1.658-3.99-2.093c-.413-.413-1.154-5.363-.784-5.056 0 0-1.374-1.657-1.875-1.657-.283 0-1.285.72-1.003 2.46.283 1.815.72 4.493 1.221 5.582 0 0 2.748-1.066 6.431.787z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    d: "M504.304 351.8s1.875 1.155 1.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1.004-1.941 0 0 1.722 2.092 2.31 2.092 0 0-1.002-1.937-1.002-2.813 0-.848-.85-4.269-1.722-5.055-.85-.938-2.682-2.965-5.145-3.685v1.005",
    fill: "#004bb3"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M504.304 351.8s1.875 1.155 1.875 3.4c0 2.158.937 6.149 2.68 7.019 0 0 .415-1.657 1.004-1.941 0 0 1.722 2.092 2.31 2.092 0 0-1.002-1.937-1.002-2.813 0-.848-.85-4.269-1.722-5.055-.85-.938-2.682-2.965-5.145-3.685v1.005z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    d: "m505.045 341.487-1.59 6.3.413 1.373s.567-.128.85-.847c.283-.788 1.156-6.15 1.657-6.39l-1.374-.414",
    fill: "#003"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "m505.045 341.487-1.59 6.3.413 1.373s.567-.128.85-.847c.283-.788 1.156-6.15 1.657-6.39l-1.374-.414z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    d: "M501.056 351.08s-2.9.848-3.99 3.114c0 0-.348-1.434 3.837-3.465l.131.35m3.356.001s2.028.782 2.53 1.936c0 0-1.94-1.216-2.529-1.434v-.501m-3.335-1.681s-4.491.72-5.516.503c0 0 1.374.284 5.582-.068l-.066-.413m7.26-2.767s.5 2.243.85 2.16c.348-.202 1.067-3.774 1.154-5.498.066-1.59-.72-2.026-1.35-1.875-.633 0-1.004 1.507-.938 2.16 0 .63.196 2.679.283 3.03",
    fill: "#00004b"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M503.454 347.81s1.81 4.052.414 4.269c-1.373.2.567.133-.348-2.59-.35-1.071-.939-2.376-1.222-2.376 0 0 1.003.412 1.156.719",
    fill: "#00004b"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    d: "M501.273 348.027s.633-1.808 2.159-.194c0 0 1.743 4.117.414 4.268-1.286.134-2.594.42-2.747-.28-.195-.72.131-3.771.131-3.771zm1.875-.652s.414-6.235 1.286-6.586c.85-.285 3.554-1.724 5.146-.413 1.592 1.35.13 7.824-.414 8.477-.567.57-1.44 2.378-4.84 1.942l-.414-1.59s1.721-.134 2.9-.787c1.22-.564 1.59-1.066 1.503-1.72-.131-.853-.065-4.123-1.003-4.424-.85-.286-2.245-.721-2.245-.721s-1.287 4.928-1.591 6.301l-.283-.419z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.232165
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M496.63 240.576c-.349-.937-.414-7.238-.349-8.198.066-1.658 3.03-10.006 3.62-10.945.632-.937.413-1.154.72-1.718l.784-1.155c.633.998 1.133 2.678 1.22 3.99 0 0-.5 3.984-1.002 5.798-.349 1.72-1.504 4.208-1.723 4.705-.567 1.222-.501 2.31-.13 2.444l-3.117 5.056",
    fill: "#004bb3"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    d: "m501.624 232.227.5.502c1.286-1.44 1.374-4.342 1.374-4.342l-.851-5.86s-.501 3.985-1.003 5.799c-.348 1.719-1.504 4.208-1.721 4.705-.85 2.092-.197 2.316-.132 2.444l1.876-3.248",
    fill: "#fff"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M502.146 232.729c1.286-1.44 1.374-4.342 1.374-4.342s.937 4.777.413 5.804c-.501 1-.501.715-.413 1.218l-1.374-2.68",
    fill: "#004bb3"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    d: "M503.52 235.408c-.066-.502-.066-.195.413-1.217.502-1.004-.413-5.804-.413-5.804l-.851-5.86c-.065-1.289-.567-2.969-1.22-3.99l-.786 1.155c-.282.564-.065.782-.719 1.72-.567.937-3.553 9.27-3.619 10.944-.065.937 0 7.238.349 8.197",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 219.302s-.067-.937-.132-1.29c-.066-.127.502.848.937.72.85.285 1.81 1.44 2.028 1.725-.35.497-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.44-.066-.285-.348-.631-.348-1.073",
    fill: "#fc0"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 219.302s-.067-.937-.132-1.29c-.066-.127.502.848.937.72.85.285 1.81 1.44 2.028 1.725-.35.497-1.221 1.591-1.876 1.374-.5-.135-.414-.938-.566-1.44-.066-.285-.348-.631-.348-1.073z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M501.71 218.515c.065.067.283.345.35.435.194.067.348 0 .631.129.632.419.85.787 1.505 1.44m-1.92-1.352c.786.352 1.221 1.006 1.81 1.725v-.134",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    d: "M500.75 218.643s.85-.413 1.134-.63c.131-.068-.632.786-.349 1.133.065.853-.632 2.182-.937 2.528-.567-.195-1.22-.195-1.722-1.155-.196-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787",
    fill: "#fc0"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M500.75 218.643s.85-.413 1.134-.63c.131-.068-.632.786-.349 1.133.065.853-.632 2.182-.937 2.528-.567-.195-1.22-.195-1.722-1.155-.196-.346.348-.721.72-1.066.195-.135.718-.721 1.155-.787z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    d: "M501.557 218.365c-.065.061-.283.346-.283.497 0 .2.13.35.065.635-.131.72-.414 1.067-.785 1.936m.567-2.265c-.065.848-.5 1.506-1.003 2.243h.131",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M502.06 218.013c.565-.631 1.655-1.284 2.157-.848 0 0 .414.284.567.501.282.28.196.413.065.782-.349.72-1.352.351-2.027 0-.13-.067-.502-.413-.72-.285-.283.067-.196.067-.283.067.065.135.195.068.283.135.567.127 1.003.497 1.722.781.502.195 1.44-.413 1.374-.938 0-.502-.85-1.5-1.286-1.5-.938 0-1.657.63-2.377 1.371.197-.133.349.129.502-.066",
    fill: "#fc0"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    d: "M502.06 218.013c.565-.631 1.655-1.284 2.157-.848 0 0 .414.284.567.501.282.28.196.413.065.782-.349.72-1.352.351-2.027 0-.13-.067-.502-.413-.72-.285-.283.067-.196.067-.283.067.065.135.195.068.283.135.567.127 1.003.497 1.722.781.502.195 1.44-.413 1.374-.938 0-.502-.85-1.5-1.286-1.5-.938 0-1.657.63-2.377 1.371.197-.133.349.129.502-.066z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M501.557 218.013c-.567-.631-1.656-1.284-2.158-.848 0 0-.436.284-.566.501-.197.28-.197.413-.067.782.35.72 1.374.351 2.028 0 .131-.067.501-.413.72-.285.349.067.197.067.349.067-.131.135-.284.068-.415.135-.501.127-.938.497-1.657.781-.5.195-1.438-.413-1.438-.938.065-.563.938-1.5 1.373-1.5.937 0 1.744.63 2.377 1.371-.131-.133-.35.129-.503-.066",
    fill: "#fc0"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    d: "M501.557 218.013c-.567-.631-1.656-1.284-2.158-.848 0 0-.436.284-.566.501-.197.28-.197.413-.067.782.35.72 1.374.351 2.028 0 .131-.067.501-.413.72-.285.349.067.197.067.349.067-.131.135-.284.068-.415.135-.501.127-.938.497-1.657.781-.5.195-1.438-.413-1.438-.938.065-.563.938-1.5 1.373-1.5.937 0 1.744.63 2.377 1.371-.131-.133-.35.129-.503-.066z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M501.776 217.645c-.284-.135-.568.128-.655.279-.065.2.065.568.284.568.348.129.85.068.938-.284.065-.346-.284-.413-.567-.563",
    fill: "#fc0"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    d: "M501.776 217.645c-.284-.135-.568.128-.655.279-.065.2.065.568.284.568.348.129.85.068.938-.284.065-.346-.284-.413-.567-.563",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M501.71 211.757s.35 2.244 1.504 3.9c0 0-1.374 1.44-1.591 2.027 0 0-.72-1.652-1.504-2.094 0 0 1.22-1.936 1.592-3.833",
    fill: "#fc0"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    d: "M501.71 211.757s.35 2.244 1.504 3.9c0 0-1.374 1.44-1.591 2.027 0 0-.72-1.652-1.504-2.094 0 0 1.22-1.936 1.592-3.833m-.088 2.4s.282.998.632 1.656c0 0-.502.413-.632.632 0 0-.283-.632-.567-.787 0 0 .567-.848.567-1.502",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M528.613 277.2c1.434-3.554 2.963-10.944 2.896-12.623-.285-6.89-.195-8.984-.847-16.087l-7.112 8.197c.135 2.679.202 3.55 0 5.274-.06.63-.496 3.771-1 4.993l6.085 10.224",
    fill: "#fff"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    d: "M522.53 266.976c.502-1.221.937-4.34 1.004-4.992.195-1.724.128-2.596 0-5.274l-4.428 4.838 3.4 5.427m18.228 6.671c.129-1.591.195-3.335.195-4.12 0-4.992.564-7.76 0-13.056-.35-4.125-1.44-9.638-1.221-14.064.066-1.283-.13-2.528-.13-3.773l-8.918 9.857c.632 7.103.564 9.196.85 16.087.066 1.657-1.44 9.07-2.897 12.622l1.875 3.183 10.224-6.736",
    fill: "#004bb3"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "m518.452 260.896 20.82-23.066.346.502-20.512 23.194-.632-.63",
    fill: "#fc0"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    d: "m518.452 260.896 20.82-23.066.346.502-20.512 23.194-.632-.63z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M539.076 244.259s-1.657 14.565-7.327 13.997",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    d: "M531.749 258.188c2.813.135 4.621-3.465 5.715-6.797 1.156-3.471 1.59-7.177 1.59-7.177",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M531.749 258.188c2.813-.128 4.621-3.773 5.648-6.887 1.155-3.336 1.657-7.11 1.657-7.11",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    d: "M531.749 258.127c2.813-.2 4.621-3.99 5.648-6.96 1.066-3.18 1.657-6.953 1.657-7.013",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M531.749 258.06c2.813-.413 4.621-4.209 5.582-6.954 1.071-3.119 1.745-6.892 1.745-7.02",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 257.971c2.806-.564 4.704-4.487 5.58-6.953 1.067-3.031 1.808-6.888 1.808-7.021",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 257.971c2.806-.781 4.704-4.771 5.58-7.02 1.067-2.964 1.808-6.798 1.808-6.954",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 257.91c2.806-.938 4.704-4.996 5.424-7.11 1.155-2.813 1.875-6.736 1.964-6.888",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 257.91c2.806-1.223 4.704-5.28 5.424-7.178 1.072-2.745 1.875-6.668 1.964-6.886",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M531.599 257.754c2.896-1.284 4.771-5.426 5.424-7.105 1.071-2.684 1.942-6.585 2.031-6.892",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M531.599 257.754c2.896-1.502 4.771-5.8 5.424-7.172 1.004-2.595 1.942-6.518 2.031-6.803",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M531.599 257.686c2.812-1.651 4.771-6.016 5.274-7.17 1.132-2.529 2.092-6.52 2.16-6.799",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 257.686c2.901-1.874 4.838-6.295 5.362-7.322 1.005-2.31 2.027-6.367 2.16-6.735",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M538.988 243.606c-.068.351-1.066 4.426-2.16 6.67-.435.785-2.372 5.211-5.274 7.237",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M538.859 240.927s-4.71 11.597-7.696 10.286",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M531.163 251.235c1.217.569 3.18-1.719 4.772-4.487 1.658-2.97 2.903-5.804 2.903-5.804",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M531.163 251.169c1.066.501 3.115-1.652 4.705-4.488a68.409 68.409 0 0 0 2.969-5.798",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M531.163 251.169c.848.44 3.03-1.652 4.62-4.555 1.81-3.248 3.031-5.708 3.031-5.708",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M531.096 251.169c.787.283 3.03-1.652 4.71-4.622 1.875-3.399 3.03-5.708 3.03-5.708",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M531.096 251.084c.631.285 2.963-1.59 4.621-4.62a217.751 217.751 0 0 0 3.03-5.715",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M531.096 251.084c.413.195 2.903-1.59 4.621-4.776l3.03-5.643",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M531.096 251.084c.284.129 2.813-1.59 4.554-4.838 2.093-3.84 3.03-5.582 3.03-5.582",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M531.096 251.084c.128 0 2.746-1.59 4.493-4.838 2.153-4.057 3.114-5.648 3.114-5.648",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M538.703 240.576s-.938 1.373-3.181 5.49c-1.747 3.406-4.493 4.93-4.493 4.93m-7.494 8.002-3.993 2.16m3.708 1.612-3.686-.636",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "m523.617 259.215-4.053 1.943",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 259.366-4.057 1.875",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 259.583-4.057 1.658",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 259.718-4.123 1.59",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 259.868-4.123 1.44",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 260.086-4.123 1.223",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 260.237-4.21 1.155",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 260.46-4.275.932",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "m523.534 260.589-4.275.847",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "m523.31 262.615-3.833-.565",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    d: "m523.31 262.397-3.833-.413",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "m523.31 262.179-3.9-.285",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "m523.31 262.05-3.9-.133",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M523.31 261.833h-3.986",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "m523.4 261.615-4.12.128",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "m523.4 261.391-4.12.286",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "m523.467 261.241-4.273.351",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "m523.467 261.023-4.273.57",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "m523.467 260.806-4.338.72",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M540.734 273.646c.129-1.155.129-2.377.129-3.117 0-4.992.63-8.763.066-14.059-.35-4.125-1.44-9.638-1.221-14.064.066-1.283-.13-2.528-.13-3.773l-20.45 22.915",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M540.734 261.894s-.284 3.033-.938 4.34c-.937 1.875-3.772 4.621-7.02 6.671",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M532.687 272.927c2.092-1.374 4.057-3.03 5.363-4.491.63-.785 1.29-1.591 1.59-2.245.72-1.286 1.005-4.336 1.005-4.336",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M532.603 272.927c2.092-1.374 3.984-3.183 5.274-4.622.72-.719 1.222-1.504 1.657-2.158.721-1.373 1.066-4.337 1.066-4.337",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M532.536 272.927c2.026-1.374 3.99-3.248 5.206-4.622.637-.784 1.29-1.592 1.659-2.31.786-1.374 1.221-4.34 1.221-4.34",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M532.47 272.861c2.026-1.373 3.9-3.335 5.144-4.621.72-.72 1.223-1.504 1.658-2.31.848-1.44 1.374-4.337 1.374-4.337",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M532.38 272.861c2.031-1.373 3.906-3.4 5.145-4.709.57-.719 1.156-1.504 1.596-2.31.933-1.505 1.524-4.339 1.524-4.339",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M532.319 272.861c2.026-1.373 3.9-3.553 5.078-4.84.63-.632 1.155-1.438 1.657-2.244.848-1.592 1.59-4.34 1.59-4.34",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M532.251 272.861c2.027-1.439 3.902-3.684 4.995-4.926a16.471 16.471 0 0 0 1.652-2.245c.938-1.657 1.747-4.337 1.747-4.337",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M532.162 272.861c2.032-1.439 3.906-3.77 4.995-4.991.57-.567 1.066-1.44 1.59-2.246 1.005-1.722 1.875-4.338 1.875-4.338",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M532.1 272.861c1.937-1.504 3.835-3.901 4.923-5.058.502-.566 1.071-1.373 1.597-2.31.998-1.723 1.936-4.335 1.936-4.335",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M532.034 272.861c1.941-1.504 3.833-4.054 4.839-5.144.501-.567 1.071-1.44 1.59-2.311 1.071-1.81 2.093-4.338 2.093-4.338",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M531.945 272.861c1.942-1.504 3.839-4.12 4.844-5.21.413-.501.999-1.373 1.5-2.31 1.156-1.873 2.245-4.34 2.245-4.34",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M531.883 272.774c1.958-1.505 3.834-4.12 4.772-5.21.413-.502 1.004-1.373 1.568-2.31 1.155-1.943 2.31-4.336 2.31-4.336",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M540.577 260.806s-2.745 5.145-4.051 6.671c-.937 1.002-2.751 3.771-4.71 5.276",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M540.516 273.646c-2.968 2.028-3.772 2.529-10.005 6.518l-1.876-2.965s.72-1.656.999-2.528",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.646c-2.813 1.94-3.84 2.529-9.923 6.366l-.061-.066-1.725-2.812s.134-.349.285-.784c.284-.502.501-1.156.63-1.658",
    fill: "none",
    stroke: "#00004f",
    strokeWidth: 0.23187
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.646c-2.746 1.876-4.057 2.681-9.923 6.3l-.061-.13c0-.065-1.591-2.813-1.591-2.813s.061-.282.28-.719c.2-.501.35-1.156.5-1.592",
    fill: "none",
    stroke: "#000053",
    strokeWidth: 0.23187
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.646c-2.685 1.723-4.119 2.681-9.923 6.147l-.061-.13c0-.066-1.507-2.747-1.507-2.747s.067-.283.194-.72c.202-.5.42-1.068.57-1.504",
    fill: "none",
    stroke: "#000056",
    strokeWidth: 0.23187
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.581c-2.595 1.722-4.342 2.812-9.923 6.082l-.061-.066c0-.13-1.374-2.812-1.374-2.812s0-.194.129-.632c.195-.5.413-1.004.502-1.439",
    fill: "none",
    stroke: "#000058",
    strokeWidth: 0.23187
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.581c-2.528 1.656-4.493 2.9-9.923 6.016l-.061-.13c0-.197-1.29-2.812-1.29-2.812s0-.197.134-.567c.195-.436.346-.937.413-1.374",
    fill: "none",
    stroke: "#00005c",
    strokeWidth: 0.23187
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.581c-2.377 1.59-4.621 2.964-9.923 5.865l-.061-.132c0-.196-1.156-2.747-1.156-2.747s-.067-.195.062-.566c.134-.414.284-.873.35-1.286",
    fill: "none",
    stroke: "#000060",
    strokeWidth: 0.23187
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M540.45 273.581c-2.31 1.504-4.839 2.964-9.923 5.711l-.061-.13c0-.197-1.072-2.748-1.072-2.748s-.061-.13.067-.5c.195-.415.195-.786.285-1.222",
    fill: "none",
    stroke: "#000062",
    strokeWidth: 0.23187
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.581c-2.16 1.439-4.928 3.03-9.85 5.647l-.067-.132c0-.283-1.004-2.747-.937-2.747 0 0-.134-.13 0-.501.128-.414.195-.72.195-1.156",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-2.092 1.439-5.056 3.182-9.85 5.58-.067 0-.067-.13-.067-.13 0-.283-.854-2.748-.854-2.748s-.128-.065 0-.414c.134-.349.134-.653.134-1.068",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-2.026 1.374-5.274 3.248-9.85 5.427-.067 0-.067-.065-.134-.13.067-.35-.72-2.682-.72-2.682h.067s-.194-.13-.067-.414c.135-.348.067-.566.067-1.003",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-1.942 1.286-5.424 3.334-9.85 5.362-.067-.066-.067-.131-.134-.195 0-.285-.563-2.595-.563-2.595s-.202-.13-.068-.436c.13-.349.068-.501 0-.938",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-1.808 1.155-5.58 3.334-9.85 5.21l-.134-.132c0-.414-.501-2.68-.501-2.68s-.195-.066-.13-.35c.13-.348.13-.436.068-.85",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-1.718 1.068-5.708 3.4-9.917 5.078l-.067-.13c0-.436-.413-2.594-.346-2.681 0 0-.284-.066-.133-.284.066-.348 0-.348-.068-.785",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    d: "M540.36 273.516c-1.657 1.003-5.864 3.466-9.917 4.991 0-.065-.067-.195-.067-.195 0-.415-.346-2.595-.284-2.595 0 0-.28-.065-.195-.283.133-.283 0-.283-.068-.72",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M540.293 273.428c-1.5 1.069-6.015 3.62-9.85 4.927l-.067-.196c0-.414-.195-2.53-.129-2.595 0 0-.35 0-.284-.195.067-.284-.066-.284-.133-.633",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    d: "M540.293 273.428c-1.434.937-6.144 3.685-9.85 4.774l-.067-.13c0-.502-.129-2.595-.067-2.682 0 0-.346.065-.279-.13.129-.284-.067-.197-.2-.568",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    d: "M540.293 273.363c-1.373.937-6.295 3.77-9.85 4.773 0-.064-.067-.196-.067-.196 0-.565 0-2.528.067-2.594 0 0-.413.066-.351-.13.067-.283-.129-.13-.195-.502",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M540.293 273.363c-1.217.85-6.518 3.836-9.85 4.621 0-.065-.067-.195-.067-.195 0-.567.067-2.53.135-2.595 0 0-.503.131-.352-.066.067-.195-.195-.065-.284-.414",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.363c-1.094.785-6.586 3.901-9.789 4.49 0 0-.067-.13-.067-.195 0-.567.135-2.465.195-2.53h.068s-.503.066-.413-.065c.062-.195-.196 0-.351-.349",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.363c-1.004.719-6.736 3.99-9.789 4.425-.067-.065-.067-.13-.067-.196 0-.632.284-2.53.352-2.53 0 0-.502.066-.502-.064.128-.196-.196.065-.351-.283",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.363c-.938.632-6.892 4.054-9.789 4.273-.067-.066-.067-.131-.134-.196.068-.634.441-2.465.502-2.53 0 0-.564.131-.435 0 .067-.196-.346.131-.501-.196",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.363c-.877.501-7.021 4.054-9.789 4.207-.067-.13-.067-.195-.134-.282 0-.633.57-2.465.659-2.53 0 0-.57.132-.57.066.068-.197-.284.195-.501-.132",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.297c-.787.502-7.238 4.208-9.789 4.122a.482.482 0 0 1-.134-.285c0-.719.659-2.463.72-2.463 0 0-.564.13-.564 0 .062-.065-.351.349-.568 0",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.297c-.636.502-7.394 4.273-9.789 3.99-.067-.065-.134-.13-.134-.196 0-.785.72-2.465.854-2.529 0 0-.72.195-.636.13.067-.13-.346.35-.63 0",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M540.232 273.297c-.57.35-7.545 4.339-9.789 3.837-.067 0-.134-.13-.134-.195 0-.786.854-2.377.938-2.465v-.065s-.72.283-.63.197c.066-.132-.413.414-.721.065",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.297c-.413.283-7.675 4.339-9.7 3.772-.068-.066-.135-.196-.195-.283.06-.785.998-2.377 1.154-2.465 0 0-.72.285-.72.197 0-.13-.501.502-.72.13",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.297c-.352.196-7.825 4.426-9.7 3.62-.068-.067-.135-.197-.195-.284 0-.785 1.154-2.312 1.215-2.464 0 0-.78.35-.72.196 0 0-.496.633-.78.284",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.297c-.286.131-7.982 4.491-9.79 3.553 0-.13-.067-.194-.129-.282 0-.85 1.218-2.377 1.285-2.465 0 0-.782.285-.72.285 0-.067-.565.567-.848.282",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.21c-.196.13-8.199 4.621-9.79 3.466 0-.065-.129-.13-.129-.283 0-.85 1.285-2.311 1.435-2.376l-.78.283s-.632.633-.939.349",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.21c-.069.065-8.328 4.71-9.79 3.335 0-.065-.129-.13-.129-.282 0-.938 1.435-2.312 1.502-2.377l-.781.283s-.66.786-1.004.502",
    fill: "none",
    stroke: "#0049af",
    strokeWidth: 0.23187
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M540.166 273.146s-9.483 5.361-9.917 2.963c0-.937 1.59-2.31 1.59-2.31l-.854.283s-.653.85-1 .567",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    d: "M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026 0 0-.502 0-.786.061-.346.135-.413.285-.503.636-.129.782.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285-.129 0-.195-.068-.285-.135-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.419.78.57 1.066 1.44 1.155 2.467-.067-.194-.35-.067-.35-.284",
    fill: "#fc0"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    d: "M539.139 237.808c-.063-.938-.565-2.026-1.218-2.026 0 0-.502 0-.786.061-.346.135-.413.285-.503.636-.129.782.938 1.066 1.658 1.156.128 0 .653-.068.786.128.129.285.062.195.129.285-.129 0-.195-.068-.285-.135-.564-.127-1.065-.127-1.875-.278-.563-.068-.937-1.156-.63-1.591.35-.351 1.59-.72 1.964-.419.78.57 1.066 1.44 1.155 2.467-.067-.194-.35-.067-.35-.284z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M539.579 238.092c.847-.284 2.093-.134 2.31.413 0 .067.195.564.128.787.068.347-.066.496-.345.715-.72.35-1.379-.497-1.657-1.156-.068-.194-.201-.564-.42-.714-.345-.068-.194 0-.345-.068.067.13.194.196.284.285.346.497.503.938.938 1.653.195.501 1.35.501 1.657.067.279-.503.062-1.72-.2-2.026-.782-.57-1.809-.503-2.747-.195.195-.068.195.284.436.195",
    fill: "#fc0"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M539.579 238.092c.847-.284 2.093-.134 2.31.413 0 0 .195.564.128.787.068.347-.066.496-.345.715-.72.35-1.379-.497-1.657-1.156-.068-.194-.201-.564-.42-.714-.345-.068-.194 0-.345-.068.067.13.194.196.284.285.346.497.503.938.938 1.653.195.501 1.35.501 1.657.067.279-.503.062-1.72-.2-2.026-.782-.57-1.809-.503-2.747-.195.195-.068.195.284.436.195z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M539.64 237.674c.285 0 .351.418.285.636 0 .195-.346.346-.57.284-.345-.133-.63-.419-.496-.786.061-.352.497-.195.781-.134",
    fill: "#fc0"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M539.64 237.674c.285 0 .351.418.285.636 0 .195-.346.346-.57.284-.345-.133-.63-.419-.496-.786.061-.352.497-.195.781-.134",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72 233.532s-2.093 1.507-4.057 2.033c0 0 .284 1.718 0 2.243 0 0 1.657-.72 2.528-.503 0 0 .413-2.528 1.507-3.773",
    fill: "#fc0"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    d: "M543.72 233.532s-2.093 1.507-4.057 2.033c0 0 .284 1.718 0 2.243 0 0 1.657-.72 2.528-.503 0 0 .413-2.528 1.507-3.773z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M542.13 235.19s-.854.57-1.658.788c0 0 .128.63 0 .847 0 0 .63-.195.999-.128 0 0 .2-1.005.636-1.506z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    d: "M539.947 239.549s-.569-.63-.787-.937c-.127-.129.285.937-.127 1.221-.352.787-.069 2.25 0 2.595.63.068 1.22.285 2.092-.345.284-.285-.135-.855-.352-1.29-.128-.195-.345-.937-.78-1.222",
    fill: "#fc0"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    d: "M539.947 239.549s-.569-.63-.787-.937c-.127-.129.285.937-.127 1.221-.352.787-.069 2.25 0 2.595.63.068 1.22.285 2.092-.345.284-.285-.135-.855-.352-1.29-.128-.195-.345-.937-.78-1.222z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M539.356 239.113c0 .068.067.42.067.503-.068.195-.285.284-.285.569-.128.72 0 1.217.068 2.154m.217-2.416c-.195.937 0 1.657.133 2.46h-.133m.156-.936c.061.284.128.501.128.936.067-.06.195.068.285.068",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 326.904c-.067 0-.198-.134-.285-.195-.414-.2-1.067-.2-1.286-.419-1.003-1.155-.283-3.332.066-4.705.85-2.533 1.003-4.844 1.504-7.238h.065c.567 2.378.633 4.705 1.439 7.238.5 1.373 1.155 3.55.13 4.705-.195.202-.85.202-1.22.419-.13.061-.283.195-.414.195",
    fill: "#fff"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 314.213c.565 2.377.719 4.839 1.503 7.394.414 1.218 1.069 3.249.283 4.42l-.012-.156c.414 0 .719-.068 1.068-.196.13-.067.209.03.295-.105.132-.195.284-.346.437-.497.283-.133.566-.066.85-.2.066-.062.066-.13.13-.13.502-.283 1.003-.568 1.222-1.065.13-.419.13-.787.065-1.221a2.843 2.843 0 0 0-.284-.788c-.13-.345-.282-.72-.5-1.065-.13-.413-.35-.721-.567-1.156-.066-.194-.132-.351-.283-.502-.067-.195-.198-.351-.284-.502-.066-.194-.283-.285-.414-.502-.132-.13-.219-.13-.284-.285-.065 0-.283-.061-.197-.129-.065 0-.194-.067-.282-.128-.283-.72-.655-1.072-.938-1.814-.196-.279-.196-.781-.196-1.154h-1.59",
    fill: "#004bb3"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M502.43 314.28s.936 3.99 1.504 4.995c.566 1 2.812 2.807 1.285 5.708",
    fill: "none",
    stroke: "#003",
    strokeWidth: 0.23187
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M502.276 314.28s.938 3.99 1.592 4.995c.567 1.066 2.878 2.812 1.351 5.708",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    d: "M502.21 314.28s.912 4.007 1.48 5.095c.566 1.004 2.812 2.963 1.22 5.864",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M502.06 314.28s1.002 4.12 1.59 5.146c.567 1.004 2.837 2.704 1.31 5.69",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    d: "M501.994 314.28s.936 4.209 1.59 5.212c.502 1 2.682 3.115 1.069 6.08",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    d: "M501.928 314.28s.937 4.275 1.504 5.275c.567 1.003 2.681 3.185 1.068 6.15",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M502.495 314.28s.937 3.84 1.592 4.928c.565 1.066 2.812 2.897 1.285 5.71",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M502.647 314.37s.85 3.616 1.505 4.838c.566 1.005 2.899 2.897 1.373 5.71",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M502.713 314.37s.85 3.55 1.59 4.838c.568 1.005 2.813 2.813 1.374 5.71",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M502.8 314.37s.85 3.398 1.591 4.772c.567 1.071 2.9 2.902 1.374 5.714",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path332 || (_path332 = /*#__PURE__*/React.createElement("path", {
    d: "M502.93 314.37s.785 3.332 1.592 4.772c.567 1.003 2.899 2.902 1.373 5.714",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path333 || (_path333 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 314.213c-.503 2.377-.634 4.839-1.505 7.394-.35 1.218-1.004 3.249-.196 4.42l-.066-.06h.066c-.349 0-.72-.068-1.069-.195-.066-.068-.197-.068-.282-.202a1.802 1.802 0 0 0-.503-.497c-.196-.133-.5-.066-.719-.2-.065-.062-.13-.13-.196-.13-.501-.283-1.003-.568-1.221-1.065-.065-.419-.131-.787-.065-1.221.065-.286.196-.503.283-.788.13-.345.284-.72.502-1.065.13-.413.348-.721.567-1.156.065-.194.13-.351.282-.502.066-.195.132-.351.283-.502.067-.194.284-.285.416-.502.13-.13.194-.13.348-.285 0 0 .195-.061.195-.129.066 0 .132-.067.132-.128.415-.72.72-1.072 1.003-1.814.196-.279.196-.781.196-1.154h1.504",
    fill: "#004bb3"
  })), _path334 || (_path334 = /*#__PURE__*/React.createElement("path", {
    d: "M500.903 314.28s-.937 3.99-1.504 4.995c-.566 1-2.813 2.807-1.374 5.708",
    fill: "none",
    stroke: "#003",
    strokeWidth: 0.23187
  })), _path335 || (_path335 = /*#__PURE__*/React.createElement("path", {
    d: "M501.056 314.28s-.937 3.99-1.504 4.995c-.632 1.066-2.835 2.964-1.286 5.86",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path336 || (_path336 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 314.28s-.937 4.058-1.504 5.146c-.567 1.004-2.813 2.964-1.22 5.865",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path337 || (_path337 = /*#__PURE__*/React.createElement("path", {
    d: "M501.273 314.28s-.936 4.12-1.525 5.146c-.633 1.004-2.812 3.03-1.221 6.017",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path338 || (_path338 = /*#__PURE__*/React.createElement("path", {
    d: "M501.34 314.28s-.938 4.209-1.505 5.212c-.567 1-2.747 3.115-1.155 6.08",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path339 || (_path339 = /*#__PURE__*/React.createElement("path", {
    d: "M501.405 314.28s-.85 4.275-1.505 5.275c-.567 1.003-2.68 3.185-1.067 6.15",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path340 || (_path340 = /*#__PURE__*/React.createElement("path", {
    d: "M500.838 314.28s-.938 3.84-1.505 4.928c-.567 1.066-2.898 2.897-1.373 5.71",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path341 || (_path341 = /*#__PURE__*/React.createElement("path", {
    d: "M500.75 314.37s-.937 3.616-1.59 4.838c-.568 1.005-2.9 2.897-1.374 5.71",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path342 || (_path342 = /*#__PURE__*/React.createElement("path", {
    d: "M500.598 314.37s-.85 3.55-1.592 4.838c-.5 1.005-2.811 2.813-1.286 5.71",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path343 || (_path343 = /*#__PURE__*/React.createElement("path", {
    d: "M500.533 314.37s-.785 3.398-1.656 4.772c-.503 1.071-2.813 2.902-1.287 5.714",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path344 || (_path344 = /*#__PURE__*/React.createElement("path", {
    d: "M500.402 314.37s-.785 3.332-1.592 4.772c-.567 1.003-2.812 2.902-1.286 5.714",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path345 || (_path345 = /*#__PURE__*/React.createElement("path", {
    d: "M498.157 317.768c-.132.195-.349.285-.415.503-.13.128-.195.284-.283.502-.131.128-.196.279-.283.502-.197.413-.414.714-.567 1.155-.196.346-.349.714-.502 1.066-.065.285-.196.503-.283.787-.066.436 0 .782.065 1.217.197.501.72.787 1.221 1.072.066 0 .131.061.195.128.198.134.503.066.721.195.196.135.348.284.5.503.066.133.197.133.283.194.35.135.721.201 1.069.201h-.065l.065.062v-.062c0 .129.066.195.132.28.195.194.85.194 1.286.419.065.06.196.194.282.194.133 0 .285-.133.416-.194.349-.202 1.001-.202 1.22-.42.065-.06.13-.128.13-.279v.062-.062c.415 0 .72-.066 1.07-.2.13-.062.194-.062.282-.195.132-.195.283-.347.437-.503.282-.129.566-.061.85-.195.064-.068.13-.128.13-.128.502-.285 1.003-.57 1.221-1.072.13-.413.13-.781.066-1.217a2.843 2.843 0 0 0-.284-.787 5.71 5.71 0 0 0-.5-1.066c-.132-.418-.35-.72-.569-1.155-.065-.2-.13-.35-.282-.502-.066-.194-.197-.351-.283-.502-.067-.195-.284-.285-.416-.503",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path346 || (_path346 = /*#__PURE__*/React.createElement("path", {
    d: "m543.942 272.661-8.03 5.32c.087 2.508.089 3.323-.196 4.822-.15.501-.652 3.335-1.222 4.273h-.039l6.677 11.145c1.644-2.858 3-9.084 3-10.667 0-6.411.213-8.32-.19-14.893z",
    fill: "#fff"
  })), _path347 || (_path347 = /*#__PURE__*/React.createElement("path", {
    d: "M534.495 287.075c.569-.938 1.071-3.772 1.222-4.274.285-1.503.285-2.31.195-4.839l-4.927 3.184 3.47 5.93",
    fill: "#004bb3"
  })), _path348 || (_path348 = /*#__PURE__*/React.createElement("path", {
    d: "m530.51 280.404 23.277-15.216.42.567-23.2 15.434-.496-.785",
    fill: "#fc0"
  })), _path349 || (_path349 = /*#__PURE__*/React.createElement("path", {
    d: "m530.51 280.404 23.277-15.216.42.567-23.2 15.434-.496-.785",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path350 || (_path350 = /*#__PURE__*/React.createElement("path", {
    d: "M548.49 310.508c.57-.346 1.509-1.283 1.81-2.154.502-1.657.419-1.596.853-3.471.196-1.066.196-2.244.413-3.334.285-1.068 1.81-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.902-1.155-9.2-.72-13.276.134-1.068-.061-2.31-.061-3.467l-10.007 6.52c.413 6.67.195 8.545.195 14.997 0 1.592-1.372 7.891-3.03 10.726l7.322 12.25",
    fill: "#004bb3"
  })), _path351 || (_path351 = /*#__PURE__*/React.createElement("path", {
    d: "m541.231 298.236 7.328 12.25c.501-.347 1.5-1.284 1.74-2.155.57-1.657.503-1.657.854-3.465.285-1.071.347-2.248.503-3.338.28-1.068 1.808-4.622 1.875-6.016m.039-.022c-.062 1.373-1.59 4.84-1.876 5.93-.128 1.067-.194 2.244-.496 3.334-.351 1.809-.285 1.724-.854 3.466-.284.786-1.222 1.808-1.741 2.093l-7.327-12.098",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path352 || (_path352 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.373-1.59 4.773-1.876 5.865-.128 1.067-.194 2.244-.496 3.332-.351 1.724-.285 1.724-.854 3.466-.284.787-1.222 1.724-1.741 2.093 0 0-7.239-11.966-7.327-12.031m12.294-2.725c-.062 1.373-1.501 4.773-1.876 5.865-.128 1-.194 2.157-.496 3.248-.351 1.72-.285 1.658-.854 3.4-.284.786-1.222 1.724-1.741 2.025-.067.067-7.239-11.748-7.327-11.813",
    fill: "none",
    stroke: "#00004f",
    strokeWidth: 0.23187
  })), _path353 || (_path353 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.286-1.501 4.708-1.876 5.798-.128 1.068-.194 2.159-.496 3.182-.351 1.724-.285 1.724-.854 3.404-.284.782-1.222 1.719-1.741 2.093-.067 0-7.171-11.664-7.327-11.752m12.294-2.725c-.062 1.286-1.501 4.621-1.808 5.711-.195 1.004-.285 2.158-.564 3.185-.351 1.718-.285 1.718-.854 3.332-.284.787-1.222 1.724-1.741 2.092-.067 0-7.171-11.53-7.327-11.595",
    fill: "none",
    stroke: "#000051",
    strokeWidth: 0.23187
  })), _path354 || (_path354 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.286-1.501 4.556-1.808 5.646-.195 1.003-.285 2.158-.564 3.183-.351 1.658-.285 1.658-.854 3.337-.284.782-1.222 1.652-1.741 2.026-.134.067-7.171-11.38-7.327-11.446m12.294-2.747c-.062 1.286-1.501 4.557-1.808 5.582-.195 1.068-.285 2.158-.564 3.183-.351 1.656-.351 1.656-.854 3.246-.284.786-1.222 1.725-1.741 2.027-.195.066-7.11-11.224-7.327-11.312",
    fill: "none",
    stroke: "#000053",
    strokeWidth: 0.23187
  })), _path355 || (_path355 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.286-1.501 4.49-1.808 5.58-.195 1.003-.285 2.094-.564 3.118-.351 1.593-.351 1.593-.937 3.244-.285.721-1.156 1.598-1.658 1.944-.195.066-7.11-11.096-7.327-11.161m12.294-2.725c-.062 1.22-1.501 4.425-1.808 5.428-.195 1.068-.285 2.158-.564 3.182-.42 1.592-.351 1.592-.938 3.182-.284.721-1.155 1.658-1.657 1.943-.195.06-7.11-10.945-7.327-11.01m12.294-2.725c-.062 1.22-1.501 4.425-1.808 5.428-.195 1.002-.285 2.026-.564 3.03-.42 1.655-.351 1.655-.938 3.184-.284.781-1.155 1.657-1.657 1.936-.285.068-7.11-10.788-7.327-10.876",
    fill: "none",
    stroke: "#000056",
    strokeWidth: 0.23187
  })), _path356 || (_path356 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.22-1.434 4.338-1.808 5.363-.195 1.002-.285 2.092-.564 3.03-.42 1.591-.351 1.591-1.004 3.115-.285.787-1.071 1.658-1.591 1.942-.285.066-7.02-10.66-7.327-10.725m12.294-2.725c-.062 1.22-1.434 4.273-1.808 5.275-.195 1.003-.346 2.093-.564 2.964-.42 1.656-.351 1.656-1.004 3.186-.285.719-1.071 1.59-1.657 1.874-.195.129-6.888-10.443-7.239-10.574",
    fill: "none",
    stroke: "#000058",
    strokeWidth: 0.23187
  })), _path357 || (_path357 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 295.49c-.062 1.22-1.434 4.273-1.808 5.275-.195.938-.346 1.94-.564 2.9-.42 1.592-.351 1.592-1.004 3.116-.285.72-1.156 1.59-1.657 1.94-.285.068-6.888-10.354-7.239-10.506m12.21-2.725c0 1.155-1.373 4.207-1.724 5.21-.195.937-.346 1.962-.57 2.899-.412 1.59-.412 1.59-.998 3.12-.285.714-1.156 1.5-1.657 1.87-.286.067-6.887-10.221-7.238-10.353",
    fill: "none",
    stroke: "#00005c",
    strokeWidth: 0.23187
  })), _path358 || (_path358 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.49c0 1.155-1.373 4.12-1.724 5.145-.195.937-.346 1.94-.57 2.899-.412 1.588-.412 1.588-.998 3.03-.285.718-1.156 1.59-1.657 1.874-.352.067-6.804-10.07-7.238-10.223m12.187-2.725c0 1.068-1.373 4.054-1.724 5.057-.195 1.003-.346 1.94-.57 2.9-.412 1.503-.412 1.503-.998 2.965-.285.72-1.156 1.59-1.657 1.874-.352.13-6.804-9.918-7.238-10.071",
    fill: "none",
    stroke: "#00005e",
    strokeWidth: 0.23187
  })), _path359 || (_path359 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 1.155-1.373 4.12-1.724 5.143-.195.852-.346 1.875-.631 2.813-.412 1.502-.412 1.502-.937 2.897-.285.72-1.156 1.507-1.657 1.875-.352.133-6.804-9.785-7.238-9.917m12.187-2.811c0 1.155-1.373 4.054-1.724 4.991-.195.938-.346 1.94-.631 2.813-.412 1.503-.412 1.503-.937 2.965-.351.721-1.156 1.501-1.657 1.808-.413.129-6.804-9.635-7.238-9.787m12.187-2.79c0 1.155-1.288 3.989-1.724 4.991-.195.938-.346 1.875-.631 2.748-.412 1.5-.412 1.5-1.003 2.963-.286.631-1.067 1.44-1.591 1.724-.413.129-6.737-9.483-7.238-9.636",
    fill: "none",
    stroke: "#000060",
    strokeWidth: 0.23187
  })), _path360 || (_path360 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 1.155-1.288 3.901-1.657 4.926-.285.937-.413 1.874-.72 2.747-.413 1.505-.413 1.505-1.004 2.901-.285.63-1.067 1.434-1.59 1.719-.503.134-6.737-9.35-7.239-9.482m12.21-2.811c0 1.067-1.288 3.901-1.657 4.838-.285.938-.413 1.876-.72 2.747-.413 1.437-.413 1.437-1.004 2.81-.285.636-1.067 1.44-1.59 1.814-.503.061-6.737-9.266-7.239-9.42",
    fill: "none",
    stroke: "#000062",
    strokeWidth: 0.23187
  })), _path361 || (_path361 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 1.067-1.288 3.836-1.657 4.838-.285.85-.413 1.81-.72 2.682-.413 1.441-.413 1.441-1.004 2.747-.285.72-1.067 1.44-1.59 1.725-.503.194-6.67-8.984-7.239-9.202m12.21-2.79c0 1.067-1.288 3.836-1.657 4.773-.285.85-.413 1.81-.72 2.682-.413 1.374-.413 1.374-1.004 2.745-.285.653-1.067 1.374-1.59 1.657-.57.195-6.586-8.85-7.239-9.067",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path362 || (_path362 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 1.067-1.288 3.77-1.657 4.708-.285.85-.413 1.809-.72 2.594-.413 1.439-.502 1.439-1.004 2.747-.285.63-1.067 1.44-1.59 1.72-.57.133-6.586-8.761-7.239-8.98m12.21-2.79c0 1.068-1.288 3.684-1.657 4.622-.285.872-.413 1.81-.72 2.616-.413 1.35-.502 1.438-1.004 2.745-.347.57-1.067 1.374-1.59 1.658-.632.129-6.586-8.632-7.239-8.85",
    fill: "none",
    stroke: "#000268",
    strokeWidth: 0.23187
  })), _path363 || (_path363 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 1.002-1.222 3.618-1.657 4.621-.285.784-.413 1.656-.72 2.528-.413 1.374-.502 1.374-1.072 2.683-.279.63-1.066 1.372-1.5 1.657-.632.195-6.586-8.481-7.238-8.7m12.187-2.79c0 1.003-1.222 3.619-1.657 4.492-.285.85-.413 1.72-.72 2.593-.413 1.286-.502 1.373-1.072 2.591-.279.636-1.066 1.378-1.59 1.658-.564.2-6.452-8.325-7.171-8.543m12.21-2.79c0 1.002-1.222 3.552-1.657 4.49-.285.85-.413 1.657-.72 2.463-.413 1.374-.502 1.374-1.072 2.594-.346.63-1.066 1.373-1.59 1.657-.63.13-6.452-8.11-7.171-8.414",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path364 || (_path364 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .937-1.222 3.465-1.657 4.424-.285.785-.413 1.723-.72 2.464-.413 1.286-.502 1.374-1.072 2.591-.346.57-1.066 1.29-1.59 1.592-.63.2-6.452-7.977-7.171-8.26m12.21-2.811c0 .937-1.155 3.4-1.657 4.338-.285.784-.413 1.656-.72 2.462-.413 1.286-.502 1.374-1.072 2.53-.346.63-1.066 1.373-1.59 1.59-.63.195-6.384-7.825-7.171-8.109",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path365 || (_path365 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .937-1.155 3.4-1.657 4.338-.285.784-.413 1.591-.72 2.376-.413 1.22-.57 1.286-1.072 2.525-.346.57-1.066 1.29-1.59 1.508-.72.194-6.384-7.674-7.171-7.979m12.21-2.768c0 .937-1.155 3.334-1.657 4.272-.285.72-.413 1.591-.72 2.376-.413 1.22-.57 1.286-1.072 2.464-.346.563-1.132 1.221-1.59 1.59-.781.134-6.3-7.608-7.171-7.89",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path366 || (_path366 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .937-1.155 3.334-1.657 4.207-.285.784-.413 1.591-.72 2.31-.502 1.221-.57 1.286-1.072 2.46-.346.57-1.132 1.29-1.59 1.508-.781.284-6.3-7.39-7.171-7.674m12.21-2.811c0 .85-1.155 3.248-1.657 4.12-.285.784-.413 1.591-.787 2.31-.413 1.22-.502 1.286-1.065 2.465-.286.563-1.072 1.221-1.507 1.439-.782.28-6.302-7.24-7.172-7.544",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path367 || (_path367 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .85-1.155 3.182-1.657 4.054-.285.784-.413 1.592-.787 2.311-.413 1.22-.502 1.286-1.065 2.398-.352.566-1.072 1.219-1.591 1.504-.787.195-6.15-7.172-7.11-7.456m12.21-2.811c0 .85-1.155 3.117-1.657 3.989-.285.784-.413 1.592-.787 2.31-.413 1.156-.502 1.221-1.065 2.376-.352.503-1.072 1.157-1.591 1.441-.787.195-6.15-7.021-7.11-7.325m12.21-2.791c0 .85-1.155 3.117-1.657 3.989-.285.719-.413 1.504-.787 2.244-.413 1.157-.502 1.222-1.155 2.312-.285.5-1.004 1.152-1.501 1.437-.787.285-6.15-6.887-7.11-7.17",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path368 || (_path368 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .85-1.071 3.03-1.657 3.901-.285.72-.413 1.504-.787 2.246-.413 1.068-.564 1.155-1.155 2.245-.285.569-1.004 1.155-1.501 1.44-.854.195-6.083-6.671-7.11-7.02m12.21-2.812c0 .784-1.071 2.964-1.657 3.836-.285.72-.413 1.504-.787 2.159-.413 1.154-.564 1.22-1.155 2.31-.285.501-1.004 1.153-1.501 1.37-.854.285-6.083-6.514-7.11-6.885",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path369 || (_path369 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .784-1.071 2.899-1.657 3.836-.285.632-.413 1.373-.787 2.093-.413 1.068-.564 1.22-1.155 2.245-.285.501-1.004 1.155-1.501 1.373-.854.285-6.083-6.365-7.11-6.736m12.21-2.811c0 .784-1.071 2.899-1.657 3.683-.285.72-.413 1.504-.787 2.159-.413 1.068-.564 1.155-1.155 2.158-.285.501-1.004 1.157-1.501 1.374-.938.284-6.022-6.235-7.11-6.584",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path370 || (_path370 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .784-1.071 2.811-1.657 3.683-.285.633-.413 1.439-.787 2.093-.413 1.004-.63 1.155-1.155 2.158-.346.502-1.004 1.066-1.501 1.284-.938.285-6.022-6.079-7.11-6.45m12.21-2.768c0 .719-1.071 2.811-1.657 3.618-.285.72-.502 1.373-.787 2.093-.413 1.003-.63 1.068-1.155 2.093-.346.5-1.004 1.068-1.501 1.374-1.005.28-5.933-6.017-7.11-6.367",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path371 || (_path371 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .719-1.071 2.746-1.657 3.552-.285.634-.502 1.374-.787 2.094-.413 1.002-.63 1.068-1.155 2.093-.346.413-1.004 1.003-1.501 1.283-1.005.285-5.933-5.861-7.11-6.232m12.21-2.79c0 .719-1.071 2.68-1.657 3.465-.285.72-.502 1.373-.787 2.028-.413 1.002-.63 1.155-1.222 2.092-.279.415-.999 1.068-1.434 1.221-1.005.35-5.933-5.645-7.11-6.016m12.21-2.79c0 .631-1.004 2.593-1.657 3.465-.285.633-.502 1.286-.787 1.94-.413 1.004-.63 1.069-1.222 2.028-.279.501-.999 1.003-1.434 1.286-1.072.28-5.866-5.58-7.11-5.93",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path372 || (_path372 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .631-1.004 2.593-1.657 3.4-.285.566-.502 1.285-.787 1.94-.413.938-.63 1.069-1.222 1.94-.279.502-.999 1.003-1.434 1.287-1.072.35-5.866-5.428-7.11-5.8m12.21-2.767c0 .631-1.004 2.528-1.657 3.334-.285.634-.502 1.286-.787 1.875-.413 1.003-.63 1.07-1.222 2.027-.346.415-.999 1.003-1.434 1.221-1.072.284-5.866-5.21-7.11-5.646",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path373 || (_path373 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.425c0 .631-1.004 2.462-1.657 3.334-.285.567-.502 1.222-.787 1.81-.502 1.003-.72 1.068-1.222 2.026-.346.415-.999.938-1.434 1.157-1.156.348-5.782-5.058-7.11-5.494m12.21-2.833c0 .631-.937 2.375-1.595 3.182-.347.632-.564 1.286-.849 1.875-.502.938-.72 1.068-1.222 1.94-.346.414-.999.937-1.434 1.155-1.223.35-5.782-4.926-7.11-5.362",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path374 || (_path374 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .654-.937 2.463-1.595 3.27-.28.566-.564 1.221-.849 1.81-.502.937-.72 1.003-1.222 1.874-.346.415-.999.938-1.5 1.156-1.157.349-5.649-4.775-7.022-5.21m12.188-2.9c0 .654-.937 2.397-1.595 3.183-.28.567-.564 1.22-.938 1.81-.413.85-.63 1.003-1.217 1.809-.35.5-.937.937-1.44 1.155-1.155.349-5.647-4.622-7.02-5.058",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path375 || (_path375 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .654-.937 2.397-1.595 3.117-.28.567-.564 1.22-.938 1.81-.413.85-.63 1.003-1.217 1.81-.35.413-.937.85-1.44 1.068-1.221.414-5.647-4.426-7.02-4.927m12.21-2.878c0 .654-.937 2.245-1.595 3.03-.28.568-.564 1.22-.938 1.722-.413.85-.63 1.003-1.217 1.81-.35.414-.937.937-1.44 1.155-1.221.35-5.58-4.338-7.02-4.84m12.21-2.877c0 .654-.937 2.245-1.595 3.03-.28.501-.564 1.155-.938 1.657-.413.872-.63 1.003-1.217 1.81-.35.348-.937.85-1.44 1.068-1.221.348-5.58-4.208-7.02-4.71",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path376 || (_path376 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .567-.937 2.158-1.595 2.966-.28.5-.564 1.067-.938 1.655-.413.786-.714.938-1.284 1.723-.285.414-.848.85-1.373 1.003-1.289.414-5.58-3.99-7.02-4.49m12.21-2.857c0 .567-.853 2.158-1.595 2.9a16.81 16.81 0 0 1-.938 1.655c-.413.786-.714.938-1.284 1.658-.285.414-.848.85-1.373 1.068-1.289.414-5.513-3.902-7.02-4.426",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path377 || (_path377 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .502-.853 2.093-1.595 2.9-.28.5-.564 1.002-.938 1.591-.413.784-.714.937-1.284 1.592-.285.414-.938.85-1.373 1.067-1.289.414-5.513-3.77-7.02-4.272m12.21-2.878c0 .502-.853 2.027-1.595 2.747-.28.502-.564 1.155-.938 1.656-.413.72-.714.85-1.284 1.592a6.12 6.12 0 0 1-1.373 1.003c-1.372.348-5.513-3.619-7.02-4.12",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path378 || (_path378 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .502-.853 1.94-1.595 2.747-.28.502-.564 1.003-1 1.503-.35.786-.72.938-1.221 1.657-.347.349-.938.786-1.374.938-1.372.415-5.513-3.466-7.02-3.99m12.21-2.855c0 .502-.853 1.94-1.595 2.68-.28.502-.564 1.004-1 1.505-.35.72-.72.85-1.221 1.592-.347.349-.938.72-1.374.938-1.44.414-5.43-3.336-7.02-3.837",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path379 || (_path379 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .502-.853 1.875-1.595 2.594-.28.502-.564 1.004-1 1.504-.35.72-.72.85-1.221 1.505-.347.348-.938.718-1.374.936-1.44.415-5.363-3.182-7.02-3.77m12.21-2.769c0 .414-.853 1.875-1.595 2.529-.28.501-.564 1.002-1 1.439-.35.719-.72.937-1.221 1.504-.347.414-.938.784-1.374 1.003-1.44.348-5.363-3.117-7.02-3.685m12.21-2.79c0 .414-.853 1.722-1.595 2.463-.28.503-.564 1.003-1 1.44-.35.718-.72.849-1.289 1.504-.28.348-.938.719-1.283.85-1.508.5-5.363-2.812-7.021-3.467",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path380 || (_path380 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .414-.787 1.722-1.595 2.463-.28.415-.564.938-1 1.373-.413.633-.72.85-1.289 1.44-.345.348-.938.72-1.283.937-1.508.414-5.363-2.747-7.021-3.4m12.188-2.813c0 .414-.787 1.656-1.595 2.397-.28.415-.564.938-1 1.353-.413.632-.72.784-1.289 1.438-.345.283-.938.633-1.373.85-1.44.415-5.206-2.593-6.953-3.248",
    fill: "none",
    stroke: "#002f96",
    strokeWidth: 0.23187
  })), _path381 || (_path381 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .414-.787 1.656-1.595 2.31-.28.437-.564.939-1 1.374-.413.566-.787.785-1.289 1.374-.345.349-.938.632-1.373.85-1.5.413-5.206-2.463-6.953-3.118m12.21-2.79c0 .349-.787 1.592-1.595 2.245-.28.415-.564.938-1 1.287-.413.632-.787.85-1.289 1.373-.345.349-.938.632-1.373.85-1.59.5-5.206-2.31-6.953-2.965",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path382 || (_path382 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .349-.787 1.504-1.595 2.245a7.736 7.736 0 0 1-1 1.221c-.413.567-.787.784-1.289 1.286-.413.349-.938.72-1.373.85-1.59.415-5.145-2.157-6.953-2.812m12.21-2.79c0 .349-.787 1.439-1.595 2.158-.28.35-.564.785-1 1.221-.413.567-.787.785-1.289 1.286-.413.283-.938.633-1.373.786-1.59.5-5.078-2.029-6.953-2.683",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path383 || (_path383 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .349-.787 1.439-1.595 2.093-.28.348-.564.873-1 1.22-.413.567-.787.72-1.373 1.22-.35.35-.854.634-1.288.786-1.658.502-5.08-1.874-6.954-2.529m12.21-2.79c0 .349-.787 1.374-1.595 2.027-.28.414-.564.85-1 1.222-.413.5-.787.719-1.373 1.22a4.72 4.72 0 0 1-1.288.72c-1.658.5-5.08-1.723-6.954-2.377m12.21-2.812c0 .282-.72 1.374-1.595 1.94a6.865 6.865 0 0 1-1 1.221c-.501.502-.787.632-1.373 1.156-.35.283-.854.565-1.288.719-1.658.501-5.08-1.591-6.954-2.246",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path384 || (_path384 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .282-.72 1.22-1.595 1.94-.28.35-.632.72-1 1.068-.501.502-.853.72-1.373 1.156-.35.283-.854.566-1.372.785-1.658.501-4.928-1.44-6.892-2.159m12.232-2.79c0 .196-.72 1.22-1.595 1.875-.28.35-.632.72-1 1.068-.501.502-.853.72-1.373 1.069-.35.348-.854.632-1.372.718-1.658.567-4.928-1.22-6.892-1.94",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path385 || (_path385 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .196-.636 1.155-1.595 1.81a10.998 10.998 0 0 1-1 1.068c-.501.501-.853.632-1.373 1.068a7.715 7.715 0 0 1-1.372.72c-1.658.5-4.928-1.156-6.892-1.876m12.232-2.79c0 .196-.636 1.155-1.595 1.722a6.863 6.863 0 0 1-1.067 1.068c-.413.437-.786.633-1.283 1.069-.419.195-.938.501-1.378.632-1.72.501-4.839-1.003-6.887-1.723",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path386 || (_path386 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .196-.636 1.068-1.595 1.722-.28.283-.632.654-1.067 1.004-.413.413-.786.566-1.283 1.002-.419.196-.938.501-1.378.632-1.72.566-4.839-.85-6.887-1.592m12.21-2.768c0 .196-.636 1.003-1.595 1.656a16.002 16.002 0 0 1-1.067 1.004c-.413.348-.786.567-1.373.938-.35.282-.847.5-1.288.631-1.808.501-4.839-.72-6.887-1.439",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path387 || (_path387 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .13-.636.937-1.506 1.592-.346.282-.72.632-1.156.937-.413.414-.786.632-1.373.937-.35.283-.847.502-1.288.632-1.808.567-4.772-.567-6.887-1.286m12.21-2.812c0 .13-.636.937-1.506 1.504-.346.349-.72.632-1.156.937-.413.349-.847.567-1.373.938-.35.196-.847.414-1.288.567-1.808.566-4.772-.415-6.887-1.156m12.21-2.79c0 .13-.636.85-1.506 1.439-.346.282-.72.567-1.156.937-.413.349-.847.567-1.44.85-.346.196-.781.414-1.221.633-1.87.501-4.706-.35-6.887-1.069",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path388 || (_path388 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .13-.636.785-1.506 1.439-.346.196-.72.501-1.156.785-.413.414-.847.566-1.44.937-.346.196-.781.349-1.221.502-1.87.566-4.706-.132-6.954-.85m12.277-2.813c0 .13-.568.72-1.506 1.374-.346.282-.72.567-1.156.784-.413.35-.937.567-1.44.85-.346.197-.781.414-1.221.502-1.87.632-4.706 0-6.954-.72",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path389 || (_path389 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337s-.568.72-1.506 1.286c-.346.197-.72.567-1.156.785-.413.349-.937.567-1.44.784-.346.197-.781.35-1.221.567-1.937.567-4.622.13-6.954-.632m12.277-2.79c0 .065-.568.654-1.506 1.22-.346.284-.72.502-1.156.786-.413.282-.937.501-1.44.784-.346.132-.781.349-1.221.501-2.004.568-4.622.284-6.954-.501",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path390 || (_path390 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337c0 .065-.568.654-1.506 1.22-.346.196-.72.415-1.156.72-.413.283-.937.501-1.44.72-.346.195-.781.348-1.221.501-2.004.567-4.622.414-6.954-.349m12.277-2.812s-.568.502-1.506 1.155c-.346.196-.72.414-1.156.72-.413.195-.937.414-1.44.632-.346.195-.781.348-1.221.501-2.004.633-4.555.567-6.954-.196",
    fill: "none",
    stroke: "#0049af",
    strokeWidth: 0.23187
  })), _path391 || (_path391 = /*#__PURE__*/React.createElement("path", {
    d: "M553.508 295.337s-.568.502-1.506 1.068c-.346.197-.72.415-1.156.633-.413.282-.937.5-1.44.719-.434.13-.781.282-1.221.414-2.088.567-4.555.719-6.954-.066m12.277-2.768s-6.239 4.926-12.316 2.812",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path392 || (_path392 = /*#__PURE__*/React.createElement("path", {
    d: "M553.787 275.892s-1.216 7.913-1.718 9.07c-.35 1-2.902 5.491-6.737 6.516",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path393 || (_path393 = /*#__PURE__*/React.createElement("path", {
    d: "M553.787 275.892s-1.283 7.825-1.808 8.915c-.413 1.003-2.745 5.364-6.67 6.671",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path394 || (_path394 = /*#__PURE__*/React.createElement("path", {
    d: "M553.726 275.826s-1.289 7.76-1.813 8.981c-.497 1.003-2.59 5.08-6.58 6.671",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path395 || (_path395 = /*#__PURE__*/React.createElement("path", {
    d: "M553.726 275.826s-1.373 7.76-1.875 8.916c-.502 1.004-2.445 4.84-6.519 6.671",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path396 || (_path396 = /*#__PURE__*/React.createElement("path", {
    d: "M553.726 275.826s-1.506 7.673-2.032 8.764c-.496 1.068-2.31 4.708-6.384 6.802",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path397 || (_path397 = /*#__PURE__*/React.createElement("path", {
    d: "M553.726 275.826s-1.59 7.608-2.093 8.764c-.501 1.002-2.16 4.338-6.3 6.802",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path398 || (_path398 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66 275.826s-1.591 7.543-2.094 8.699c-.502 1.002-2.026 4.12-6.233 6.801",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path399 || (_path399 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66 275.826s-1.747 7.456-2.244 8.632c-.503 1.07-1.814 3.903-6.15 6.89",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path400 || (_path400 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66 275.826s-1.809 7.39-2.311 8.546c-.503 1.068-1.725 3.683-6.083 6.954",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path401 || (_path401 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66 275.76s-1.876 7.457-2.462 8.547c-.502 1.067-1.506 3.4-5.933 7.02",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path402 || (_path402 = /*#__PURE__*/React.createElement("path", {
    d: "M553.66 275.76s-1.943 7.326-2.529 8.48c-.502 1.069-1.373 3.184-5.865 7.02",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path403 || (_path403 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 275.76s-1.958 7.326-2.528 8.415c-.564 1.069-1.223 2.965-5.798 7.02",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path404 || (_path404 = /*#__PURE__*/React.createElement("path", {
    d: "M553.57 275.674s-2.027 7.324-2.68 8.393c-.568 1.068-1.07 2.747-5.646 7.107",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path405 || (_path405 = /*#__PURE__*/React.createElement("path", {
    d: "M553.291 271.03s-1.005 11.162-8.985 14.214",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path406 || (_path406 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 271.03s-.352 3.554-2.026 7.02c-1.222 2.68-3.338 5.711-6.892 7.171",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path407 || (_path407 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 271.03s-.503 3.619-2.092 7.02c-1.156 2.376-3.25 5.582-6.804 7.171",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path408 || (_path408 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 271.03c0 .066-.63 3.77-2.16 6.888-1.155 2.312-3.248 5.582-6.736 7.238",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path409 || (_path409 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 271.03c0 .066-.787 3.837-2.31 6.888-1.005 2.094-3.12 5.494-6.586 7.173",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path410 || (_path410 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 271.03c-.067.131-.854 3.99-2.377 6.801-.938 1.876-3.03 5.43-6.519 7.238",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path411 || (_path411 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 271.03c0 .131-.937 4.055-2.376 6.736-.85 1.744-2.964 5.363-6.452 7.326",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path412 || (_path412 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 270.965c0 .196-1.065 4.207-2.46 6.736-.788 1.504-2.903 5.276-6.368 7.326",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path413 || (_path413 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 270.965c-.061.196-1.221 4.338-2.528 6.67-.787 1.44-2.812 5.276-6.3 7.39",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path414 || (_path414 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 270.965c-.061.283-1.283 4.425-2.679 6.67-.636 1.156-2.661 5.145-6.15 7.39",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path415 || (_path415 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 270.965c-.128.283-1.44 4.49-2.745 6.604-.57 1.004-2.595 5.06-6.083 7.391",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path416 || (_path416 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 270.965c-.067.283-1.507 4.622-2.751 6.518-.503.785-2.528 4.992-6.016 7.455",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path417 || (_path417 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 270.965c-.067.283-1.657 4.709-2.902 6.452-.413.633-2.377 4.993-5.864 7.544",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path418 || (_path418 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 267.914s-2.31 8.98-8.761 11.16",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path419 || (_path419 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 267.914s-.854 3.182-3.03 6.234c-1.373 2.093-3.404 4.12-5.715 4.926",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path420 || (_path420 = /*#__PURE__*/React.createElement("path", {
    d: "M553.224 267.914s-.938 3.117-3.12 6.146c-1.44 2.093-3.465 4.273-5.641 4.993",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path421 || (_path421 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.848s-.937 3.117-3.03 6.147c-1.501 2.158-3.684 4.338-5.731 5.058",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path422 || (_path422 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.782s-.937 3.03-3.113 6.235c-1.597 2.092-3.773 4.425-5.648 5.057",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path423 || (_path423 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.782s-.998 2.965-3.248 6.083c-1.59 2.223-3.834 4.556-5.513 5.144",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path424 || (_path424 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.782s-.998 2.965-3.331 6.017c-1.657 2.31-3.99 4.708-5.43 5.21",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path425 || (_path425 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.695s-1.065 2.965-3.331 6.017c-1.725 2.31-4.124 4.84-5.43 5.275",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path426 || (_path426 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.695s-1.065 2.812-3.465 5.929c-1.719 2.377-4.208 4.927-5.296 5.276",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path427 || (_path427 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.695s-1.155 2.747-3.554 5.865c-1.808 2.376-4.336 5.056-5.207 5.362",
    fill: "none",
    stroke: "#002f96",
    strokeWidth: 0.23187
  })), _path428 || (_path428 = /*#__PURE__*/React.createElement("path", {
    d: "M553.134 267.63s-1.221 2.747-3.616 5.864c-1.875 2.375-4.425 5.21-5.145 5.428",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path429 || (_path429 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 267.63s-1.16 2.68-3.556 5.864c-1.941 2.375-4.559 5.21-5.211 5.428",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path430 || (_path430 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 267.63s-1.222 2.593-3.69 5.71c-1.873 2.53-4.62 5.43-5.077 5.582",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path431 || (_path431 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 267.564s-1.222 2.594-3.772 5.711c-1.942 2.529-4.777 5.582-4.995 5.646",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path432 || (_path432 = /*#__PURE__*/React.createElement("path", {
    d: "M553.073 267.476s-1.222 2.53-3.84 5.713c-2.025 2.594-4.927 5.646-4.927 5.646m-8.439 1.351-4.425.785m3.99 2.55-3.99-1.656",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path433 || (_path433 = /*#__PURE__*/React.createElement("path", {
    d: "m535.935 280.251-4.426.72",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path434 || (_path434 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 280.47-4.425.501",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path435 || (_path435 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 280.622-4.425.349",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path436 || (_path436 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 280.753-4.486.282",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path437 || (_path437 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 280.971-4.486.065",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path438 || (_path438 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 281.124-4.553-.066",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path439 || (_path439 = /*#__PURE__*/React.createElement("path", {
    d: "m535.867 281.276-4.62-.197",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path440 || (_path440 = /*#__PURE__*/React.createElement("path", {
    d: "m535.807 281.407-4.56-.283",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path441 || (_path441 = /*#__PURE__*/React.createElement("path", {
    d: "m535.807 281.56-4.621-.414",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path442 || (_path442 = /*#__PURE__*/React.createElement("path", {
    d: "m535.522 283.303-4.058-1.504",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path443 || (_path443 = /*#__PURE__*/React.createElement("path", {
    d: "m535.522 283.15-4.12-1.438",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path444 || (_path444 = /*#__PURE__*/React.createElement("path", {
    d: "m535.522 283.02-4.12-1.374",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path445 || (_path445 = /*#__PURE__*/React.createElement("path", {
    d: "m535.589 282.801-4.275-1.22",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path446 || (_path446 = /*#__PURE__*/React.createElement("path", {
    d: "m535.589 282.65-4.342-1.156",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path447 || (_path447 = /*#__PURE__*/React.createElement("path", {
    d: "m535.589 282.498-4.342-1.07",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path448 || (_path448 = /*#__PURE__*/React.createElement("path", {
    d: "m535.65 282.28-4.487-.851",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path449 || (_path449 = /*#__PURE__*/React.createElement("path", {
    d: "m535.717 282.061-4.554-.785",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path450 || (_path450 = /*#__PURE__*/React.createElement("path", {
    d: "m535.717 281.93-4.62-.654",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path451 || (_path451 = /*#__PURE__*/React.createElement("path", {
    d: "m535.717 281.777-4.71-.565",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path452 || (_path452 = /*#__PURE__*/React.createElement("path", {
    d: "M548.49 310.508c.57-.346 1.509-1.283 1.81-2.154.502-1.657.419-1.596.853-3.471.196-1.066.196-2.244.413-3.334.285-1.068 1.81-4.621 1.875-6.016.129-4.622 1.658-7.76 1.284-12.753-.28-3.902-1.155-9.2-.72-13.276.134-1.068-.061-2.31-.061-3.467l-22.976 15.217",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path453 || (_path453 = /*#__PURE__*/React.createElement("path", {
    d: "M554.161 264.883c.195-.85-.066-2.03-.72-2.157 0 0-.501-.134-.786-.068-.347 0-.413.13-.565.437-.35.784.565 1.286 1.285 1.504.133.066.569.131.63.349.134.349.067.197.134.349-.134-.065-.134-.196-.285-.283-.501-.283-1.004-.35-1.74-.72-.503-.195-.57-1.373-.201-1.658.419-.345 1.746-.284 2.03 0 .564.72.631 1.724.502 2.682 0-.194-.284-.13-.284-.414",
    fill: "#fc0"
  })), _path454 || (_path454 = /*#__PURE__*/React.createElement("path", {
    d: "M554.161 264.883c.195-.85-.066-2.03-.72-2.157 0 0-.501-.134-.786-.068-.347 0-.413.13-.565.437-.35.784.565 1.286 1.285 1.504.133.066.569.131.63.349.134.349.067.197.134.349-.134-.065-.134-.196-.285-.283-.501-.283-1.004-.35-1.74-.72-.503-.195-.57-1.373-.201-1.658.419-.345 1.746-.284 2.03 0 .564.72.631 1.724.502 2.682 0-.194-.284-.13-.284-.414z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path455 || (_path455 = /*#__PURE__*/React.createElement("path", {
    d: "M554.53 265.318c.938 0 2.026.349 2.093.938 0 .131.066.633 0 .85-.068.349-.129.501-.503.567-.847.197-1.216-.784-1.373-1.505 0-.13-.06-.566-.195-.718-.346-.132-.285-.067-.346-.132.061.065.128.132.195.284.196.501.285 1.069.503 1.81.128.567 1.217.784 1.59.436.413-.35.503-1.657.285-1.94-.636-.72-1.596-.938-2.595-.938.194.065.128.413.345.348",
    fill: "#fc0"
  })), _path456 || (_path456 = /*#__PURE__*/React.createElement("path", {
    d: "M554.53 265.318c.938 0 2.026.349 2.093.938 0 .131.066.633 0 .85-.068.349-.129.501-.503.567-.847.197-1.216-.784-1.373-1.505 0-.13-.06-.566-.195-.718-.346-.132-.285-.067-.346-.132.061.065.128.132.195.284.196.501.285 1.069.503 1.81.128.567 1.217.784 1.59.436.413-.35.503-1.657.285-1.94-.636-.72-1.596-.938-2.595-.938.194.065.128.413.345.348",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path457 || (_path457 = /*#__PURE__*/React.createElement("path", {
    d: "M554.725 264.948c.2.13.2.414.134.632-.134.197-.502.283-.63.13-.351-.13-.57-.565-.351-.85.194-.282.568-.065.847.067",
    fill: "#fc0"
  })), _path458 || (_path458 = /*#__PURE__*/React.createElement("path", {
    d: "M554.725 264.948c.2.13.2.414.134.632-.134.197-.502.283-.63.13-.351-.13-.57-.565-.351-.85.194-.282.568-.065.847.067z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path459 || (_path459 = /*#__PURE__*/React.createElement("path", {
    d: "M559.586 261.833s-2.372.998-4.425.998c0 0-.129 1.724-.497 2.226 0 0 1.808-.282 2.595.065 0 0 .999-2.373 2.31-3.334",
    fill: "#fc0"
  })), _path460 || (_path460 = /*#__PURE__*/React.createElement("path", {
    d: "M559.586 261.833s-2.372.998-4.425.998c0 0-.129 1.724-.497 2.226 0 0 1.808-.282 2.595.065 0 0 .999-2.373 2.31-3.334z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path461 || (_path461 = /*#__PURE__*/React.createElement("path", {
    d: "M557.65 263.05s-.938.418-1.747.418c0 0-.061.63-.195.848 0 0 .72-.065 1.003.065 0 0 .347-1.003.938-1.354z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path462 || (_path462 = /*#__PURE__*/React.createElement("path", {
    d: "M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068-.564.72-.63 2.158-.63 2.593.563.197 1.154.569 2.092.066.346-.195.129-.784-.067-1.286 0-.283-.068-1.002-.413-1.374",
    fill: "#fc0"
  })), _path463 || (_path463 = /*#__PURE__*/React.createElement("path", {
    d: "M554.53 266.823s-.414-.785-.565-1.068c-.066-.13.063.937-.35 1.068-.564.72-.63 2.158-.63 2.593.563.197 1.154.569 2.092.066.346-.195.129-.784-.067-1.286 0-.283-.068-1.002-.413-1.374z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path464 || (_path464 = /*#__PURE__*/React.createElement("path", {
    d: "M554.095 266.19c0 .132-.068.633-.068.567 0-.196-.195.197-.279.283-.35.655-.419 1.07-.569 2.311m.698-2.092c-.195.937-.346.937-.346 2.245l-.067-.065m.48-1.308c-.195.632-.195 1.003-.195 1.373l.279.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path465 || (_path465 = /*#__PURE__*/React.createElement("path", {
    d: "M531.945 314.213c-1.876 1.658-5.275 2.528-5.86 2.97-1.223.847-3.03 2.153-6.085 2.31-2.31.195-3.335-.419-5.646-.72-2.66-.285.283.128-2.223-.42-1.287-.344-1.287-.562-3.03-.93-1.287-.352-2.595-.637-3.401-1.725-.35-.413-.633-.787-.633-1.44h-1.722c-.13.503.349 1.44.502 1.808.065.135.349.436.414.659.282.496.196.345.719.781.065.067.633.57.785.631.349.285.632.57 1.003.636 1.722.279 2.529.63 4.12 1.155 1.57.413.719.346 1.94.631.501.129 1.723.569 2.31.63 1.069.195 1.222.352 2.312.57 2.811.63 5.582.502 8.328.285 1.155-.068 3.99-.637 4.927-1.29 1.72-1.222 5.581-1.719 7.238-2.896.28-.134 1.284-.637 1.502-.854 1.59-1.373 2.963-1.72 4.71-2.813h-12.25",
    fill: "#004bb3"
  })), _path466 || (_path466 = /*#__PURE__*/React.createElement("path", {
    d: "M518.54 314.213c-1.222.636-1.81 1.658-5.21 2.746-1.287 0-2.748.57-3.99.502 1.526.352 1.526.57 2.747.855 2.528.562-.415.128 2.223.413 2.311.284 3.335.937 5.647.72 3.03-.135 4.838-1.44 6.083-2.311.563-.413 3.99-1.29 5.865-2.97h-13.409",
    fill: "#fff"
  })), _path467 || (_path467 = /*#__PURE__*/React.createElement("path", {
    d: "M518.54 314.213h-13.56c0 .636.283 1.005.633 1.44.784 1.072 2.091 1.374 3.4 1.725 1.373.279 2.812-.42 4.272-.42 3.554-1.064 3.99-2.242 5.211-2.745",
    fill: "#004bb3"
  })), _path468 || (_path468 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 314.213s2.371.135 2.528.135c.127 0 9.699-.135 9.699-.135",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path469 || (_path469 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 314.28s2.31.13 2.59.195c.2.068 9.637-.127 9.637-.127",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path470 || (_path470 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 314.37s2.31.195 2.59.279c.418 0 9.509-.279 9.509-.279",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path471 || (_path471 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 314.37s2.176.279 2.679.346c.501.133 9.352-.284 9.352-.284",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path472 || (_path472 = /*#__PURE__*/React.createElement("path", {
    d: "M531.599 314.43s2.16.286 2.745.42c.631.128 9.264-.42 9.264-.42",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path473 || (_path473 = /*#__PURE__*/React.createElement("path", {
    d: "M531.599 314.43s2.092.42 2.812.57c.781.129 9.197-.502 9.197-.502",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path474 || (_path474 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 314.43s2.092.503 2.963.721c.854.195 8.985-.564 8.985-.564",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path475 || (_path475 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 314.499s2.026.569 2.963.786c1.004.128 8.918-.72 8.918-.72",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path476 || (_path476 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 314.587s1.942.63 3.03.848c1.156.196 8.851-.786 8.851-.786",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path477 || (_path477 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 314.587s1.875.72 3.119.999c1.155.201 8.634-.848 8.634-.848",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path478 || (_path478 = /*#__PURE__*/React.createElement("path", {
    d: "M531.532 314.649s1.808.787 3.18 1.004c1.29.285 8.483-.937 8.483-.937",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path479 || (_path479 = /*#__PURE__*/React.createElement("path", {
    d: "M544 314.213h-12.334",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path480 || (_path480 = /*#__PURE__*/React.createElement("path", {
    d: "M543.128 314.805s-6.953 1.284-8.416 1c-1.434-.28-3.248-1.156-3.248-1.156",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path481 || (_path481 = /*#__PURE__*/React.createElement("path", {
    d: "M529.94 319.643s-4.491.632-4.642.632c-.067 0-2.528-.195-2.66-.195l-2.18-.503",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path482 || (_path482 = /*#__PURE__*/React.createElement("path", {
    d: "M530.136 319.577s-4.554.72-4.838.636c-.195-.068-2.445-.201-2.594-.201-.131 0-2.029-.413-2.029-.413",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path483 || (_path483 = /*#__PURE__*/React.createElement("path", {
    d: "M530.443 319.447s-4.71.783-5.145.632c-.285 0-2.377-.129-2.528-.129-.197 0-1.876-.434-1.876-.434",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path484 || (_path484 = /*#__PURE__*/React.createElement("path", {
    d: "M530.66 319.292s-4.776.854-5.43.72c-.345 0-2.16-.128-2.46-.128-.197-.068-1.658-.352-1.658-.352",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path485 || (_path485 = /*#__PURE__*/React.createElement("path", {
    d: "M530.946 319.23s-4.928.849-5.715.721c-.413-.068-2.093-.134-2.377-.201-.28 0-1.503-.195-1.503-.195",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path486 || (_path486 = /*#__PURE__*/React.createElement("path", {
    d: "M531.163 319.074s-4.994 1.005-6.016.787c-.502-.067-1.875-.128-2.31-.194-.352 0-1.289-.196-1.289-.196",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path487 || (_path487 = /*#__PURE__*/React.createElement("path", {
    d: "M531.443 319.013s-5.14.999-6.296.781c-.57-.061-1.814-.195-2.249-.195-.413-.068-1.22-.128-1.22-.128",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path488 || (_path488 = /*#__PURE__*/React.createElement("path", {
    d: "M531.666 318.923s-5.213 1.066-6.52.787a13.936 13.936 0 0 0-2.248-.194c-.413-.068-1-.068-1-.068",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path489 || (_path489 = /*#__PURE__*/React.createElement("path", {
    d: "m529.634 319.794-4.336.57-2.66-.134-2.311-.564",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path490 || (_path490 = /*#__PURE__*/React.createElement("path", {
    d: "M531.945 318.795s-5.363 1.155-6.888.848c-1.439-.284-2.964-.284-2.964-.284m-11.4.09s-2.748-1.005-4.209-1.507c-2.594-.999-2.9-3.617-2.9-3.617m7.412 4.253s-1.656-.636-3.03-1.156c-3.77-1.44-3.335-3.185-3.335-3.185",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path491 || (_path491 = /*#__PURE__*/React.createElement("path", {
    d: "M511.28 318.706s-2.245-.787-3.335-1.222c-.633-.195-1.439-.564-1.722-.782-.502-.284-1.157-.937-1.286-1.221-.35-.503-.415-1.223-.415-1.223",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path492 || (_path492 = /*#__PURE__*/React.createElement("path", {
    d: "M511.498 318.923s-2.747-1.003-3.553-1.372c-.501-.129-1.439-.57-1.722-.72-.35-.285-1.222-.937-1.374-1.155-.197-.413-.414-1.44-.414-1.44",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path493 || (_path493 = /*#__PURE__*/React.createElement("path", {
    d: "M511.781 319.074s-3.335-1.155-3.836-1.373c-.283-.128-1.505-.63-1.722-.72-.197-.128-1.286-1.066-1.44-1.217-.13-.2-.436-1.506-.436-1.506",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path494 || (_path494 = /*#__PURE__*/React.createElement("path", {
    d: "M511.998 319.292s-3.836-1.373-4.053-1.5c-.197-.069-1.592-.57-1.657-.632-.131-.067-1.504-1.155-1.504-1.222-.066-.134-.567-1.59-.567-1.59",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path495 || (_path495 = /*#__PURE__*/React.createElement("path", {
    d: "M510.996 319.447s-3.334-1.221-4.49-1.656c-.785-.285-1.657-1.005-2.027-1.506-.567-.782-.785-1.937-.785-1.937",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path496 || (_path496 = /*#__PURE__*/React.createElement("path", {
    d: "M511.346 319.447s-4.055-1.438-4.928-1.807c-.567-.201-1.657-1.071-1.874-1.44-.436-.57-.785-1.875-.785-1.875",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path497 || (_path497 = /*#__PURE__*/React.createElement("path", {
    d: "M511.65 319.516s-4.708-1.814-5.21-1.943c-.414-.134-1.656-1.155-1.809-1.373-.349-.413-.719-1.875-.719-1.875",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path498 || (_path498 = /*#__PURE__*/React.createElement("path", {
    d: "M511.934 319.516s-5.276-2.032-5.582-2.094c-.194-.067-1.656-1.16-1.72-1.289-.132-.195-.634-1.808-.634-1.808",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path499 || (_path499 = /*#__PURE__*/React.createElement("path", {
    d: "m512.218 319.516-5.93-2.25-1.592-1.222-.566-1.719",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path500 || (_path500 = /*#__PURE__*/React.createElement("path", {
    d: "M505.328 314.213s2.53.135 2.682.135c.131 0 10.071-.135 10.071-.135",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path501 || (_path501 = /*#__PURE__*/React.createElement("path", {
    d: "M505.328 314.28s2.464.13 2.682.195c.283.068 10.005-.127 10.005-.127",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path502 || (_path502 = /*#__PURE__*/React.createElement("path", {
    d: "M505.263 314.37s2.441.195 2.813.279c.348 0 9.853-.279 9.853-.279",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path503 || (_path503 = /*#__PURE__*/React.createElement("path", {
    d: "M505.263 314.37s2.377.279 2.9.346c.5.133 9.7-.284 9.7-.284",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path504 || (_path504 = /*#__PURE__*/React.createElement("path", {
    d: "M505.263 314.43s2.223.286 2.9.42c.633.128 9.635-.42 9.635-.42",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path505 || (_path505 = /*#__PURE__*/React.createElement("path", {
    d: "M505.263 314.43s2.158.42 2.965.57c.72.129 9.505-.502 9.505-.502",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path506 || (_path506 = /*#__PURE__*/React.createElement("path", {
    d: "M505.177 314.43s2.157.503 3.03.721c.936.195 9.416-.564 9.416-.564",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path507 || (_path507 = /*#__PURE__*/React.createElement("path", {
    d: "M505.177 314.499s2.092.569 3.117.786c1.003.128 9.264-.72 9.264-.72",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path508 || (_path508 = /*#__PURE__*/React.createElement("path", {
    d: "M505.177 314.587s2.004.63 3.117.848c1.155.196 9.199-.786 9.199-.786",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path509 || (_path509 = /*#__PURE__*/React.createElement("path", {
    d: "M505.177 314.587s1.94.72 3.182.999c1.286.201 9.07-.848 9.07-.848",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path510 || (_path510 = /*#__PURE__*/React.createElement("path", {
    d: "M505.177 314.649s1.787.787 3.247 1.004c1.374.285 8.917-.937 8.917-.937",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path511 || (_path511 = /*#__PURE__*/React.createElement("path", {
    d: "M518.169 314.213h-12.754",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path512 || (_path512 = /*#__PURE__*/React.createElement("path", {
    d: "M517.23 314.805s-7.17 1.284-8.697 1c-1.504-.28-3.4-1.156-3.4-1.156",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path513 || (_path513 = /*#__PURE__*/React.createElement("path", {
    d: "M503.214 314.213c-.131.503.348 1.44.501 1.814.066.129.35.436.415.653.283.503.195.346.72.781.065.068.631.57.783.636.35.28.634.564 1.004.632 1.722.284 2.529.63 4.12 1.155 1.569.413.72.346 1.94.63.502.134 1.722.569 2.31.63 1.07.202 1.221.352 2.311.57 2.813.63 5.58.502 8.325.285 1.156-.067 3.99-.632 4.928-1.29 1.724-1.215 5.582-1.718 7.238-2.896.285-.134 1.29-.63 1.508-.854 1.59-1.373 2.962-1.719 4.704-2.807",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path514 || (_path514 = /*#__PURE__*/React.createElement("path", {
    d: "M474.721 277.2c-1.438-3.554-2.964-10.944-2.899-12.623.35-6.89.197-8.984.85-16.087l7.173 8.197c-.197 2.679-.197 3.55 0 5.274.064.63.436 3.771.938 4.993l-6.083 10.224",
    fill: "#fff"
  })), _path515 || (_path515 = /*#__PURE__*/React.createElement("path", {
    d: "M480.804 266.976c-.502-1.221-.85-4.34-.938-4.992-.195-1.724-.195-2.596 0-5.274l4.339 4.838-3.401 5.427m-18.203 6.671c-.066-1.591-.196-3.335-.196-4.12 0-4.992-.567-7.76 0-13.056.414-4.125 1.439-9.638 1.22-14.064-.065-1.283.131-2.528.196-3.773l8.85 9.857c-.63 7.103-.5 9.196-.849 16.087-.065 1.657 1.44 9.07 2.9 12.622l-1.875 3.183-10.224-6.736",
    fill: "#004bb3"
  })), _path516 || (_path516 = /*#__PURE__*/React.createElement("path", {
    d: "m484.858 260.896-20.817-23.066-.415.502 20.6 23.194.632-.63",
    fill: "#fc0"
  })), _path517 || (_path517 = /*#__PURE__*/React.createElement("path", {
    d: "m484.858 260.896-20.817-23.066-.415.502 20.6 23.194.632-.63",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path518 || (_path518 = /*#__PURE__*/React.createElement("path", {
    d: "M464.258 244.259s1.656 14.565 7.325 13.997",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path519 || (_path519 = /*#__PURE__*/React.createElement("path", {
    d: "M471.583 258.188c-2.813.135-4.71-3.465-5.712-6.797-1.068-3.471-1.592-7.177-1.592-7.177",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path520 || (_path520 = /*#__PURE__*/React.createElement("path", {
    d: "M471.583 258.188c-2.813-.128-4.71-3.773-5.647-6.887-1.155-3.336-1.657-7.11-1.657-7.11",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path521 || (_path521 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 258.127c-2.9-.2-4.774-3.99-5.712-6.96-1.068-3.18-1.59-6.953-1.656-7.013",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path522 || (_path522 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 258.06c-2.9-.413-4.774-4.209-5.647-6.954-1.068-3.119-1.656-6.892-1.743-7.02",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path523 || (_path523 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 257.971c-2.9-.564-4.774-4.487-5.582-6.953-1.067-3.031-1.72-6.888-1.809-7.021",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path524 || (_path524 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 257.971c-2.812-.781-4.774-4.771-5.515-7.02-1.069-2.964-1.788-6.798-1.788-6.954",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path525 || (_path525 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 257.91c-2.9-.938-4.84-4.996-5.582-7.11-1.003-2.813-1.787-6.736-1.787-6.888",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path526 || (_path526 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 257.91c-2.9-1.223-4.84-5.28-5.43-7.178-1.155-2.745-1.939-6.668-1.939-6.886",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path527 || (_path527 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 257.754c-2.813-1.284-4.84-5.426-5.43-7.105-1.067-2.684-1.939-6.585-1.939-6.892",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path528 || (_path528 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 257.754c-2.813-1.502-4.84-5.8-5.364-7.172-1.068-2.595-2.005-6.518-2.005-6.803",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path529 || (_path529 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 257.686c-2.813-1.651-4.84-6.016-5.276-7.17-1.068-2.529-2.093-6.52-2.093-6.799",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path530 || (_path530 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 257.686c-2.898-1.874-4.927-6.295-5.362-7.322-1.003-2.31-2.027-6.367-2.092-6.735",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path531 || (_path531 = /*#__PURE__*/React.createElement("path", {
    d: "M464.346 243.606c.065.351 1.067 4.426 2.157 6.67.35.785 2.377 5.211 5.275 7.237",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path532 || (_path532 = /*#__PURE__*/React.createElement("path", {
    d: "M464.476 240.927s4.708 11.597 7.76 10.286",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path533 || (_path533 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.235c-1.286.569-3.248-1.719-4.84-4.487a76.8 76.8 0 0 1-2.898-5.804",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path534 || (_path534 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.169c-1.155.501-3.182-1.652-4.773-4.488a77.23 77.23 0 0 1-2.965-5.798",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path535 || (_path535 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.169c-1.003.44-3.117-1.652-4.773-4.555-1.81-3.248-2.9-5.708-2.9-5.708",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path536 || (_path536 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.169c-.784.283-3.03-1.652-4.621-4.622-1.962-3.399-3.03-5.708-3.03-5.708",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path537 || (_path537 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.084c-.632.285-2.964-1.59-4.621-4.62-1.962-3.556-3.03-5.715-3.03-5.715",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path538 || (_path538 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.084c-.5.195-2.899-1.59-4.556-4.776-2.027-3.617-3.117-5.643-3.117-5.643",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path539 || (_path539 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.084c-.282.129-2.812-1.59-4.556-4.838-2.027-3.84-3.03-5.582-3.03-5.582",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path540 || (_path540 = /*#__PURE__*/React.createElement("path", {
    d: "M472.236 251.084c-.13 0-2.747-1.59-4.49-4.838-2.093-4.057-3.118-5.648-3.118-5.648",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path541 || (_path541 = /*#__PURE__*/React.createElement("path", {
    d: "M464.628 240.576s1.003 1.373 3.117 5.49c1.81 3.406 4.491 4.93 4.491 4.93m7.63 8.002 3.902 2.16m-3.684 1.612 3.684-.636",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path542 || (_path542 = /*#__PURE__*/React.createElement("path", {
    d: "m479.715 259.215 4.053 1.943",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path543 || (_path543 = /*#__PURE__*/React.createElement("path", {
    d: "m479.715 259.366 4.119 1.875",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path544 || (_path544 = /*#__PURE__*/React.createElement("path", {
    d: "m479.715 259.583 4.119 1.658",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path545 || (_path545 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 259.718 4.12 1.59",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path546 || (_path546 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 259.868 4.12 1.44",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path547 || (_path547 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 260.086 4.207 1.223",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path548 || (_path548 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 260.237 4.207 1.155",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path549 || (_path549 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 260.46 4.272.932",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path550 || (_path550 = /*#__PURE__*/React.createElement("path", {
    d: "m479.78 260.589 4.272.847",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path551 || (_path551 = /*#__PURE__*/React.createElement("path", {
    d: "m480.085 262.615 3.683-.565",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path552 || (_path552 = /*#__PURE__*/React.createElement("path", {
    d: "m480.085 262.397 3.771-.413",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path553 || (_path553 = /*#__PURE__*/React.createElement("path", {
    d: "m479.997 262.179 3.903-.285",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path554 || (_path554 = /*#__PURE__*/React.createElement("path", {
    d: "m479.997 262.05 3.903-.133",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path555 || (_path555 = /*#__PURE__*/React.createElement("path", {
    d: "M479.931 261.833h4.056",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path556 || (_path556 = /*#__PURE__*/React.createElement("path", {
    d: "m479.931 261.615 4.056.128",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path557 || (_path557 = /*#__PURE__*/React.createElement("path", {
    d: "m479.931 261.391 4.12.286",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path558 || (_path558 = /*#__PURE__*/React.createElement("path", {
    d: "m479.931 261.241 4.208.351",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path559 || (_path559 = /*#__PURE__*/React.createElement("path", {
    d: "m479.931 261.023 4.274.57",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path560 || (_path560 = /*#__PURE__*/React.createElement("path", {
    d: "m479.866 260.806 4.339.72",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path561 || (_path561 = /*#__PURE__*/React.createElement("path", {
    d: "M462.601 273.646c-.066-1.155-.13-2.377-.13-3.117.064-4.992-.634-8.763-.066-14.059.414-4.125 1.439-9.638 1.22-14.064-.065-1.283.131-2.528.196-3.773l20.384 22.915",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path562 || (_path562 = /*#__PURE__*/React.createElement("path", {
    d: "M462.601 261.894s.196 3.033.937 4.34c.938 1.875 3.772 4.621 7.02 6.671",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path563 || (_path563 = /*#__PURE__*/React.createElement("path", {
    d: "M470.645 272.927c-2.092-1.374-3.967-3.03-5.275-4.491-.72-.785-1.287-1.591-1.723-2.245-.632-1.286-.937-4.336-.937-4.336",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path564 || (_path564 = /*#__PURE__*/React.createElement("path", {
    d: "M470.733 272.927c-2.094-1.374-3.99-3.183-5.276-4.622-.633-.719-1.286-1.504-1.592-2.158-.785-1.373-1.134-4.337-1.134-4.337",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path565 || (_path565 = /*#__PURE__*/React.createElement("path", {
    d: "M470.798 272.927c-2.093-1.374-3.99-3.248-5.21-4.622-.634-.784-1.22-1.592-1.657-2.31-.785-1.374-1.221-4.34-1.221-4.34",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path566 || (_path566 = /*#__PURE__*/React.createElement("path", {
    d: "M470.863 272.861c-2.093-1.373-3.99-3.335-5.21-4.621-.567-.72-1.155-1.504-1.59-2.31-.786-1.44-1.353-4.337-1.353-4.337",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path567 || (_path567 = /*#__PURE__*/React.createElement("path", {
    d: "M470.95 272.861c-2.027-1.373-3.902-3.4-5.144-4.709-.567-.719-1.155-1.504-1.592-2.31-.85-1.505-1.439-4.339-1.439-4.339",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path568 || (_path568 = /*#__PURE__*/React.createElement("path", {
    d: "M471.016 272.861c-2.028-1.373-3.902-3.553-5.058-4.84a12.216 12.216 0 0 1-1.59-2.244c-.939-1.592-1.593-4.34-1.593-4.34",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path569 || (_path569 = /*#__PURE__*/React.createElement("path", {
    d: "M471.081 272.861c-1.94-1.439-3.902-3.684-4.992-4.926a16.585 16.585 0 0 1-1.657-2.245c-.937-1.657-1.656-4.337-1.656-4.337",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path570 || (_path570 = /*#__PURE__*/React.createElement("path", {
    d: "M471.169 272.861c-1.962-1.439-3.903-3.77-4.993-4.991-.501-.567-1.068-1.44-1.592-2.246-1.003-1.722-1.809-4.338-1.809-4.338",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path571 || (_path571 = /*#__PURE__*/React.createElement("path", {
    d: "M471.234 272.861c-1.94-1.504-3.837-3.901-4.928-5.058-.5-.566-1.067-1.373-1.59-2.31-1.069-1.723-1.94-4.335-1.94-4.335",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path572 || (_path572 = /*#__PURE__*/React.createElement("path", {
    d: "M471.299 272.861c-1.94-1.504-3.836-4.054-4.84-5.144-.5-.567-1.067-1.44-1.591-2.311-1.068-1.81-2.093-4.338-2.093-4.338",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path573 || (_path573 = /*#__PURE__*/React.createElement("path", {
    d: "M471.386 272.861c-1.962-1.504-3.77-4.12-4.773-5.21-.502-.501-1.07-1.373-1.658-2.31-1.068-1.873-2.158-4.34-2.158-4.34",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path574 || (_path574 = /*#__PURE__*/React.createElement("path", {
    d: "M471.452 272.774c-1.94-1.505-3.772-4.12-4.774-5.21-.414-.502-1.003-1.373-1.504-2.31-1.221-1.943-2.377-4.336-2.377-4.336",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path575 || (_path575 = /*#__PURE__*/React.createElement("path", {
    d: "M462.754 260.806s2.747 5.145 4.054 6.671c.937 1.002 2.813 3.771 4.71 5.276",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path576 || (_path576 = /*#__PURE__*/React.createElement("path", {
    d: "M462.819 273.646c3.03 2.028 3.77 2.529 10.006 6.518l1.875-2.965s-.72-1.656-1.003-2.528",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path577 || (_path577 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.646c2.9 1.94 3.837 2.529 9.94 6.366l.066-.066 1.657-2.812s-.065-.349-.283-.784a24.828 24.828 0 0 1-.568-1.658",
    fill: "none",
    stroke: "#00004f",
    strokeWidth: 0.23187
  })), _path578 || (_path578 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.646c2.747 1.876 3.99 2.681 9.94 6.3l.066-.13c0-.065 1.592-2.813 1.592-2.813s-.066-.282-.196-.719c-.196-.501-.414-1.156-.567-1.592",
    fill: "none",
    stroke: "#000053",
    strokeWidth: 0.23187
  })), _path579 || (_path579 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.646c2.681 1.723 4.208 2.681 9.94 6.147l.066-.13c0-.066 1.439-2.747 1.439-2.747s0-.283-.195-.72c-.132-.5-.35-1.068-.415-1.504",
    fill: "none",
    stroke: "#000056",
    strokeWidth: 0.23187
  })), _path580 || (_path580 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.581c2.616 1.722 4.338 2.812 9.94 6.082l.066-.066c0-.13 1.373-2.812 1.373-2.812s0-.194-.13-.632c-.196-.5-.349-1.004-.414-1.439",
    fill: "none",
    stroke: "#000058",
    strokeWidth: 0.23187
  })), _path581 || (_path581 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.581c2.53 1.656 4.491 2.9 9.94 6.016l.066-.13c0-.197 1.287-2.812 1.287-2.812s0-.197-.132-.567c-.195-.436-.282-.937-.349-1.374",
    fill: "none",
    stroke: "#00005c",
    strokeWidth: 0.23187
  })), _path582 || (_path582 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.581c2.464 1.59 4.71 2.964 9.94 5.865l.132-.132c0-.196 1.068-2.747 1.068-2.747s.066-.195-.066-.566c-.13-.414-.283-.873-.283-1.286",
    fill: "none",
    stroke: "#000060",
    strokeWidth: 0.23187
  })), _path583 || (_path583 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.581c2.398 1.504 4.84 2.964 9.94 5.711l.132-.13c0-.197 1.002-2.748 1.002-2.748s.066-.13-.064-.5c-.131-.415-.198-.786-.284-1.222",
    fill: "none",
    stroke: "#000062",
    strokeWidth: 0.23187
  })), _path584 || (_path584 = /*#__PURE__*/React.createElement("path", {
    d: "M462.884 273.581c2.246 1.439 4.993 3.03 9.94 5.647l.132-.132c0-.283.937-2.747.85-2.747 0 0 .131-.13 0-.501-.131-.414-.131-.72-.196-1.156",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path585 || (_path585 = /*#__PURE__*/React.createElement("path", {
    d: "M462.972 273.516c2.093 1.439 5.144 3.182 9.853 5.58l.131-.13c0-.283.785-2.748.785-2.748s.131-.065 0-.414-.131-.653-.131-1.068",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path586 || (_path586 = /*#__PURE__*/React.createElement("path", {
    d: "M462.972 273.516c2.005 1.374 5.21 3.248 9.853 5.427.065 0 .131-.13.131-.13 0-.35.719-2.682.719-2.682s.132-.13.066-.414c-.196-.348-.131-.566-.131-1.003",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path587 || (_path587 = /*#__PURE__*/React.createElement("path", {
    d: "M462.972 273.516c1.94 1.286 5.428 3.334 9.853 5.362.065-.066.131-.131.131-.195 0-.285.567-2.595.567-2.595s.196-.13.13-.436c-.13-.349-.13-.501-.13-.938",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path588 || (_path588 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.516a74.855 74.855 0 0 0 9.788 5.21l.131-.132c0-.414.502-2.68.502-2.68s.195-.066.13-.35c-.13-.348-.065-.436-.065-.85",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path589 || (_path589 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.516c1.722 1.068 5.647 3.4 9.788 5.078l.131-.13c0-.436.414-2.594.349-2.681 0 0 .349-.066.196-.284-.13-.348 0-.348 0-.785",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path590 || (_path590 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.516c1.591 1.003 5.865 3.466 9.853 4.991l.066-.195c0-.415.349-2.595.283-2.595 0 0 .284-.065.196-.283-.13-.283 0-.283.066-.72",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path591 || (_path591 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.428c1.504 1.069 6.017 3.62 9.853 4.927.066 0 .066-.196.066-.196 0-.414.196-2.53.196-2.595 0 0 .283 0 .196-.195-.13-.284.066-.284.131-.633",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path592 || (_path592 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.428c1.439.937 6.147 3.685 9.853 4.774.066 0 .066-.13.066-.13 0-.502.13-2.595.066-2.682 0 0 .413.065.282-.13-.064-.284.131-.197.197-.568",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path593 || (_path593 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.363c1.374.937 6.365 3.77 9.853 4.773.066-.064.066-.196.132-.196 0-.565-.066-2.528-.066-2.594 0 0 .349.066.283-.13-.065-.283.131-.13.284-.502",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path594 || (_path594 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.363c1.286.85 6.518 3.836 9.853 4.621.066-.065.066-.13.132-.195 0-.567-.132-2.53-.197-2.595 0 0 .415.131.415-.066-.132-.195.065-.065.282-.414",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path595 || (_path595 = /*#__PURE__*/React.createElement("path", {
    d: "M463.037 273.363c1.221.785 6.649 3.901 9.853 4.49.066 0 .132-.13.132-.195 0-.567-.197-2.465-.283-2.53 0 0 .5.066.413-.065-.13-.195.13 0 .349-.349",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path596 || (_path596 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.363c1.003.719 6.735 3.99 9.787 4.425.066-.065.132-.13.132-.196 0-.632-.35-2.53-.35-2.53s.502.066.35-.064c0-.196.283.065.413-.283",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path597 || (_path597 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.363c.937.632 6.888 4.054 9.787 4.273.066-.066.132-.131.132-.196 0-.634-.416-2.465-.502-2.53 0 0 .501.131.501 0-.065-.196.283.131.414-.196",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path598 || (_path598 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.363c.85.501 7.106 4.054 9.853 4.207 0-.13.066-.195.066-.282 0-.633-.502-2.465-.567-2.53 0 0 .567.132.501.066-.066-.197.283.195.502-.132",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path599 || (_path599 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.297c.784.502 7.238 4.208 9.853 4.122 0-.067.066-.197.066-.285 0-.719-.633-2.463-.72-2.463 0 0 .633.13.566 0-.065-.065.35.349.567 0",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path600 || (_path600 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.297c.718.502 7.39 4.273 9.853 3.99 0-.065.066-.13.066-.196 0-.785-.72-2.465-.786-2.529 0 0 .567.195.567.13-.065-.13.414.35.633 0",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path601 || (_path601 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.297c.632.35 7.608 4.339 9.853 3.837 0 0 .066-.13.066-.195 0-.786-.786-2.377-.85-2.465v-.065s.632.283.566.197c0-.132.414.414.72.065",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path602 || (_path602 = /*#__PURE__*/React.createElement("path", {
    d: "M463.103 273.297c.5.283 7.76 4.339 9.853 3.772.066-.066.066-.196.066-.283 0-.785-.938-2.377-1.004-2.465 0 0 .72.285.633.197 0-.13.5.502.784.13",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path603 || (_path603 = /*#__PURE__*/React.createElement("path", {
    d: "M463.168 273.297c.349.196 7.826 4.426 9.788 3.62.066-.067.066-.197.13-.284-.064-.785-1.067-2.312-1.155-2.464 0 0 .72.35.72.196-.066 0 .5.633.784.284",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path604 || (_path604 = /*#__PURE__*/React.createElement("path", {
    d: "M463.168 273.297c.282.131 7.978 4.491 9.788 3.553.066-.13.066-.194.13-.282 0-.85-1.22-2.377-1.285-2.465 0 0 .784.285.719.285 0-.067.567.567.938.282",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path605 || (_path605 = /*#__PURE__*/React.createElement("path", {
    d: "M463.168 273.21c.196.13 8.109 4.621 9.788 3.466.066-.065.066-.13.13-.283 0-.85-1.285-2.311-1.373-2.376l.785.283c-.065-.065.567.633.85.349",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path606 || (_path606 = /*#__PURE__*/React.createElement("path", {
    d: "M463.168 273.21c.13.065 8.327 4.71 9.788 3.335.066-.065.13-.13.13-.282 0-.938-1.373-2.312-1.503-2.377l.85.283s.566.786.937.502",
    fill: "none",
    stroke: "#0049af",
    strokeWidth: 0.23187
  })), _path607 || (_path607 = /*#__PURE__*/React.createElement("path", {
    d: "M463.256 273.146s9.416 5.361 9.852 2.963c0-.937-1.59-2.31-1.59-2.31l.85.283s.631.85 1.002.567",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path608 || (_path608 = /*#__PURE__*/React.createElement("path", {
    d: "M464.258 237.808c0-.938.501-2.026 1.155-2.026 0 0 .502 0 .785.061.35.135.414.285.501.636.132.782-.85 1.066-1.59 1.156-.197 0-.72-.068-.786.128-.196.285-.065.195-.196.285.131 0 .196-.068.283-.135.633-.127 1.155-.127 1.94-.278.502-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.961-.419-.786.57-1.07 1.44-1.156 2.467.065-.194.349-.067.414-.284",
    fill: "#fc0"
  })), _path609 || (_path609 = /*#__PURE__*/React.createElement("path", {
    d: "M464.258 237.808c0-.938.501-2.026 1.155-2.026 0 0 .502 0 .785.061.35.135.414.285.501.636.132.782-.85 1.066-1.59 1.156-.197 0-.72-.068-.786.128-.196.285-.065.195-.196.285.131 0 .196-.068.283-.135.633-.127 1.155-.127 1.94-.278.502-.068.85-1.156.567-1.591-.283-.351-1.591-.72-1.961-.419-.786.57-1.07 1.44-1.156 2.467.065-.194.349-.067.414-.284z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path610 || (_path610 = /*#__PURE__*/React.createElement("path", {
    d: "M463.756 238.092c-.85-.284-2.006-.134-2.223.413 0 .067-.197.564-.197.787 0 .347.066.496.437.715.632.35 1.286-.497 1.57-1.156.064-.194.195-.564.413-.714.349-.068.284 0 .349-.068-.065.13-.196.196-.282.285-.285.497-.502.938-.939 1.653-.282.501-1.35.501-1.656.067-.284-.503-.066-1.72.283-2.026.72-.57 1.722-.503 2.66-.195-.131-.068-.195.284-.415.195",
    fill: "#fc0"
  })), _path611 || (_path611 = /*#__PURE__*/React.createElement("path", {
    d: "M463.756 238.092c-.85-.284-2.006-.134-2.223.413 0 0-.197.564-.197.787 0 .347.066.496.437.715.632.35 1.286-.497 1.57-1.156.064-.194.195-.564.413-.714.349-.068.284 0 .349-.068-.065.13-.196.196-.282.285-.285.497-.502.938-.939 1.653-.282.501-1.35.501-1.656.067-.284-.503-.066-1.72.283-2.026.72-.57 1.722-.503 2.66-.195-.131-.068-.195.284-.415.195z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path612 || (_path612 = /*#__PURE__*/React.createElement("path", {
    d: "M463.691 237.674c-.283 0-.349.418-.283.636 0 .195.348.346.566.284.35-.133.633-.419.567-.786-.13-.352-.567-.195-.85-.134",
    fill: "#fc0"
  })), _path613 || (_path613 = /*#__PURE__*/React.createElement("path", {
    d: "M463.691 237.674c-.283 0-.349.418-.283.636 0 .195.348.346.566.284.35-.133.633-.419.567-.786-.13-.352-.567-.195-.85-.134",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path614 || (_path614 = /*#__PURE__*/React.createElement("path", {
    d: "M459.68 233.532s2.093 1.507 3.99 2.033c0 0-.284 1.718 0 2.243 0 0-1.658-.72-2.53-.503 0 0-.414-2.528-1.438-3.773",
    fill: "#fc0"
  })), _path615 || (_path615 = /*#__PURE__*/React.createElement("path", {
    d: "M459.68 233.532s2.093 1.507 3.99 2.033c0 0-.284 1.718 0 2.243 0 0-1.658-.72-2.53-.503 0 0-.414-2.528-1.438-3.773z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path616 || (_path616 = /*#__PURE__*/React.createElement("path", {
    d: "M461.294 235.19s.784.57 1.59.788c0 0-.13.63 0 .847 0 0-.632-.195-1.003-.128 0 0-.13-1.005-.566-1.506z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path617 || (_path617 = /*#__PURE__*/React.createElement("path", {
    d: "M463.386 239.549s.632-.63.85-.937c.065-.129-.35.937.065 1.221.35.787.066 2.25 0 2.595-.653.068-1.221.285-2.027-.345-.283-.285.066-.855.283-1.29.132-.195.437-.937.785-1.222",
    fill: "#fc0"
  })), _path618 || (_path618 = /*#__PURE__*/React.createElement("path", {
    d: "M463.386 239.549s.632-.63.85-.937c.065-.129-.35.937.065 1.221.35.787.066 2.25 0 2.595-.653.068-1.221.285-2.027-.345-.283-.285.066-.855.283-1.29.132-.195.437-.937.785-1.222z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path619 || (_path619 = /*#__PURE__*/React.createElement("path", {
    d: "M463.974 239.113c0 .068-.065.42-.065.503.065.195.283.284.349.569.065.72-.066 1.217-.13 2.154m-.219-2.416c.196.937 0 1.657-.065 2.46h.065m-.153-.936c-.13.284-.13.501-.13.936-.066-.06-.197.068-.283.068",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path620 || (_path620 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 326.904c.13 0 .282-.134.413-.195.349-.2 1.003-.2 1.22-.419 1.004-1.155.35-3.332-.13-4.705-.784-2.533-.85-4.844-1.439-7.238h-.065c-.502 2.378-.633 4.705-1.504 7.238-.35 1.373-1.069 3.55-.066 4.705.196.202.85.202 1.286.419.065.061.196.195.284.195",
    fill: "#fff"
  })), _path621 || (_path621 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 314.213c-.503 2.377-.634 4.839-1.505 7.394-.35 1.218-1.004 3.249-.196 4.42l-.066-.06h.066c-.349 0-.72-.068-1.069-.195-.066-.068-.197-.068-.282-.202a1.802 1.802 0 0 0-.503-.497c-.196-.133-.5-.066-.719-.2-.065-.062-.13-.13-.196-.13-.501-.283-1.003-.568-1.221-1.065-.065-.419-.131-.787-.065-1.221.065-.286.196-.503.283-.788.13-.345.284-.72.502-1.065.13-.413.348-.721.567-1.156.065-.194.13-.351.282-.502.066-.195.132-.351.283-.502.067-.194.284-.285.416-.502.13-.13-.16-.005-.006-.16 0 0 .358-.397.358-.464.065 0 .313-.095.313-.157.414-.72.73-.833 1.012-1.575.197-.279.197-.781.197-1.154h1.504",
    fill: "#004bb3"
  })), _path622 || (_path622 = /*#__PURE__*/React.createElement("path", {
    d: "M500.903 314.28s-.937 3.99-1.504 4.995c-.566 1-2.813 2.807-1.374 5.708",
    fill: "none",
    stroke: "#003",
    strokeWidth: 0.23187
  })), _path623 || (_path623 = /*#__PURE__*/React.createElement("path", {
    d: "M501.056 314.28s-.937 3.99-1.504 4.995c-.632 1.066-2.835 2.964-1.286 5.86",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path624 || (_path624 = /*#__PURE__*/React.createElement("path", {
    d: "M501.121 314.28s-.937 4.058-1.504 5.146c-.567 1.004-2.813 2.964-1.22 5.865",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path625 || (_path625 = /*#__PURE__*/React.createElement("path", {
    d: "M501.273 314.28s-.936 4.12-1.525 5.146c-.633 1.004-2.812 3.03-1.221 6.017",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path626 || (_path626 = /*#__PURE__*/React.createElement("path", {
    d: "M501.34 314.28s-.938 4.209-1.505 5.212c-.567 1-2.747 3.115-1.155 6.08",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path627 || (_path627 = /*#__PURE__*/React.createElement("path", {
    d: "M501.405 314.28s-.85 4.275-1.505 5.275c-.567 1.003-2.68 3.185-1.067 6.15",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path628 || (_path628 = /*#__PURE__*/React.createElement("path", {
    d: "M500.838 314.28s-.938 3.84-1.505 4.928c-.567 1.066-2.898 2.897-1.373 5.71",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path629 || (_path629 = /*#__PURE__*/React.createElement("path", {
    d: "M500.75 314.37s-.937 3.616-1.59 4.838c-.568 1.005-2.9 2.897-1.374 5.71",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path630 || (_path630 = /*#__PURE__*/React.createElement("path", {
    d: "M500.598 314.37s-.85 3.55-1.592 4.838c-.5 1.005-2.811 2.813-1.286 5.71",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path631 || (_path631 = /*#__PURE__*/React.createElement("path", {
    d: "M500.533 314.37s-.785 3.398-1.656 4.772c-.503 1.071-2.813 2.902-1.287 5.714",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path632 || (_path632 = /*#__PURE__*/React.createElement("path", {
    d: "M500.402 314.37s-.785 3.332-1.592 4.772c-.567 1.003-2.812 2.902-1.286 5.714",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path633 || (_path633 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 314.213c.565 2.377.719 4.839 1.503 7.394.414 1.218 1.069 3.249.283 4.42l.01-.148c.413 0 .71-.088 1.06-.216.13-.069.194-.046.281-.18.132-.194.284-.259.437-.409.283-.134.567-.068.85-.201.066-.062.066-.13.13-.13.502-.283 1.004-.568 1.222-1.065.13-.419.13-.787.065-1.221a2.843 2.843 0 0 0-.283-.788c-.131-.345-.283-.72-.501-1.065-.13-.413-.35-.721-.567-1.156-.066-.194-.13-.351-.283-.502-.066-.195-.197-.351-.284-.502-.066-.194-.283-.285-.414-.502-.18-.32-.304-.282-.37-.439-.065 0-.092.063-.005-.004-.066 0-.168-.145-.256-.207-.33-.328-.754-1.047-1.07-1.706-.197-.28-.197-.781-.197-1.156h-1.59",
    fill: "#004bb3"
  })), _path634 || (_path634 = /*#__PURE__*/React.createElement("path", {
    d: "M502.43 314.28s.936 3.99 1.504 4.995c.566 1 2.812 2.807 1.285 5.708",
    fill: "none",
    stroke: "#003",
    strokeWidth: 0.23187
  })), _path635 || (_path635 = /*#__PURE__*/React.createElement("path", {
    d: "M502.276 314.28s.938 3.99 1.592 4.995c.567 1.066 3.066 2.594 1.54 5.49",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path636 || (_path636 = /*#__PURE__*/React.createElement("path", {
    d: "M502.21 314.28s.938 4.058 1.505 5.146c.567 1.004 2.885 2.802 1.293 5.703",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path637 || (_path637 = /*#__PURE__*/React.createElement("path", {
    d: "M502.06 314.28s1.002 4.12 1.59 5.146c.562.997 2.814 2.753 1.358 5.703-.007.013-.034.014-.041.027-.005.01.228-.251.041-.027",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path638 || (_path638 = /*#__PURE__*/React.createElement("path", {
    d: "M501.994 314.28s.936 4.209 1.59 5.212c.502 1 2.682 3.115 1.069 6.08",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path639 || (_path639 = /*#__PURE__*/React.createElement("path", {
    d: "M501.928 314.28s.937 4.275 1.504 5.275c.567 1.003 2.681 3.185 1.068 6.15",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path640 || (_path640 = /*#__PURE__*/React.createElement("path", {
    d: "M502.495 314.28s.937 3.84 1.592 4.928c.565 1.066 2.812 2.897 1.285 5.71",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path641 || (_path641 = /*#__PURE__*/React.createElement("path", {
    d: "M502.647 314.37s.85 3.616 1.505 4.838c.566 1.005 2.899 2.897 1.373 5.71",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path642 || (_path642 = /*#__PURE__*/React.createElement("path", {
    d: "M502.713 314.37s.85 3.55 1.59 4.838c.568 1.005 2.813 2.813 1.374 5.71",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path643 || (_path643 = /*#__PURE__*/React.createElement("path", {
    d: "M502.8 314.37s.85 3.398 1.591 4.772c.567 1.071 2.9 2.902 1.374 5.714",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path644 || (_path644 = /*#__PURE__*/React.createElement("path", {
    d: "M502.93 314.37s.785 3.332 1.592 4.772c.567 1.003 2.899 2.902 1.373 5.714",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path645 || (_path645 = /*#__PURE__*/React.createElement("path", {
    d: "M504.85 317.461c.13.195.578.787.643 1.004.065.13.195.285.283.503.131.128.196.279.283.502.197.413.415.714.567 1.155.197.346.349.714.502 1.066.13.284.196.502.282.787.066.435.066.781-.064 1.217-.196.501-.72.787-1.22 1.071 0 0-.067.062-.132.129-.283.133-.566.066-.85.194-.13.135-.283.285-.436.503-.065.134-.13.134-.283.195a2.689 2.689 0 0 1-1.068.2v.062-.061c0 .128-.066.195-.132.28-.195.194-.85.194-1.22.418-.131.062-.283.195-.414.195-.066 0-.196-.133-.283-.195-.415-.201-1.069-.201-1.287-.419-.065-.061-.13-.128-.13-.279v.061-.061c-.349 0-.72-.066-1.07-.2-.064-.062-.196-.062-.281-.196a1.895 1.895 0 0 0-.502-.502c-.197-.129-.502-.062-.721-.195-.064-.068-.13-.129-.195-.129-.501-.284-1.003-.57-1.221-1.071-.066-.413-.131-.782-.066-1.217.065-.285.197-.503.284-.787.13-.35.283-.72.501-1.066.131-.419.349-.72.567-1.155.066-.201.131-.351.283-.502.066-.195.131-.352.284-.503.066-.194.514-.656.645-.874",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path646 || (_path646 = /*#__PURE__*/React.createElement("path", {
    d: "M459.37 272.661c-.341 6.572-.192 8.482-.192 14.894-.065 1.585 1.36 7.827 3.006 10.68l6.678-11.159h-.027c-.567-.938-1.068-3.77-1.22-4.273-.283-1.496-.283-2.314-.197-4.812z",
    fill: "#fff"
  })), _path647 || (_path647 = /*#__PURE__*/React.createElement("path", {
    d: "M468.836 287.075c-.568-.938-1.07-3.772-1.22-4.274-.285-1.503-.285-2.31-.198-4.839l4.927 3.184-3.466 5.93",
    fill: "#004bb3"
  })), _path648 || (_path648 = /*#__PURE__*/React.createElement("path", {
    d: "m472.825 280.404-23.283-15.216-.414.567 23.217 15.434.502-.785",
    fill: "#fc0"
  })), _path649 || (_path649 = /*#__PURE__*/React.createElement("path", {
    d: "m472.825 280.404-23.283-15.216-.414.567 23.217 15.434.502-.785z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path650 || (_path650 = /*#__PURE__*/React.createElement("path", {
    d: "M454.84 310.508c-.501-.346-1.44-1.283-1.723-2.154-.631-1.657-.5-1.596-.936-3.471-.197-1.066-.197-2.244-.501-3.334-.132-1.068-1.723-4.621-1.81-6.016-.131-4.622-1.656-7.76-1.287-12.753.283-3.902 1.156-9.2.72-13.276-.131-1.068.066-2.31.066-3.467l10.004 6.52c-.347 6.67-.194 8.545-.194 14.997-.066 1.592 1.373 7.891 3.03 10.726l-7.324 12.25",
    fill: "#004bb3"
  })), _path651 || (_path651 = /*#__PURE__*/React.createElement("path", {
    d: "m462.078 298.236-7.326 12.25c-.565-.347-1.438-1.284-1.808-2.155-.502-1.657-.414-1.657-.85-3.465-.196-1.071-.196-2.248-.415-3.338-.282-1.068-1.81-4.622-1.875-6.016m-.043-.022c.066 1.373 1.591 4.84 1.875 5.93.195 1.067.195 2.244.414 3.334.415 1.809.348 1.724.937 3.466.283.786 1.221 1.808 1.743 2.093l7.326-12.098",
    fill: "none",
    stroke: "#00004b",
    strokeWidth: 0.23187
  })), _path652 || (_path652 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.373 1.591 4.773 1.81 5.865.282 1.067.282 2.244.566 3.332.414 1.724.283 1.724.85 3.466.283.787 1.221 1.724 1.743 2.093 0 0 7.238-11.966 7.326-12.031m-12.295-2.725c.066 1.373 1.591 4.773 1.81 5.865.282 1 .282 2.157.566 3.248.414 1.72.283 1.658.85 3.4.283.786 1.221 1.724 1.743 2.025.067.067 7.238-11.748 7.326-11.813",
    fill: "none",
    stroke: "#00004f",
    strokeWidth: 0.23187
  })), _path653 || (_path653 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.286 1.591 4.708 1.81 5.798.282 1.068.282 2.159.566 3.182.414 1.724.283 1.724.85 3.404.283.782 1.221 1.719 1.743 2.093.132 0 7.238-11.664 7.326-11.752m-12.295-2.725c.066 1.286 1.591 4.621 1.81 5.711.282 1.004.282 2.158.566 3.185.414 1.718.283 1.718.938 3.332.282.787 1.155 1.724 1.722 2.092.065 0 7.106-11.53 7.238-11.595",
    fill: "none",
    stroke: "#000051",
    strokeWidth: 0.23187
  })), _path654 || (_path654 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.286 1.503 4.556 1.81 5.646.282 1.003.282 2.158.566 3.183.414 1.658.283 1.658.938 3.337.282.782 1.155 1.652 1.722 2.026.065.067 7.106-11.38 7.238-11.446m-12.275-2.747c.067 1.286 1.504 4.557 1.81 5.582.283 1.068.283 2.158.567 3.183.414 1.656.349 1.656.938 3.246.282.786 1.155 1.725 1.722 2.027.13.066 7.019-11.224 7.238-11.312",
    fill: "none",
    stroke: "#000053",
    strokeWidth: 0.23187
  })), _path655 || (_path655 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.286 1.503 4.49 1.81 5.58.282 1.003.282 2.094.566 3.118.414 1.593.349 1.593.938 3.244.282.721 1.22 1.598 1.722 1.944.13.066 7.019-11.096 7.238-11.161m-12.275-2.725c.067 1.22 1.504 4.425 1.81 5.428.283 1.068.283 2.158.567 3.182.414 1.592.349 1.592.938 3.182.282.721 1.22 1.658 1.722 1.943.13.06 7.019-10.945 7.238-11.01m-12.275-2.725c.067 1.22 1.504 4.425 1.81 5.428.283 1.002.283 2.026.567 3.03.414 1.655.349 1.655.938 3.184.282.781 1.22 1.657 1.722 1.936.196.068 6.953-10.788 7.238-10.876",
    fill: "none",
    stroke: "#000056",
    strokeWidth: 0.23187
  })), _path656 || (_path656 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.22 1.503 4.338 1.81 5.363.282 1.002.282 2.092.566 3.03.414 1.591.414 1.591.938 3.115.282.787 1.22 1.658 1.722 1.942.196.066 6.953-10.66 7.238-10.725m-12.275-2.725c.067 1.22 1.504 4.273 1.81 5.275.283 1.003.283 2.093.567 2.964.414 1.656.414 1.656 1.003 3.186.282.719 1.155 1.59 1.656 1.874.284.129 6.955-10.443 7.238-10.574",
    fill: "none",
    stroke: "#000058",
    strokeWidth: 0.23187
  })), _path657 || (_path657 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.22 1.503 4.273 1.81 5.275.282.938.282 1.94.566 2.9.414 1.592.414 1.592 1.003 3.116.282.72 1.155 1.59 1.656 1.94.284.068 6.89-10.354 7.238-10.506m-12.273-2.725c.066 1.155 1.438 4.207 1.81 5.21.282.937.282 1.962.566 2.899.414 1.59.414 1.59 1.003 3.12.282.714 1.155 1.5 1.656 1.87.284.067 6.89-10.221 7.238-10.353",
    fill: "none",
    stroke: "#00005c",
    strokeWidth: 0.23187
  })), _path658 || (_path658 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.49c.066 1.155 1.438 4.12 1.81 5.145.282.937.348 1.94.566 2.899.414 1.588.414 1.588 1.003 3.03.282.718 1.155 1.59 1.656 1.874.35.067 6.89-10.07 7.238-10.223m-12.273-2.725c.066 1.068 1.438 4.054 1.81 5.057.282 1.003.348 1.94.566 2.9.414 1.503.414 1.503 1.003 2.965.282.72 1.155 1.59 1.656 1.874.35.13 6.89-9.918 7.238-10.071",
    fill: "none",
    stroke: "#00005e",
    strokeWidth: 0.23187
  })), _path659 || (_path659 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066 1.155 1.438 4.12 1.81 5.143.282.852.348 1.875.566 2.813.414 1.502.414 1.502 1.003 2.897.282.72 1.155 1.507 1.656 1.875.35.133 6.803-9.785 7.238-9.917m-12.273-2.811c.066 1.155 1.351 4.054 1.81 4.991.282.938.348 1.94.566 2.813.501 1.503.501 1.503 1.003 2.965.282.721 1.155 1.501 1.656 1.808.415.129 6.737-9.635 7.238-9.787m-12.273-2.79c.066 1.155 1.351 3.989 1.81 4.991.195.938.348 1.875.632 2.748.435 1.5.435 1.5 1.003 2.963.282.631 1.068 1.44 1.59 1.724.503.129 6.737-9.483 7.239-9.636",
    fill: "none",
    stroke: "#000060",
    strokeWidth: 0.23187
  })), _path660 || (_path660 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066 1.155 1.351 3.901 1.81 4.926.195.937.348 1.874.632 2.747.435 1.505.435 1.505 1.003 2.901.282.63 1.154 1.434 1.59 1.719.503.134 6.737-9.35 7.239-9.482m-12.275-2.811c.067 1.067 1.352 3.901 1.81 4.838.196.938.35 1.876.633 2.747.435 1.437.435 1.437 1.003 2.81.282.636 1.154 1.44 1.656 1.814.414.061 6.671-9.266 7.172-9.42",
    fill: "none",
    stroke: "#000062",
    strokeWidth: 0.23187
  })), _path661 || (_path661 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066 1.067 1.351 3.836 1.81 4.838.195.85.348 1.81.632 2.682.435 1.441.435 1.441 1.003 2.747.348.72 1.154 1.44 1.656 1.725.502.194 6.605-8.984 7.172-9.202m-12.272-2.79c.065 1.067 1.35 3.836 1.808 4.773.196.85.35 1.81.633 2.682.435 1.374.435 1.374 1.067 2.745.284.653 1.069 1.374 1.592 1.657.502.195 6.605-8.85 7.172-9.067",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path662 || (_path662 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066 1.067 1.351 3.77 1.81 4.708.195.85.348 1.809.632 2.594.435 1.439.435 1.439 1.067 2.747.284.63 1.069 1.44 1.592 1.72.502.133 6.605-8.761 7.172-8.98m-12.272-2.79c.065 1.068 1.35 3.684 1.808 4.622.196.872.35 1.81.633 2.616.435 1.35.5 1.438 1.067 2.745.284.57 1.069 1.374 1.592 1.658.567.129 6.517-8.632 7.172-8.85",
    fill: "none",
    stroke: "#000268",
    strokeWidth: 0.23187
  })), _path663 || (_path663 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066 1.002 1.287 3.618 1.81 4.621.195.784.348 1.656.632 2.528.435 1.374.5 1.374 1.067 2.683.284.63 1.069 1.372 1.592 1.657.567.195 6.453-8.481 7.172-8.7m-12.272-2.79c.065 1.003 1.285 3.619 1.808 4.492.196.85.35 1.72.72 2.593.348 1.286.413 1.373 1.003 2.591.282.636 1.067 1.378 1.592 1.658.565.2 6.451-8.325 7.171-8.543m-12.295-2.79c.066 1.002 1.287 3.552 1.81 4.49.195.85.348 1.657.718 2.463.35 1.374.502 1.374 1.004 2.594.282.63 1.067 1.373 1.592 1.657.63.13 6.451-8.11 7.171-8.414",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path664 || (_path664 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066.937 1.287 3.465 1.81 4.424.195.785.348 1.723.718 2.464.35 1.286.502 1.374 1.004 2.591.349.57 1.067 1.29 1.592 1.592.63.2 6.451-7.977 7.171-8.26m-12.295-2.811c.066.937 1.287 3.4 1.81 4.338.195.784.348 1.656.718 2.462.35 1.286.502 1.374 1.004 2.53.349.63 1.067 1.373 1.592 1.59.719.195 6.386-7.825 7.171-8.109",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path665 || (_path665 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 295.425c.066.937 1.287 3.4 1.81 4.338.195.784.413 1.591.718 2.376.35 1.22.502 1.286 1.069 2.525.283.57 1.003 1.29 1.504 1.508.72.194 6.388-7.674 7.172-7.979m-12.272-2.768c.065.937 1.285 3.334 1.72 4.272.284.72.502 1.591.786 2.376.349 1.22.5 1.286 1.068 2.464.283.563 1.003 1.221 1.504 1.59.72.134 6.387-7.608 7.172-7.89",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path666 || (_path666 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .937 1.154 3.334 1.656 4.207.283.784.501 1.591.785 2.31.349 1.221.5 1.286 1.068 2.46.283.57 1.068 1.29 1.504 1.508.785.284 6.3-7.39 7.172-7.674m-12.186-2.811c0 .85 1.155 3.248 1.657 4.12.283.784.501 1.591.785 2.31.414 1.22.5 1.286 1.068 2.465.283.563 1.068 1.221 1.504 1.439.785.28 6.3-7.24 7.172-7.544",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path667 || (_path667 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .85 1.154 3.182 1.656 4.054.283.784.501 1.592.785 2.311.414 1.22.5 1.286 1.068 2.398.283.566 1.068 1.219 1.504 1.504.785.195 6.3-7.172 7.172-7.456m-12.186-2.811c0 .85 1.155 3.117 1.657 3.989.283.784.501 1.592.785 2.31.414 1.156.567 1.221 1.068 2.376.348.503 1.068 1.157 1.504 1.441.85.195 6.234-7.021 7.172-7.325m-12.186-2.791c0 .85 1.155 3.117 1.657 3.989.283.719.501 1.504.785 2.244.414 1.157.567 1.222 1.068 2.312.348.5 1.068 1.152 1.591 1.437.85.285 6.147-6.887 7.107-7.17",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path668 || (_path668 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .85 1.154 3.03 1.656 3.901.283.72.501 1.504.785 2.246.414 1.068.567 1.155 1.155 2.245.283.569 1.004 1.155 1.504 1.44.85.195 6.082-6.671 7.107-7.02m-12.207-2.812c0 .784 1.154 2.964 1.656 3.836.283.72.501 1.504.785 2.159.414 1.154.567 1.22 1.155 2.31.349.501 1.004 1.153 1.504 1.37.85.285 6.082-6.514 7.107-6.885",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path669 || (_path669 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .784 1.154 2.899 1.656 3.836.283.632.501 1.373.785 2.093.414 1.068.567 1.22 1.155 2.245.349.501 1.004 1.155 1.504 1.373.938.285 6.082-6.365 7.107-6.736m-12.207-2.811c0 .784 1.067 2.899 1.656 3.683.283.72.501 1.504.785 2.159.414 1.068.567 1.155 1.155 2.158.349.501 1.004 1.157 1.504 1.374.938.284 6.017-6.235 7.107-6.584",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path670 || (_path670 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .784 1.067 2.811 1.656 3.683.283.633.501 1.439.785 2.093.414 1.004.567 1.155 1.155 2.158.349.502 1.004 1.066 1.504 1.284.938.285 6.017-6.079 7.107-6.45m-12.207-2.768c0 .719 1.067 2.811 1.656 3.618.283.72.501 1.373.785 2.093.5 1.003.632 1.068 1.155 2.093.349.5 1.004 1.068 1.504 1.374 1.004.28 6.017-6.017 7.107-6.367",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path671 || (_path671 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .719 1.067 2.746 1.656 3.552.283.634.501 1.374.785 2.094.5 1.002.632 1.068 1.155 2.093.349.413 1.004 1.003 1.504 1.283 1.004.285 5.93-5.861 7.107-6.232m-12.207-2.79c0 .719 1.002 2.68 1.656 3.465.283.72.501 1.373.85 2.028.414 1.002.567 1.155 1.068 2.092.348.415 1.003 1.068 1.505 1.221 1.002.35 5.93-5.645 7.106-6.016m-12.186-2.79c0 .631 1.003 2.593 1.657 3.465.283.633.501 1.286.85 1.94.414 1.004.567 1.069 1.155 2.028.35.501 1.004 1.003 1.44 1.286 1.068.28 5.864-5.58 7.106-5.93",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path672 || (_path672 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .631 1.002 2.593 1.656 3.4.283.566.501 1.285.85 1.94.414.938.567 1.069 1.155 1.94.35.502 1.004 1.003 1.44 1.287 1.068.35 5.864-5.428 7.106-5.8m-12.207-2.767c0 .631 1.002 2.528 1.656 3.334.283.634.501 1.286.85 1.875.414 1.003.567 1.07 1.155 2.027.35.415 1.004 1.003 1.44 1.221 1.155.284 5.864-5.21 7.106-5.646",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path673 || (_path673 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.425c0 .631 1.002 2.462 1.656 3.334.283.567.501 1.222.85 1.81.414 1.003.567 1.068 1.22 2.026.283.415.938.938 1.374 1.157 1.156.348 5.799-5.058 7.107-5.494m-12.207-2.833c0 .631 1.002 2.375 1.656 3.182.283.632.501 1.286.85 1.875.414.938.632 1.068 1.22 1.94.283.414.938.937 1.374 1.155 1.156.35 5.799-4.926 7.107-5.362",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path674 || (_path674 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .654 1.002 2.463 1.656 3.27.283.566.501 1.221.85 1.81.414.937.632 1.003 1.22 1.874.283.415.938.938 1.374 1.156 1.221.349 5.799-4.775 7.107-5.21m-12.207-2.9c0 .654 1.002 2.397 1.656 3.183.283.567.501 1.22.85 1.81.414.85.632 1.003 1.22 1.809.35.5.938.937 1.44 1.155 1.155.349 5.646-4.622 7.02-5.058",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path675 || (_path675 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .654.937 2.397 1.656 3.117.283.567.501 1.22.85 1.81.414.85.72 1.003 1.22 1.81.35.413 1.004.85 1.44 1.068 1.155.414 5.646-4.426 7.02-4.927m-12.187-2.878c0 .654.938 2.245 1.657 3.03.283.568.501 1.22.85 1.722.414.85.72 1.003 1.22 1.81.35.414 1.004.937 1.44 1.155 1.22.35 5.646-4.338 7.02-4.84m-12.187-2.877c0 .654.938 2.245 1.657 3.03.283.501.501 1.155.85 1.657.414.872.72 1.003 1.22 1.81.35.348 1.004.85 1.44 1.068 1.286.348 5.646-4.208 7.02-4.71",
    fill: "none",
    stroke: "#002289",
    strokeWidth: 0.23187
  })), _path676 || (_path676 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .567.937 2.158 1.656 2.966.283.5.501 1.067.85 1.655.414.786.72.938 1.22 1.723.35.414 1.004.85 1.44 1.003 1.286.414 5.582-3.99 7.02-4.49m-12.187-2.857c0 .567.938 2.158 1.657 2.9.283.566.501 1.068.85 1.655.414.786.72.938 1.286 1.658.283.414.938.85 1.374 1.068 1.286.414 5.494-3.902 7.02-4.426",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path677 || (_path677 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .502.937 2.093 1.656 2.9.283.5.501 1.002.85 1.591.414.784.72.937 1.286 1.592.283.414.938.85 1.374 1.067 1.373.414 5.494-3.77 7.02-4.272m-12.187-2.878c0 .502.938 2.027 1.657 2.747.283.502.501 1.155.85 1.656.502.72.72.85 1.286 1.592.349.349.938.785 1.374 1.003 1.373.348 5.494-3.619 7.02-4.12",
    fill: "none",
    stroke: "#00288f",
    strokeWidth: 0.23187
  })), _path678 || (_path678 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .502.85 1.94 1.656 2.747.283.502.501 1.003.85 1.503.502.786.784.938 1.286 1.657.349.349.938.786 1.439.938 1.286.415 5.363-3.466 6.954-3.99m-12.186-2.855c0 .502.85 1.94 1.657 2.68.283.502.501 1.004.85 1.505.502.72.784.85 1.286 1.592.349.349.938.72 1.439.938 1.374.414 5.363-3.336 6.954-3.837",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path679 || (_path679 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .502.85 1.875 1.59 2.594.35.502.633 1.004 1.004 1.504.414.72.719.85 1.22 1.505.35.348.938.718 1.44.936 1.373.415 5.361-3.182 6.953-3.77m-12.207-2.769c0 .414.85 1.875 1.59 2.529.35.501.633 1.002 1.004 1.439.414.719.719.937 1.22 1.504a4.92 4.92 0 0 0 1.44 1.003c1.373.348 5.361-3.117 6.953-3.685m-12.207-2.79c0 .414.784 1.722 1.59 2.463.35.503.633 1.003 1.004 1.44.414.718.719.849 1.286 1.504.348.348.85.719 1.351.85 1.439.5 5.297-2.812 6.954-3.467",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path680 || (_path680 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .414.784 1.722 1.59 2.463.35.415.633.938 1.004 1.373.414.633.719.85 1.286 1.44.348.348.85.72 1.351.937 1.439.414 5.21-2.747 6.954-3.4m-12.186-2.813c0 .414.785 1.656 1.592 2.397.348.415.632.938 1.003 1.353.414.632.719.784 1.286 1.438.348.283.937.633 1.351.85 1.504.415 5.21-2.593 6.954-3.248",
    fill: "none",
    stroke: "#002f96",
    strokeWidth: 0.23187
  })), _path681 || (_path681 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .414.784 1.656 1.59 2.31.35.437.633.939 1.004 1.374.414.566.784.785 1.286 1.374.348.349.937.632 1.351.85 1.504.413 5.21-2.463 6.954-3.118m-12.186-2.79c0 .349.785 1.592 1.592 2.245.348.415.632.938 1.003 1.287.414.632.784.85 1.373 1.373.283.349.85.632 1.287.85 1.59.5 5.144-2.31 6.953-2.965",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path682 || (_path682 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .349.784 1.504 1.59 2.245.35.415.633.786 1.004 1.221.414.567.784.784 1.373 1.286.348.349.85.72 1.287.85 1.59.415 5.144-2.157 6.953-2.812m-12.207-2.79c0 .349.784 1.439 1.59 2.158.35.35.633.785 1.004 1.221.414.567.784.785 1.373 1.286.348.283.85.633 1.287.786 1.59.5 5.144-2.029 6.953-2.683",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path683 || (_path683 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .349.784 1.439 1.59 2.093.35.348.633.873 1.004 1.22.414.567.85.72 1.373 1.22.348.35.85.634 1.287.786 1.655.502 5.144-1.874 6.953-2.529m-12.207-2.79c0 .349.718 1.374 1.59 2.027.35.414.633.85 1.004 1.222.414.5.85.719 1.373 1.22.348.283.85.567 1.287.72 1.655.5 5.057-1.723 6.953-2.377m-12.207-2.812c0 .282.718 1.374 1.59 1.94.283.436.633.785 1.004 1.221.414.502.85.632 1.373 1.156a4.657 4.657 0 0 0 1.287.719c1.743.501 5.057-1.591 6.953-2.246",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path684 || (_path684 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .282.718 1.22 1.59 1.94.283.35.633.72 1.004 1.068.414.502.85.72 1.373 1.156.348.283.85.566 1.287.785 1.743.501 5.057-1.44 6.953-2.159m-12.207-2.79c0 .196.718 1.22 1.59 1.875.283.35.633.72 1.004 1.068.5.502.85.72 1.373 1.069.348.348.85.632 1.287.718 1.743.567 4.99-1.22 6.953-1.94",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path685 || (_path685 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .196.718 1.155 1.59 1.81.283.348.633.719 1.004 1.068.5.501.85.632 1.439 1.068.348.283.784.501 1.286.72 1.722.5 4.926-1.156 6.888-1.876m-12.207-2.79c0 .196.718 1.155 1.503 1.722l1.068 1.068c.502.437.85.633 1.44 1.069.348.195.784.501 1.285.632 1.723.501 4.84-1.003 6.89-1.723",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path686 || (_path686 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .196.718 1.068 1.503 1.722.35.283.72.654 1.068 1.004.502.413.938.566 1.44 1.002.348.196.784.501 1.285.632 1.723.566 4.84-.85 6.89-1.592m-12.187-2.768c0 .196.72 1.003 1.504 1.656.35.285.72.633 1.156 1.004.414.348.85.567 1.374.938.349.282.85.5 1.286.631 1.809.501 4.84-.72 6.888-1.439",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path687 || (_path687 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .13.653.937 1.503 1.592.35.282.72.632 1.156.937.414.414.85.632 1.374.937a4.686 4.686 0 0 0 1.286.632c1.809.567 4.773-.567 6.888-1.286m-12.207-2.812c0 .13.653.937 1.503 1.504.35.349.72.632 1.156.937.414.349.85.567 1.374.938.414.196.85.414 1.286.567 1.809.566 4.773-.415 6.888-1.156m-12.207-2.79c0 .13.653.85 1.503 1.439.35.282.72.567 1.156.937.414.349.85.567 1.374.85.414.196.85.414 1.286.633 1.875.501 4.773-.35 6.888-1.069",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path688 || (_path688 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .13.653.785 1.503 1.439.35.196.72.501 1.156.785.414.414.85.566 1.439.937.349.196.784.349 1.22.502 1.941.566 4.71-.132 6.889-.85m-12.207-2.813c0 .13.653.72 1.503 1.374.35.282.72.567 1.156.784.414.35.85.567 1.439.85.349.197.784.414 1.22.502 1.941.632 4.71 0 6.889-.72",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path689 || (_path689 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337s.653.72 1.503 1.286c.35.197.72.567 1.156.785.414.349.937.567 1.439.784.349.197.85.35 1.22.567 1.941.567 4.622.13 6.889-.632m-12.207-2.79c0 .065.653.654 1.503 1.22.35.284.72.502 1.156.786.414.282.937.501 1.439.784.414.132.85.349 1.22.501 2.027.568 4.622.284 6.889-.501",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path690 || (_path690 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337c0 .065.567.654 1.503 1.22a12.926 12.926 0 0 1 1.156.72c.414.283.937.501 1.439.72.414.195.85.348 1.22.501 2.027.567 4.622.414 6.889-.349m-12.207-2.812s.567.502 1.503 1.155c.35.196.72.414 1.221.72.35.195.85.414 1.351.632.416.195.851.348 1.221.501 2.028.633 4.556.567 6.89-.196",
    fill: "none",
    stroke: "#0049af",
    strokeWidth: 0.23187
  })), _path691 || (_path691 = /*#__PURE__*/React.createElement("path", {
    d: "M449.827 295.337s.567.502 1.503 1.068c.35.197.72.415 1.221.633.35.282.85.5 1.351.719.416.13.851.282 1.221.414 2.094.567 4.556.719 6.89-.066m-12.187-2.768s6.3 4.926 12.252 2.812",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path692 || (_path692 = /*#__PURE__*/React.createElement("path", {
    d: "M449.543 275.892s1.22 7.913 1.721 9.07c.35 1 2.9 5.491 6.672 6.516",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path693 || (_path693 = /*#__PURE__*/React.createElement("path", {
    d: "M449.543 275.892s1.286 7.825 1.81 8.915c.413 1.003 2.746 5.364 6.67 6.671",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path694 || (_path694 = /*#__PURE__*/React.createElement("path", {
    d: "M449.609 275.826s1.373 7.76 1.874 8.981c.348 1.003 2.594 5.08 6.518 6.671",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path695 || (_path695 = /*#__PURE__*/React.createElement("path", {
    d: "M449.609 275.826s1.437 7.76 1.939 8.916c.415 1.004 2.377 4.84 6.453 6.671",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path696 || (_path696 = /*#__PURE__*/React.createElement("path", {
    d: "M449.609 275.826s1.503 7.673 2.026 8.764c.502 1.068 2.312 4.708 6.366 6.802",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path697 || (_path697 = /*#__PURE__*/React.createElement("path", {
    d: "M449.609 275.826s1.59 7.608 2.157 8.764c.415 1.002 2.094 4.338 6.235 6.802",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path698 || (_path698 = /*#__PURE__*/React.createElement("path", {
    d: "M449.609 275.826s1.655 7.543 2.245 8.699c.5 1.002 1.94 4.12 6.147 6.801",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path699 || (_path699 = /*#__PURE__*/React.createElement("path", {
    d: "M449.674 275.826s1.656 7.456 2.245 8.632c.5 1.07 1.874 3.903 6.082 6.89",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path700 || (_path700 = /*#__PURE__*/React.createElement("path", {
    d: "M449.674 275.826s1.809 7.39 2.31 8.546c.567 1.068 1.744 3.683 6.083 6.954",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path701 || (_path701 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 275.76s1.81 7.457 2.376 8.547c.501 1.067 1.505 3.4 5.93 7.02",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path702 || (_path702 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 275.76s1.875 7.326 2.442 8.48c.566 1.069 1.373 3.184 5.864 7.02",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path703 || (_path703 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 275.76s2.027 7.326 2.529 8.415c.566 1.069 1.285 2.965 5.864 7.02",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path704 || (_path704 = /*#__PURE__*/React.createElement("path", {
    d: "M449.761 275.674s2.093 7.324 2.593 8.393c.568 1.068 1.157 2.747 5.777 7.107",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path705 || (_path705 = /*#__PURE__*/React.createElement("path", {
    d: "M450.045 271.03s1.001 11.162 8.98 14.214",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path706 || (_path706 = /*#__PURE__*/React.createElement("path", {
    d: "M450.045 271.03c.065 0 .5 3.554 2.092 7.02 1.221 2.68 3.335 5.711 6.888 7.171",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path707 || (_path707 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 271.03s.501 3.619 2.093 7.02c1.155 2.376 3.269 5.582 6.801 7.171",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path708 || (_path708 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 271.03c0 .066.632 3.77 2.158 6.888 1.155 2.312 3.182 5.582 6.736 7.238",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path709 || (_path709 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 271.03c0 .066.719 3.837 2.31 6.888 1.003 2.094 3.03 5.494 6.584 7.173",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path710 || (_path710 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 271.03c.066.131.85 3.99 2.376 6.801.937 1.876 3.03 5.43 6.517 7.238",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path711 || (_path711 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 271.03c0 .131.937 4.055 2.398 6.736.85 1.744 2.965 5.363 6.452 7.326",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path712 || (_path712 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 270.965c.065.196 1.068 4.207 2.464 6.736.784 1.504 2.899 5.276 6.365 7.326",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path713 || (_path713 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 270.965c.065.196 1.155 4.338 2.616 6.67.72 1.44 2.747 5.276 6.235 7.39",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path714 || (_path714 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 270.965c0 .283 1.22 4.425 2.594 6.67.634 1.156 2.66 5.145 6.147 7.39",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path715 || (_path715 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 270.965c.065.283 1.374 4.49 2.66 6.604.633 1.004 2.594 5.06 6.082 7.391",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path716 || (_path716 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 270.965c.065.283 1.504 4.622 2.813 6.518.501.785 2.462 4.992 5.929 7.455",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path717 || (_path717 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 270.965c.065.283 1.592 4.709 2.9 6.452.414.633 2.375 4.993 5.864 7.544",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path718 || (_path718 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 267.914s2.31 8.98 8.85 11.16",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path719 || (_path719 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 267.914s.936 3.182 3.03 6.234c1.373 2.093 3.4 4.12 5.8 4.926",
    fill: "none",
    stroke: "#00056b",
    strokeWidth: 0.23187
  })), _path720 || (_path720 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 267.914s.936 3.117 3.03 6.146c1.504 2.093 3.554 4.273 5.8 4.993",
    fill: "none",
    stroke: "#00096f",
    strokeWidth: 0.23187
  })), _path721 || (_path721 = /*#__PURE__*/React.createElement("path", {
    d: "M450.11 267.848s1.004 3.117 3.183 6.147c1.504 2.158 3.618 4.338 5.646 5.058",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path722 || (_path722 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 267.782s.937 3.03 3.183 6.235c1.505 2.092 3.771 4.425 5.58 5.057",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path723 || (_path723 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 267.782s1.003 2.965 3.248 6.083c1.592 2.223 3.837 4.556 5.494 5.144",
    fill: "none",
    stroke: "#001c82",
    strokeWidth: 0.23187
  })), _path724 || (_path724 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 267.782s1.068 2.965 3.248 6.017c1.722 2.31 4.055 4.708 5.494 5.21",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path725 || (_path725 = /*#__PURE__*/React.createElement("path", {
    d: "M450.197 267.695s1.068 2.965 3.4 6.017c1.723 2.31 4.055 4.84 5.364 5.275",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path726 || (_path726 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.695s1.004 2.812 3.401 5.929c1.743 2.377 4.207 4.927 5.276 5.276",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path727 || (_path727 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.695s1.068 2.747 3.466 5.865c1.788 2.376 4.273 5.056 5.211 5.362",
    fill: "none",
    stroke: "#002f96",
    strokeWidth: 0.23187
  })), _path728 || (_path728 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.63s1.068 2.747 3.554 5.864c1.809 2.375 4.425 5.21 5.143 5.428",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path729 || (_path729 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.63s1.156 2.68 3.619 5.864c1.874 2.375 4.556 5.21 5.058 5.428",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path730 || (_path730 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.63s1.22 2.593 3.685 5.71c1.939 2.53 4.709 5.43 4.992 5.582",
    fill: "none",
    stroke: "#0042a8",
    strokeWidth: 0.23187
  })), _path731 || (_path731 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.564s1.22 2.594 3.771 5.711c1.94 2.529 4.775 5.582 4.993 5.646",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path732 || (_path732 = /*#__PURE__*/React.createElement("path", {
    d: "M450.262 267.476s1.286 2.53 3.837 5.713c2.027 2.594 4.927 5.646 4.927 5.646m8.436 1.351 4.426.785m-3.99 2.55 3.99-1.656",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path733 || (_path733 = /*#__PURE__*/React.createElement("path", {
    d: "m467.397 280.251 4.425.72",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path734 || (_path734 = /*#__PURE__*/React.createElement("path", {
    d: "m467.397 280.47 4.49.501",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path735 || (_path735 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 280.622 4.49.349",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path736 || (_path736 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 280.753 4.49.282",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path737 || (_path737 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 280.971 4.556.065",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path738 || (_path738 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 281.124 4.556-.066",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path739 || (_path739 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 281.276 4.621-.197",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path740 || (_path740 = /*#__PURE__*/React.createElement("path", {
    d: "m467.463 281.407 4.708-.283",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path741 || (_path741 = /*#__PURE__*/React.createElement("path", {
    d: "m467.528 281.56 4.622-.414",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path742 || (_path742 = /*#__PURE__*/React.createElement("path", {
    d: "m467.898 283.303 4.055-1.504",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path743 || (_path743 = /*#__PURE__*/React.createElement("path", {
    d: "m467.81 283.15 4.121-1.438",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path744 || (_path744 = /*#__PURE__*/React.createElement("path", {
    d: "m467.81 283.02 4.21-1.374",
    fill: "none",
    stroke: "#00359c",
    strokeWidth: 0.23187
  })), _path745 || (_path745 = /*#__PURE__*/React.createElement("path", {
    d: "m467.745 282.801 4.274-1.22",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path746 || (_path746 = /*#__PURE__*/React.createElement("path", {
    d: "m467.745 282.65 4.34-1.156",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path747 || (_path747 = /*#__PURE__*/React.createElement("path", {
    d: "m467.745 282.498 4.426-1.07",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path748 || (_path748 = /*#__PURE__*/React.createElement("path", {
    d: "m467.68 282.28 4.491-.851",
    fill: "none",
    stroke: "#00167c",
    strokeWidth: 0.23187
  })), _path749 || (_path749 = /*#__PURE__*/React.createElement("path", {
    d: "m467.68 282.061 4.556-.785",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path750 || (_path750 = /*#__PURE__*/React.createElement("path", {
    d: "m467.68 281.93 4.556-.654",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path751 || (_path751 = /*#__PURE__*/React.createElement("path", {
    d: "m467.616 281.777 4.708-.565",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path752 || (_path752 = /*#__PURE__*/React.createElement("path", {
    d: "M454.84 310.508c-.501-.346-1.44-1.283-1.723-2.154-.631-1.657-.5-1.596-.936-3.471-.197-1.066-.197-2.244-.501-3.334-.132-1.068-1.744-4.621-1.81-6.016-.131-4.622-1.656-7.76-1.287-12.753.283-3.902 1.156-9.2.72-13.276-.131-1.068.066-2.31.066-3.467l22.976 15.217",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path753 || (_path753 = /*#__PURE__*/React.createElement("path", {
    d: "M449.172 264.883c-.13-.85.065-2.03.72-2.157.065 0 .502-.134.784-.068.349 0 .415.13.633.437.283.784-.633 1.286-1.286 1.504-.196.066-.633.131-.72.349-.131.349-.066.197-.131.349.132-.065.132-.196.283-.283.502-.283 1.004-.35 1.723-.72.567-.195.633-1.373.283-1.658-.415-.345-1.722-.284-2.027 0-.633.72-.72 1.724-.567 2.682 0-.194.349-.13.283-.414",
    fill: "#fc0"
  })), _path754 || (_path754 = /*#__PURE__*/React.createElement("path", {
    d: "M449.172 264.883c-.13-.85.065-2.03.72-2.157 0 0 .502-.134.784-.068.349 0 .415.13.633.437.283.784-.633 1.286-1.286 1.504-.196.066-.633.131-.72.349-.131.349-.066.197-.131.349.132-.065.132-.196.283-.283.502-.283 1.004-.35 1.723-.72.567-.195.633-1.373.283-1.658-.415-.345-1.722-.284-2.027 0-.633.72-.72 1.724-.567 2.682 0-.194.349-.13.283-.414z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path755 || (_path755 = /*#__PURE__*/React.createElement("path", {
    d: "M448.802 265.318c-.85 0-2.028.349-2.094.938 0 .131-.065.633 0 .85.066.349.197.501.502.567.85.197 1.22-.784 1.374-1.505 0-.13 0-.566.195-.718.35-.132.284-.067.35-.132a.797.797 0 0 0-.197.284c-.195.501-.195 1.069-.501 1.81-.13.567-1.22.784-1.591.436-.415-.35-.567-1.657-.283-1.94.632-.72 1.657-.938 2.593-.938-.13.065-.13.413-.348.348",
    fill: "#fc0"
  })), _path756 || (_path756 = /*#__PURE__*/React.createElement("path", {
    d: "M448.802 265.318c-.85 0-2.028.349-2.094.938 0 .131-.065.633 0 .85.066.349.197.501.502.567.85.197 1.22-.784 1.374-1.505 0-.13 0-.566.195-.718.35-.132.284-.067.35-.132a.797.797 0 0 0-.197.284c-.195.501-.195 1.069-.501 1.81-.13.567-1.22.784-1.591.436-.415-.35-.567-1.657-.283-1.94.632-.72 1.657-.938 2.593-.938-.13.065-.13.413-.348.348",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path757 || (_path757 = /*#__PURE__*/React.createElement("path", {
    d: "M448.584 264.948c-.196.13-.196.414-.066.632.066.197.436.283.567.13.35-.13.566-.565.35-.85-.198-.282-.503-.065-.851.067",
    fill: "#fc0"
  })), _path758 || (_path758 = /*#__PURE__*/React.createElement("path", {
    d: "M448.584 264.948c-.196.13-.196.414-.066.632.066.197.436.283.567.13.35-.13.566-.565.35-.85-.198-.282-.503-.065-.851.067z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path759 || (_path759 = /*#__PURE__*/React.createElement("path", {
    d: "M443.723 261.833s2.463.998 4.424.998c0 0 .066 1.724.502 2.226 0 0-1.722-.282-2.594.065 0 0-1.004-2.373-2.311-3.334",
    fill: "#fc0"
  })), _path760 || (_path760 = /*#__PURE__*/React.createElement("path", {
    d: "M443.723 261.833s2.463.998 4.424.998c0 0 .066 1.724.502 2.226 0 0-1.744-.282-2.594.065 0 0-1.004-2.373-2.311-3.334z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path761 || (_path761 = /*#__PURE__*/React.createElement("path", {
    d: "M445.684 263.05s1.004.418 1.81.418c0 0 0 .63.196.848 0 0-.72-.065-1.003.065 0 0-.414-1.003-1.003-1.354z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path762 || (_path762 = /*#__PURE__*/React.createElement("path", {
    d: "M448.802 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068.566.72.719 2.158.719 2.593-.654.197-1.221.569-2.18.066-.349-.195-.066-.784 0-1.286.13-.283.196-1.002.501-1.374",
    fill: "#fc0"
  })), _path763 || (_path763 = /*#__PURE__*/React.createElement("path", {
    d: "M448.802 266.823s.414-.785.567-1.068c.065-.13-.065.937.349 1.068.566.72.719 2.158.719 2.593-.654.197-1.221.569-2.18.066-.349-.195-.066-.784 0-1.286.13-.283.196-1.002.501-1.374z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path764 || (_path764 = /*#__PURE__*/React.createElement("path", {
    d: "M449.237 266.19c0 .132.067.633.067.567 0-.196.194.197.282.283.349.655.415 1.07.567 2.311m-.698-2.092c.196.937.35.937.35 2.245l.13-.065m-.48-1.308c.131.632.066 1.003.131 1.373l-.282.13",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path765 || (_path765 = /*#__PURE__*/React.createElement("path", {
    d: "M471.452 314.213c1.81 1.658 5.21 2.528 5.798 2.97 1.22.847 3.03 2.153 6.147 2.31 2.247.195 3.25-.419 5.582-.72 2.68-.285-.35.128 2.246-.42 1.286-.344 1.286-.562 3.117-.93 1.286-.352 2.594-.637 3.4-1.725.283-.413.501-.787.567-1.44h1.743c.197.503-.282 1.44-.5 1.808-.065.135-.283.436-.414.659-.283.496-.197.345-.633.781-.131.067-.72.57-.871.631-.35.285-.634.57-1.07.636-1.655.279-2.376.63-4.054 1.155-1.591.413-.72.346-1.875.631-.632.129-1.788.569-2.376.63-1.067.195-1.22.352-2.31.57-2.813.63-5.581.502-8.328.285-1.156-.068-3.99-.637-4.927-1.29-1.743-1.222-5.515-1.719-7.238-2.896-.195-.134-1.286-.637-1.503-.854-1.57-1.373-2.965-1.72-4.622-2.813h12.252",
    fill: "#004bb3"
  })), _path766 || (_path766 = /*#__PURE__*/React.createElement("path", {
    d: "M484.793 314.213c1.22.636 1.81 1.658 5.21 2.746 1.286 0 2.747.57 3.99.502-1.505.352-1.505.57-2.747.855-2.594.562.414.128-2.245.413-2.311.284-3.336.937-5.581.72-3.118-.135-4.927-1.44-6.147-2.311-.567-.413-3.99-1.29-5.8-2.97h13.342",
    fill: "#fff"
  })), _path767 || (_path767 = /*#__PURE__*/React.createElement("path", {
    d: "M484.793 314.213h13.56c-.066.636-.284 1.005-.567 1.44-.785 1.072-2.093 1.374-3.4 1.725-1.439.279-2.9-.42-4.34-.42-3.553-1.064-3.988-2.242-5.209-2.745",
    fill: "#004bb3"
  })), _path768 || (_path768 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 314.213s-2.377.135-2.53.135c-.13 0-9.7-.135-9.7-.135",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path769 || (_path769 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 314.28s-2.377.13-2.53.195c-.282.068-9.634-.127-9.634-.127",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path770 || (_path770 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 314.37s-2.312.195-2.66.279c-.35 0-9.505-.279-9.505-.279",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path771 || (_path771 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 314.37s-2.225.279-2.748.346c-.501.133-9.352-.284-9.352-.284",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path772 || (_path772 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 314.43s-2.16.286-2.748.42c-.633.128-9.265-.42-9.265-.42",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path773 || (_path773 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 314.43s-2.094.42-2.813.57c-.72.129-9.134-.502-9.134-.502",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path774 || (_path774 = /*#__PURE__*/React.createElement("path", {
    d: "M471.736 314.43s-2.029.503-2.9.721c-.851.195-8.981-.564-8.981-.564",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path775 || (_path775 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 314.499s-2.027.569-3.03.786c-.937.128-8.85-.72-8.85-.72",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path776 || (_path776 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 314.587s-1.94.63-3.03.848c-1.068.196-8.763-.786-8.763-.786",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path777 || (_path777 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 314.587s-1.874.72-3.116.999c-1.221.201-8.634-.848-8.634-.848",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path778 || (_path778 = /*#__PURE__*/React.createElement("path", {
    d: "M471.8 314.649s-1.81.787-3.116 1.004c-1.374.285-8.546-.937-8.546-.937",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path779 || (_path779 = /*#__PURE__*/React.createElement("path", {
    d: "M459.33 314.213h12.34",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path780 || (_path780 = /*#__PURE__*/React.createElement("path", {
    d: "M460.203 314.805s6.955 1.284 8.415 1c1.503-.28 3.248-1.156 3.248-1.156",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path781 || (_path781 = /*#__PURE__*/React.createElement("path", {
    d: "M473.48 319.643s4.425.632 4.555.632c.066 0 2.595-.195 2.682-.195l2.18-.503",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path782 || (_path782 = /*#__PURE__*/React.createElement("path", {
    d: "M473.196 319.577s4.556.72 4.926.636c.13-.068 2.464-.201 2.53-.201.13 0 2.026-.413 2.026-.413",
    fill: "none",
    stroke: "#001178",
    strokeWidth: 0.23187
  })), _path783 || (_path783 = /*#__PURE__*/React.createElement("path", {
    d: "M472.978 319.447s4.621.783 5.144.632c.197 0 2.312-.129 2.53-.129.13 0 1.809-.434 1.809-.434",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path784 || (_path784 = /*#__PURE__*/React.createElement("path", {
    d: "M472.672 319.292s4.774.854 5.429.72c.349 0 2.245-.128 2.463-.128.196-.068 1.657-.352 1.657-.352",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path785 || (_path785 = /*#__PURE__*/React.createElement("path", {
    d: "M472.454 319.23s4.84.849 5.647.721c.414-.068 2.092-.134 2.463-.201.283 0 1.438-.195 1.438-.195",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path786 || (_path786 = /*#__PURE__*/React.createElement("path", {
    d: "M472.171 319.074s4.991 1.005 6.016.787c.502-.067 1.94-.128 2.312-.194.349 0 1.351-.196 1.351-.196",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path787 || (_path787 = /*#__PURE__*/React.createElement("path", {
    d: "M471.953 319.013s5.08.999 6.234.781c.634-.061 1.876-.195 2.225-.195.413-.068 1.22-.128 1.22-.128",
    fill: "none",
    stroke: "#0039a0",
    strokeWidth: 0.23187
  })), _path788 || (_path788 = /*#__PURE__*/React.createElement("path", {
    d: "M471.67 318.923s5.21 1.066 6.517.787c.72-.133 1.723-.194 2.225-.194.413-.068 1.003-.068 1.003-.068",
    fill: "none",
    stroke: "#0045ab",
    strokeWidth: 0.23187
  })), _path789 || (_path789 = /*#__PURE__*/React.createElement("path", {
    d: "m473.696 319.794 4.34.57 2.681-.134 2.31-.564",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path790 || (_path790 = /*#__PURE__*/React.createElement("path", {
    d: "M471.452 318.795s5.362 1.155 6.8.848c1.44-.284 2.966-.284 2.966-.284m11.402.09s2.812-1.005 4.207-1.507c2.594-.999 2.9-3.617 2.9-3.617m-7.39 4.253s1.655-.636 3.116-1.156c3.685-1.44 3.248-3.185 3.248-3.185",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path791 || (_path791 = /*#__PURE__*/React.createElement("path", {
    d: "M492.118 318.706s2.158-.787 3.335-1.222c.566-.195 1.287-.564 1.723-.782.5-.284 1.067-.937 1.286-1.221.282-.503.282-1.223.282-1.223",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path792 || (_path792 = /*#__PURE__*/React.createElement("path", {
    d: "M491.833 318.923s2.747-1.003 3.62-1.372a23.04 23.04 0 0 0 1.656-.72c.35-.285 1.222-.937 1.374-1.155.283-.413.415-1.44.415-1.44",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path793 || (_path793 = /*#__PURE__*/React.createElement("path", {
    d: "M491.616 319.074s3.27-1.155 3.837-1.373c.284-.128 1.44-.63 1.591-.72.283-.128 1.439-1.066 1.505-1.217.13-.2.414-1.506.414-1.506",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path794 || (_path794 = /*#__PURE__*/React.createElement("path", {
    d: "M491.333 319.292s3.837-1.373 4.12-1.5c.066-.069 1.505-.57 1.591-.632.132-.067 1.505-1.155 1.505-1.222.13-.134.566-1.59.566-1.59",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path795 || (_path795 = /*#__PURE__*/React.createElement("path", {
    d: "M492.336 319.447s3.4-1.221 4.49-1.656c.85-.285 1.657-1.005 2.028-1.506.567-.782.785-1.937.785-1.937",
    fill: "none",
    stroke: "#003ca2",
    strokeWidth: 0.23187
  })), _path796 || (_path796 = /*#__PURE__*/React.createElement("path", {
    d: "M491.987 319.447s4.055-1.438 4.927-1.807c.567-.201 1.657-1.071 1.874-1.44.415-.57.72-1.875.72-1.875",
    fill: "none",
    stroke: "#002d93",
    strokeWidth: 0.23187
  })), _path797 || (_path797 = /*#__PURE__*/React.createElement("path", {
    d: "M491.681 319.516s4.71-1.814 5.277-1.943c.348-.134 1.591-1.155 1.808-1.373.284-.413.634-1.875.634-1.875",
    fill: "none",
    stroke: "#001e85",
    strokeWidth: 0.23187
  })), _path798 || (_path798 = /*#__PURE__*/React.createElement("path", {
    d: "M491.398 319.516s5.276-2.032 5.582-2.094c.195-.067 1.59-1.16 1.721-1.289.132-.195.655-1.808.655-1.808",
    fill: "none",
    stroke: "#000f75",
    strokeWidth: 0.23187
  })), _path799 || (_path799 = /*#__PURE__*/React.createElement("path", {
    d: "m491.114 319.516 5.93-2.25 1.592-1.222.567-1.719",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path800 || (_path800 = /*#__PURE__*/React.createElement("path", {
    d: "M498.004 314.213s-2.53.135-2.594.135c-.131 0-10.137-.135-10.137-.135",
    fill: "none",
    stroke: "#00066d",
    strokeWidth: 0.23187
  })), _path801 || (_path801 = /*#__PURE__*/React.createElement("path", {
    d: "M498.004 314.28s-2.464.13-2.682.195c-.283.068-10.005-.127-10.005-.127",
    fill: "none",
    stroke: "#000b73",
    strokeWidth: 0.23187
  })), _path802 || (_path802 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07 314.37s-2.378.195-2.813.279c-.35 0-9.853-.279-9.853-.279",
    fill: "none",
    stroke: "#001379",
    strokeWidth: 0.23187
  })), _path803 || (_path803 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07 314.37s-2.312.279-2.813.346c-.501.133-9.788-.284-9.788-.284",
    fill: "none",
    stroke: "#00187e",
    strokeWidth: 0.23187
  })), _path804 || (_path804 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07 314.43s-2.246.286-2.9.42c-.633.128-9.635-.42-9.635-.42",
    fill: "none",
    stroke: "#002086",
    strokeWidth: 0.23187
  })), _path805 || (_path805 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07 314.43s-2.159.42-2.9.57c-.785.129-9.57-.502-9.57-.502",
    fill: "none",
    stroke: "#00258b",
    strokeWidth: 0.23187
  })), _path806 || (_path806 = /*#__PURE__*/React.createElement("path", {
    d: "M498.07 314.43s-2.093.503-2.965.721c-.85.195-9.418-.564-9.418-.564",
    fill: "none",
    stroke: "#002b91",
    strokeWidth: 0.23187
  })), _path807 || (_path807 = /*#__PURE__*/React.createElement("path", {
    d: "M498.157 314.499s-2.093.569-3.118.786c-1.003.128-9.265-.72-9.265-.72",
    fill: "none",
    stroke: "#039",
    strokeWidth: 0.23187
  })), _path808 || (_path808 = /*#__PURE__*/React.createElement("path", {
    d: "M498.157 314.587s-1.962.63-3.184.848c-1.068.196-9.134-.786-9.134-.786",
    fill: "none",
    stroke: "#00389e",
    strokeWidth: 0.23187
  })), _path809 || (_path809 = /*#__PURE__*/React.createElement("path", {
    d: "M498.222 314.587s-2.027.72-3.249.999c-1.286.201-8.98-.848-8.98-.848",
    fill: "none",
    stroke: "#003ea6",
    strokeWidth: 0.23187
  })), _path810 || (_path810 = /*#__PURE__*/React.createElement("path", {
    d: "M498.222 314.649s-1.94.787-3.336 1.004c-1.373.285-8.85-.937-8.85-.937",
    fill: "none",
    stroke: "#0046ad",
    strokeWidth: 0.23187
  })), _path811 || (_path811 = /*#__PURE__*/React.createElement("path", {
    d: "M485.163 314.213h12.84",
    fill: "none",
    stroke: "#006",
    strokeWidth: 0.23187
  })), _path812 || (_path812 = /*#__PURE__*/React.createElement("path", {
    d: "M486.036 314.805s7.325 1.284 8.85 1c1.44-.28 3.336-1.156 3.336-1.156",
    fill: "none",
    stroke: "#004bb3",
    strokeWidth: 0.23187
  })), _path813 || (_path813 = /*#__PURE__*/React.createElement("path", {
    d: "M500.096 314.213c.197.503-.282 1.44-.5 1.814-.065.129-.284.436-.415.653-.283.503-.195.346-.632.781-.131.068-.72.57-.873.636-.348.28-.632.564-1.067.632-1.657.284-2.377.63-4.055 1.155-1.591.413-.72.346-1.875.63-.633.134-1.788.569-2.377.63-1.068.202-1.22.352-2.31.57-2.812.63-5.58.502-8.327.285-1.155-.067-3.99-.632-4.927-1.29-1.744-1.215-5.516-1.718-7.238-2.896-.196-.134-1.286-.63-1.503-.854-1.57-1.373-2.965-1.719-4.623-2.807",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.23187
  })), _path814 || (_path814 = /*#__PURE__*/React.createElement("path", {
    d: "m550.673 314.213-49.028-81.964-48.963 81.964Z",
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 0.5796749999999999
  })), _path815 || (_path815 = /*#__PURE__*/React.createElement("path", {
    d: "m545.964 311.534-44.319-73.99-44.166 73.99Z",
    fill: "#fff"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    strokeWidth: 0.786
  }, /*#__PURE__*/React.createElement("path", {
    d: "M493.95 250.516c2.092-1.876 4.62-2.68 7.607-2.68h.196c2.813 0 5.712.72 7.608 2.68",
    stroke: "#00a8ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.95 250.582c2.025-1.942 4.62-2.595 7.607-2.679h.196c2.9 0 5.865.714 7.674 2.68",
    stroke: "#009eff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.862 250.65c2.027-1.943 4.709-2.685 7.695-2.685h.196c2.965 0 5.93.72 7.762 2.746",
    stroke: "#0096ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.796 250.8c2.028-2.027 4.775-2.746 7.762-2.746h.282c2.965 0 5.93.72 7.827 2.813",
    stroke: "#008bff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.731 250.867c2.027-2.032 4.84-2.747 7.892-2.813h.196c3.03.066 6.016.781 7.914 2.964",
    stroke: "#0082ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.644 250.934c2.027-2.099 4.839-2.814 7.979-2.814h.196c3.117.062 6.082.85 7.978 3.031",
    stroke: "#0079ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.644 251.084c1.961-2.093 4.839-2.902 7.979-2.902h.196c3.247.068 6.147.854 8.11 3.12",
    stroke: "#006fff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.078 251.955c2.31-2.46 5.21-3.18 8.633-3.18h.194c3.772.06 6.956 1.282 8.851 3.9",
    stroke: "#1609ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.143 251.826c2.245-2.31 5.144-3.03 8.545-3.12h.196c3.684.068 6.802 1.29 8.7 3.84",
    stroke: "#1316ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.207 251.738c2.246-2.377 5.059-3.12 8.393-3.12h.197c3.618.066 6.802 1.222 8.698 3.772",
    stroke: "#1120ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.207 251.67c2.246-2.31 5.059-3.03 8.393-3.114h.197c3.553.061 6.67 1.155 8.633 3.683",
    stroke: "#0f2dff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.36 251.52c2.093-2.244 4.927-2.964 8.263-2.964h.13c3.554 0 6.671 1 8.633 3.55",
    stroke: "#0938ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.36 251.452c2.093-2.243 4.992-2.962 8.197-2.962h.196c3.467 0 6.584.937 8.48 3.398",
    stroke: "#0645ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.426 251.39c2.027-2.248 4.927-2.968 8.11-2.968h.196c3.4 0 6.43.854 8.415 3.338",
    stroke: "#054fff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M493.513 251.235c1.94-2.16 4.84-2.896 8.044-2.896h.131c3.4 0 6.453.78 8.394 3.248",
    stroke: "#025cff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.762 245.655c1.439-1.006 2.964-1.284 4.838-1.284 1.81 0 3.466.278 4.84 1.217",
    stroke: "#ff0500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.762 245.721c1.439-1.004 2.964-1.289 4.838-1.289 1.81 0 3.466.285 4.84 1.222",
    stroke: "#ff0b00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.696 245.788c1.505-1.004 3.03-1.29 4.927-1.29 1.809 0 3.554.286 4.992 1.223",
    stroke: "#f10",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.696 245.938c1.44-1.003 3.03-1.372 4.927-1.372 1.874 0 3.554.346 4.992 1.222",
    stroke: "#ff1800",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.63 246.005c1.44-1.004 3.118-1.373 4.993-1.373 1.874 0 3.619.347 5.058 1.285",
    stroke: "#ff1e00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.543 246.067c1.505-.999 3.183-1.374 5.057-1.374 1.876 0 3.62.353 5.058 1.29",
    stroke: "#ff2500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.543 246.224c1.44-1.094 3.118-1.44 5.057-1.44 1.876 0 3.685.346 5.146 1.283",
    stroke: "#ff2d00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.478 246.285c1.504-1.067 3.183-1.435 5.145-1.435 1.962 0 3.77.347 5.21 1.374",
    stroke: "#f30",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.478 246.374c1.44-1.066 3.183-1.44 5.145-1.44 1.962 0 3.77.352 5.276 1.374",
    stroke: "#ff3900",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.412 246.44c1.505-1.07 3.249-1.439 5.212-1.439 1.96 0 3.835.413 5.275 1.374",
    stroke: "#ff3e00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.324 246.525c1.505-1.066 3.25-1.434 5.276-1.434 1.962 0 3.838.435 5.364 1.372",
    stroke: "#ff4500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.235 248.467c1.592-1.284 4.273-1.942 6.453-1.942 2.31 0 4.84.636 6.517 1.942",
    stroke: "#fff500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.322 248.339c1.592-1.29 4.208-1.876 6.366-1.876 2.245 0 4.774.564 6.453 1.937",
    stroke: "#ffeb00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.388 248.249c1.591-1.283 4.12-1.875 6.3-1.875 2.245 0 4.71.57 6.365 1.875",
    stroke: "#ffe000",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.453 248.12c1.591-1.221 4.055-1.812 6.235-1.812 2.245 0 4.71.568 6.3 1.812",
    stroke: "#ffd600",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.453 248.054c1.591-1.222 4.055-1.808 6.235-1.808 2.158 0 4.556.563 6.235 1.808",
    stroke: "#ffcf00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.54 247.903c1.657-1.222 3.99-1.814 6.17-1.814 2.158 0 4.555.57 6.147 1.876",
    stroke: "#ffc500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.605 247.837c1.592-1.223 3.903-1.81 6.083-1.81 2.158 0 4.49.565 6.082 1.81",
    stroke: "#ffb900",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.672 247.68c1.59-1.155 3.836-1.72 6.016-1.72 2.158 0 4.426.565 6.016 1.72",
    stroke: "#ffaf00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.76 247.619c1.59-1.223 3.77-1.724 5.95-1.724 2.093 0 4.425.568 5.93 1.724",
    stroke: "#ffa600",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.824 247.462c1.504-1.154 3.684-1.651 5.864-1.651 2.006 0 4.273.497 5.865 1.65",
    stroke: "#ff9c00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.824 247.4c1.591-1.154 3.771-1.656 5.864-1.656 2.006 0 4.273.502 5.777 1.59",
    stroke: "#ff9100",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.954 247.245c1.505-1.156 3.62-1.657 5.734-1.657 2.006 0 4.208.501 5.711 1.657",
    stroke: "#ff8600",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.954 247.183c1.592-1.155 3.62-1.657 5.734-1.657 2.006 0 4.12.502 5.711 1.59",
    stroke: "#ff7c00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.042 247.028c1.504-1.067 3.553-1.591 5.646-1.591 1.94 0 4.054.501 5.581 1.59",
    stroke: "#ff7500",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.107 246.966c1.592-1.155 3.467-1.597 5.582-1.597 1.938 0 3.988.442 5.492 1.53",
    stroke: "#ff6b00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.172 246.81c1.504-1.066 3.402-1.501 5.516-1.501 1.94 0 3.99.412 5.493 1.5",
    stroke: "#ff6000",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M496.26 246.748c1.504-1.16 3.335-1.507 5.428-1.507 1.874 0 3.902.435 5.428 1.44",
    stroke: "#ff5600",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M495.018 248.617c1.744-1.283 4.338-1.936 6.67-1.936 2.376 0 4.927.631 6.583 2.026",
    stroke: "#ebff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.952 248.774c1.81-1.44 4.425-2.026 6.736-2.026 2.376 0 4.993.714 6.736 2.087",
    stroke: "#d6ff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.886 248.902c1.876-1.5 4.426-2.093 6.802-2.093 2.376 0 5.058.721 6.736 2.093",
    stroke: "#c2ff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.821 249.058c2.027-1.596 4.426-2.159 6.89-2.159 2.376 0 5.055.72 6.8 2.16",
    stroke: "#adff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.734 249.12c2.093-1.59 4.492-2.154 6.889-2.154 2.529 0 5.21.714 6.953 2.153",
    stroke: "#9f0",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.668 249.276c2.159-1.724 4.426-2.248 6.956-2.248 2.528 0 5.275.72 7.018 2.248",
    stroke: "#85ff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.668 249.427c2.159-1.808 4.426-2.31 6.956-2.31 2.528 0 5.361.72 7.105 2.22",
    stroke: "#6fff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.516 249.556c2.376-1.937 4.491-2.44 7.107-2.44 2.594 0 5.362.849 7.107 2.377",
    stroke: "#5cff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.45 249.644c2.464-1.941 4.492-2.377 7.173-2.377 2.594 0 5.428.787 7.171 2.31",
    stroke: "#46ff00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.08 250.298c2.18-1.876 4.621-2.528 7.608-2.528 2.747 0 5.712.72 7.543 2.528",
    stroke: "#05b9e2",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.167 250.298c2.158-1.937 4.556-2.68 7.544-2.68 2.747 0 5.645.782 7.541 2.529",
    stroke: "#09c5c6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.167 250.147c2.224-1.876 4.621-2.528 7.544-2.528 2.747 0 5.645.72 7.455 2.438",
    stroke: "#11ccab",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.233 250.058c2.245-1.938 4.555-2.529 7.455-2.529 2.68 0 5.581.787 7.39 2.467",
    stroke: "#16d38f",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.233 250.058c2.31-2.004 4.555-2.596 7.39-2.596 2.747 0 5.646.787 7.39 2.468",
    stroke: "#1cde6f",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.298 249.996c2.376-2.031 4.49-2.533 7.326-2.533 2.745 0 5.58.786 7.389 2.377",
    stroke: "#20e653",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.386 249.93c2.376-2.027 4.49-2.53 7.238-2.53 2.68 0 5.58.782 7.324 2.373",
    stroke: "#28ed38",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M494.386 249.862c2.44-2.026 4.49-2.528 7.238-2.528 2.593 0 5.58.786 7.324 2.4",
    stroke: "#2df81c",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M506.418 245.504c-1.373-.938-2.964-1.223-4.773-1.223-1.875 0-3.336.285-4.774 1.29",
    stroke: "red",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.844 252.893c-1.874-2.746-5.21-4.058-9.07-4.058-3.552 0-6.364.72-8.762 3.186",
    stroke: "#1800ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M509.319 250.298c-1.876-1.809-4.775-2.528-7.608-2.528-2.966 0-5.516.72-7.696 2.594",
    stroke: "#00b3ff",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M510.038 251.452c-2.028-2.377-5.058-3.18-8.415-3.18-3.118 0-6.083.72-8.11 2.896",
    stroke: "#06f",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.316 248.617c-1.658-1.372-4.273-2.026-6.585-2.026-2.244 0-4.927.631-6.582 1.943",
    stroke: "#ff0",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M507.007 246.525c-1.439-.937-3.4-1.434-5.363-1.434-2.026 0-3.77.435-5.276 1.59",
    stroke: "#ff4b00",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M508.881 249.644c-1.721-1.5-4.62-2.377-7.237-2.377-2.747 0-4.708.503-7.172 2.528",
    stroke: "#3f0",
    strokeWidth: 0.23187
  }))), _path816 || (_path816 = /*#__PURE__*/React.createElement("path", {
    d: "m470.514 289.539-13.058 21.974h88.506l-13.187-21.974h-62.239",
    fill: "#0088e8"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M504.02 302.379c1.157.282 2.53.501 3.903.064 1.875-.413 3.684-1.503 5.93-1.285 1.59.13 3.77 1.504 6.452 1.504 2.592 0 3.486-.937 5.796-1.374 1.596-.348 2.377-.13 4.124.197 1.96.349 2.964 1.504 6.301 1.22",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  }), /*#__PURE__*/React.createElement("path", {
    d: "M469.926 305.58c1.439-1.155 4.054-1.588 6.082-1.155 2.594.569 3.684 1.222 6.517 1.222 2.029-.067 3.838-1.437 5.952-1.437 3.467 0 3.62.718 6.737 1.287a8.789 8.789 0 0 0 2.594 0c1.155-.195 2.18-.57 3.03-1.072 1.003-.499 3.466-.412 4.709-.28 2.18.196 3.03 1.067 3.553 1.157 1.155.345 2.463.496 3.902.127 1.875-.563 3.62-1.808 5.93-1.503 1.591.13 3.77 1.721 6.388 1.721 2.679 0 3.555-1.065 5.776-1.59 1.657-.349 2.46-.13 4.208.197 1.959.41 2.963 1.723 6.3 1.438",
    stroke: "#fff",
    strokeWidth: 0.6372
  }), /*#__PURE__*/React.createElement("path", {
    d: "M464.912 303.12c1.438-1.003 4.055-1.44 6.082-1.003 2.595.5 3.77 1.068 6.517 1.068 2.094-.065 3.837-1.286 5.93-1.286 3.554 0 3.619.632 6.737 1.155a8.6 8.6 0 0 0 2.593 0c1.156-.13 2.16-.567 3.118-.937.85-.414 3.402-.349 4.621-.283 2.159.196 3.03.937 3.554 1.067 1.155.197 2.529.35 3.903.066 1.874-.501 3.684-1.591 5.93-1.351 1.59.13 3.835 1.591 6.452 1.504 2.593 0 3.554-.938 5.775-1.374 1.596-.349 2.4-.13 4.123.196 1.937.414 3.031 1.505 6.363 1.221",
    stroke: "#fff",
    strokeWidth: 0.46285499999999996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.355 310.29c1.44-1.222 4.056-1.74 6.083-1.222 2.594.57 3.77 1.378 6.517 1.29 2.094 0 3.903-1.591 5.93-1.591 3.554 0 3.619.781 6.737 1.501.784.135 1.81.135 2.66 0 1.067-.284 2.092-.72 3.03-1.217.937-.501 3.4-.419 4.62-.284 2.158.194 3.03 1.066 3.555 1.284 1.155.284 2.528.501 3.989.066 1.874-.63 3.619-1.941 5.864-1.657 1.59.129 3.836 1.875 6.453 1.875 2.594 0 3.553-1.155 5.798-1.724 1.592-.413 2.378-.129 4.12.2 2.026.497 3.03 1.937 6.367 1.653",
    stroke: "#fff",
    strokeWidth: 0.836915
  }), /*#__PURE__*/React.createElement("path", {
    d: "M461.51 306.15c1.505-1.005 4.121-1.373 6.148-1.005 2.595.502 3.772 1.071 6.519 1.071.937 0 1.809-.284 2.66-.569",
    stroke: "#fff",
    strokeWidth: 0.46285499999999996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M474.94 301.876c.414-.13 1.657-.718 3.4-.718 3.554 0 1.286 0 4.426.567.785.13 3.03.13 3.684-.415m30.934 10.007c1.155-.195 2.093-.569 3.117-1.004.937-.436 3.335-.346 4.623-.195 2.177.195 3.03.937 3.55 1.003 1.138.28 2.533.414 3.907.063 1.875-.503 3.682-1.591 5.926-1.374 1.591.195 3.84 1.59 6.451 1.59",
    stroke: "#000",
    strokeWidth: 0.406215
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.814 301.507c2.59 0 3.55-.938 5.799-1.374 1.59-.349 2.371-.13 4.119.196 2.026.35 3.03 1.505 6.367 1.221",
    stroke: "#fff",
    strokeWidth: 0.46285499999999996
  }), /*#__PURE__*/React.createElement("path", {
    d: "M460.487 310.575c1.504-1.005 4.12-1.44 6.082-1.005 2.594.502 3.77 1.072 6.583 1.072 2.027-.067 3.837-1.29 5.952-1.29 3.465 0 3.618.632 6.67 1.156a8.426 8.426 0 0 0 2.594 0c1.156-.128 2.16-.502 3.118-.938.937-.413 3.4-.345 4.621-.194 2.159.133 3.03.847 3.554 1.003",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.067 307.304c1.527-1.004 4.12-1.373 6.083-1.004 2.593.503 3.77 1.155 6.517 1.072 2.094-.068 3.838-1.29 5.93-1.223 3.553 0 3.684.57 6.736 1.155a8.785 8.785 0 0 0 2.594 0c1.156-.194 2.159-.568 3.117-1.004.938-.345 3.401-.345 4.623-.194 2.157.194 3.03.936 3.552 1.003 1.156.285 2.53.414 3.903.068 1.874-.419 3.684-1.507 5.93-1.38 1.722.202 3.989 1.597 6.451 1.597 2.595 0 3.554-.938 5.798-1.373 1.59-.351 2.376-.201 4.208.195 1.875.346 2.963 1.502 6.233 1.217",
    stroke: "#000",
    strokeWidth: 0.836915
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M492.706 252.48c2.747-1.374 5.581-2.16 8.917-2.16 3.182 0 6.583 1.155 9.199 2.594l9.418 15.653c0 10.29-8.415 18.77-18.64 18.77-10.202 0-18.55-8.262-18.638-18.705l9.702-16.175z",
    stroke: "#fff3f3",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 250.516c3.116 0 6.517 1.154 9.132 2.594l9.2 15.436c0 10.07-8.196 18.485-18.356 18.485-10.137 0-18.267-8.11-18.333-18.421l9.57-15.957c2.682-1.284 5.494-2.16 8.763-2.16z",
    stroke: "#fff3ef",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 250.732c3.116 0 6.387 1.156 8.98 2.595 0 0 9.134 15.152 9.134 15.219 0 10.004-8.196 18.267-18.138 18.267-9.919 0-18.049-8.109-18.136-18.202 0-.065 9.351-15.652 9.417-15.74 2.681-1.284 5.428-2.16 8.698-2.16z",
    stroke: "#ffefef",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 250.934c3.03 0 6.299 1.155 8.849 2.528.065.061 8.982 14.93 8.982 15.084 0 9.853-7.979 18.049-17.832 18.049-9.788 0-17.833-7.978-17.833-17.984 0-.132 9.135-15.456 9.2-15.523 2.68-1.284 5.428-2.154 8.611-2.154z",
    stroke: "#ffefed",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 251.235c3.03 0 6.233 1.155 8.696 2.466.132.13 8.917 14.713 8.917 14.931 0 9.635-7.891 17.7-17.613 17.7-9.703 0-17.55-7.825-17.616-17.7 0-.131 8.982-15.215 9.135-15.304 2.594-1.284 5.363-2.093 8.48-2.093m0 .217c2.964 0 6.147 1.155 8.632 2.468.131.061 8.763 14.494 8.763 14.712 0 9.483-7.825 17.484-17.395 17.484s-17.33-7.76-17.397-17.484c0-.196 8.917-14.93 9.07-15.086 2.528-1.218 5.21-2.094 8.327-2.094",
    stroke: "#ffedeb",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 251.738c2.963 0 6.08 1.065 8.479 2.376.196.13 8.633 14.214 8.633 14.496 0 9.418-7.674 17.178-17.113 17.178-9.419 0-17.048-7.608-17.113-17.177 0-.197 8.611-14.714 8.85-14.87 2.594-1.284 5.21-2.027 8.263-2.027z",
    stroke: "#ffebe8",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 251.955c2.898 0 6.015 1.066 8.414 2.377.195.128 8.48 13.908 8.48 14.28 0 9.263-7.608 16.98-16.895 16.98-9.265 0-16.83-7.542-16.895-16.98 0-.284 8.48-14.497 8.764-14.654 2.44-1.217 5.057-2.026 8.108-2.026z",
    stroke: "#ffebe6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 252.172c2.811 0 5.862 1.072 8.26 2.378.284.128 8.329 13.69 8.329 14.061 0 9.068-7.457 16.676-16.613 16.676-9.133 0-16.611-7.39-16.611-16.677 0-.348 8.328-14.277 8.611-14.429 2.398-1.222 5.057-2.03 7.979-2.03z",
    stroke: "#ffe8e6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 252.48c2.811 0 5.797 1.003 8.109 2.31.282.128 8.26 13.406 8.26 13.842 0 8.982-7.39 16.459-16.393 16.459-8.981 0-16.305-7.238-16.393-16.459 0-.348 8.197-13.992 8.48-14.217 2.465-1.215 4.993-1.935 7.89-1.935z",
    stroke: "#ffe8e2",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 252.675c2.745 0 5.732 1.004 8.043 2.31.283.195 8.044 13.19 8.044 13.626 0 8.85-7.238 16.24-16.11 16.24-8.916 0-16.089-7.238-16.089-16.24 0-.415 7.978-13.776 8.328-13.994 2.398-1.155 4.926-1.942 7.76-1.942z",
    stroke: "#ffe6e0",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 252.982c2.745 0 5.645 1 7.912 2.22.349.195 7.978 12.907 7.978 13.41 0 8.697-7.171 15.956-15.891 15.956-8.698 0-15.805-7.02-15.87-15.87 0-.502 7.825-13.624 8.196-13.841 2.376-1.156 4.839-1.875 7.674-1.875",
    stroke: "#ffe6de",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 253.2c2.68 0 5.58.998 7.76 2.243.414.195 7.825 12.688 7.825 13.19 0 8.545-6.954 15.739-15.586 15.739-8.612 0-15.587-6.955-15.652-15.653 0-.567 7.673-13.343 8.109-13.623 2.31-1.137 4.774-1.874 7.543-1.874z",
    stroke: "#ffe2de",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 253.417c2.593 0 5.513.998 7.607 2.244.502.194 7.761 12.404 7.761 12.971 0 8.48-6.89 15.435-15.37 15.435a15.323 15.323 0 0 1-15.369-15.37c0-.566 7.457-13.12 7.979-13.405 2.246-1.155 4.622-1.875 7.39-1.875",
    stroke: "#ffe2dc",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 253.701c2.593 0 5.361.939 7.542 2.155.501.285 7.608 12.1 7.608 12.755 0 8.327-6.803 15.216-15.151 15.216-8.327 0-15.086-6.736-15.152-15.151 0-.633 7.39-12.903 7.914-13.189 2.158-1.072 4.556-1.808 7.238-1.808zm0 .219c2.593 0 5.275.937 7.389 2.092.501.346 7.543 11.967 7.543 12.62 0 8.197-6.737 14.934-14.933 14.934-8.175 0-14.868-6.585-14.868-14.868 0-.72 7.172-12.686 7.696-12.97 2.245-1.072 4.555-1.809 7.172-1.809",
    stroke: "#ffe0d9",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 254.198c2.528 0 5.143.937 7.324 2.031.501.347 7.325 11.749 7.325 12.403 0 8.044-6.584 14.715-14.65 14.715-8.045 0-14.563-6.518-14.65-14.65 0-.718 7.02-12.468 7.543-12.751 2.158-1.067 4.491-1.725 7.107-1.725z",
    stroke: "#ffded6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 254.415c2.528 0 5.056.938 7.17 2.033.502.345 7.239 11.443 7.239 12.184 0 7.891-6.518 14.497-14.433 14.497-7.89 0-14.343-6.453-14.343-14.431 0-.785 6.801-12.183 7.39-12.557 2.092-1.006 4.425-1.724 6.953-1.724z",
    stroke: "#ffded3",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 254.723c2.463 0 4.991.87 7.018 1.942.567.346 7.107 11.226 7.107 11.967 0 7.76-6.388 14.28-14.149 14.28-7.76 0-14.06-6.367-14.125-14.214 0-.785 6.67-11.966 7.325-12.318 2.026-1.004 4.272-1.657 6.8-1.657z",
    stroke: "#ffdcd3",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 254.94c2.463 0 4.926.854 6.887 1.943.633.346 7.02 10.943 7.02 11.75 0 7.673-6.3 13.995-13.93 13.995-7.674 0-13.843-6.235-13.908-13.909 0-.85 6.518-11.747 7.237-12.1 2.027-1.002 4.208-1.656 6.67-1.656z",
    stroke: "#ffdcd1",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 255.158c2.396 0 4.838.854 6.8 1.942.633.413 6.8 10.66 6.8 11.532 0 7.542-6.08 13.778-13.624 13.778-7.542 0-13.624-6.083-13.624-13.691 0-.937 6.387-11.446 7.02-11.88 2.026-1.005 4.208-1.659 6.583-1.659zm0 .285c2.309 0 4.773.786 6.67 1.875.719.413 6.735 10.443 6.735 11.314 0 7.39-6.016 13.494-13.406 13.494-7.39 0-13.342-5.929-13.407-13.407 0-.937 6.234-11.228 6.954-11.664 1.94-1.004 4.054-1.59 6.453-1.59z",
    stroke: "#ffd9cf",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 255.66c2.309 0 4.62.788 6.517 1.876.784.413 6.583 10.16 6.583 11.096 0 7.238-5.93 13.276-13.124 13.276-7.237 0-13.123-5.864-13.188-13.189 0-1.003 6.082-11.01 6.802-11.446 1.962-.999 4.054-1.59 6.365-1.59z",
    stroke: "#ffd6cc",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 255.945c2.244 0 4.555.787 6.387 1.808.783.413 6.516 9.942 6.516 10.88 0 7.106-5.798 12.97-12.904 12.97-7.107 0-12.818-5.733-12.906-12.905 0-1.004 5.8-10.727 6.671-11.23 1.875-.937 3.903-1.523 6.235-1.523",
    stroke: "#ffd6c9",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 256.163c2.244 0 4.49.786 6.299 1.808.785.502 6.366 9.636 6.366 10.662 0 6.954-5.713 12.751-12.689 12.751-6.953 0-12.622-5.645-12.687-12.686 0-1.068 5.734-10.51 6.52-11.011 1.873-.938 3.9-1.524 6.146-1.524z",
    stroke: "#ffd3c9",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 256.38c2.179 0 4.423.787 6.147 1.808.85.503 6.234 9.42 6.234 10.444 0 6.89-5.582 12.535-12.404 12.535-6.888 0-12.405-5.58-12.405-12.47 0-1.067 5.495-10.29 6.366-10.787 1.876-.938 3.771-1.507 6.017-1.507z",
    stroke: "#ffd3c6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 256.687c2.091 0 4.337.721 6.08 1.658.85.497 6.083 9.197 6.083 10.287 0 6.737-5.494 12.252-12.187 12.252-6.67 0-12.186-5.428-12.186-12.186 0-1.068 5.363-10.007 6.302-10.57 1.743-.854 3.683-1.44 5.863-1.44z",
    stroke: "#ffd1c5",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 256.905c2.091 0 4.271.72 5.95 1.657.937.565 5.93 8.914 5.93 10.136 0 6.518-5.363 11.967-11.881 11.967-6.584 0-11.881-5.362-11.968-11.967 0-1.156 5.21-9.857 6.169-10.353 1.722-.854 3.684-1.44 5.776-1.44z",
    stroke: "#ffd1c2",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 257.189c2.026 0 4.118.72 5.797 1.59 1.003.565 5.864 8.698 5.864 9.918 0 6.366-5.275 11.663-11.662 11.663a11.648 11.648 0 0 1-11.663-11.662c0-1.22 4.992-9.571 6.017-10.136 1.743-.854 3.553-1.373 5.646-1.373",
    stroke: "#ffcfc2",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 257.407c2.026 0 4.053.63 5.645 1.59 1.003.564 5.733 8.48 5.733 9.723 0 6.235-5.08 11.444-11.378 11.444-6.302 0-11.38-5.079-11.447-11.445 0-1.22 4.841-9.353 5.865-9.917 1.722-.853 3.553-1.372 5.582-1.372z",
    stroke: "#ffcfbe",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 257.686c1.96 0 3.988.637 5.58 1.507 1.002.57 5.58 8.196 5.58 9.483 0 6.082-4.992 11.161-11.161 11.161-6.147 0-11.161-4.991-11.161-11.16 0-1.287 4.708-9.138 5.71-9.724 1.657-.787 3.402-1.284 5.428-1.284zm0 .224c1.96 0 3.835.63 5.427 1.5 1.068.654 5.428 7.98 5.428 9.266 0 5.93-4.84 10.943-10.879 10.943-6.016 0-10.942-4.84-10.942-10.943 0-1.286 4.556-8.852 5.645-9.483 1.592-.848 3.336-1.283 5.276-1.283z",
    stroke: "#ffccbc",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 258.127c1.873 0 3.77.63 5.361 1.501 1.004.632 5.276 7.696 5.276 9.07 0 5.864-4.774 10.725-10.66 10.725-5.864 0-10.66-4.773-10.66-10.725 0-1.374 4.338-8.634 5.494-9.265 1.503-.787 3.247-1.29 5.144-1.29z",
    stroke: "#ffc9b9",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 258.345c1.808 0 3.682.63 5.209 1.5 1.068.632 5.144 7.392 5.144 8.853 0 5.711-4.621 10.443-10.377 10.443a10.401 10.401 0 0 1-10.44-10.443c0-1.44 4.207-8.417 5.361-9.07 1.504-.787 3.184-1.283 5.058-1.283z",
    stroke: "#ffc9b8",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 258.624c1.808 0 3.618.569 5.056 1.44 1.155.636 5.08 7.173 5.08 8.634 0 5.58-4.556 10.224-10.16 10.224-5.646 0-10.137-4.557-10.202-10.224 0-1.44 4.055-8.11 5.276-8.852 1.504-.78 3.117-1.222 4.927-1.222z",
    stroke: "#ffc6b8",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 258.84c1.742 0 3.553.637 4.991 1.44 1.155.722 4.927 6.892 4.927 8.418 0 5.428-4.491 9.919-9.942 9.919-5.428 0-9.919-4.426-9.919-9.92 0-1.504 3.838-7.891 5.08-8.633 1.505-.72 3.03-1.223 4.84-1.223z",
    stroke: "#ffc6b5",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 259.065c1.742 0 3.465.63 4.838 1.434 1.221.72 4.774 6.673 4.774 8.199 0 5.275-4.337 9.7-9.635 9.7-5.363 0-9.636-4.338-9.701-9.7 0-1.505 3.77-7.675 4.992-8.417 1.374-.72 2.965-1.216 4.709-1.216zm0 .301c1.656 0 3.334.503 4.708 1.374 1.307.719 4.708 6.366 4.708 7.979 0 5.146-4.273 9.418-9.417 9.418-5.21 0-9.419-4.12-9.419-9.418 0-1.59 3.554-7.389 4.84-8.197 1.286-.721 2.813-1.156 4.556-1.156z",
    stroke: "#ffc5b3",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 259.583c1.59 0 3.247.57 4.555 1.29 1.286.781 4.556 6.233 4.556 7.825 0 5.056-4.054 9.199-9.135 9.199-5.057 0-9.199-4.121-9.199-9.2 0-1.591 3.401-7.171 4.71-7.98 1.373-.72 2.812-1.156 4.49-1.156z",
    stroke: "#ffc2af",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 259.868c1.59 0 3.181.503 4.49 1.222 1.286.782 4.424 5.93 4.424 7.608 0 4.926-4.054 8.981-8.915 8.981-4.927 0-8.917-4.055-8.917-8.981 0-1.656 3.183-6.955 4.557-7.765 1.285-.652 2.747-1.064 4.337-1.064z",
    stroke: "#ffc2ad",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 260.086c1.503 0 3.116.503 4.337 1.223 1.373.786 4.272 5.645 4.272 7.389 0 4.774-3.836 8.698-8.633 8.698a8.68 8.68 0 0 1-8.698-8.698c0-1.723 3.03-6.737 4.426-7.54 1.286-.636 2.681-1.072 4.272-1.072z",
    stroke: "#ffbead",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 260.37c1.503 0 3.03.414 4.271 1.156 1.352.87 4.121 5.428 4.121 7.172 0 4.621-3.772 8.48-8.416 8.48-4.62 0-8.392-3.772-8.48-8.48 0-1.723 2.9-6.452 4.34-7.323a8.805 8.805 0 0 1 4.119-1.004z",
    stroke: "#ffbeab",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 260.589c1.438 0 2.898.501 4.118 1.154 1.44.849 3.99 5.211 3.99 6.955 0 4.556-3.618 8.196-8.109 8.196-4.556 0-8.175-3.619-8.175-8.196 0-1.81 2.66-6.235 4.12-7.105 1.22-.57 2.528-1.004 4.055-1.004",
    stroke: "#ffbca8",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 260.806c1.438 0 2.811.503 3.988 1.155 1.439.848 3.903 4.928 3.903 6.737 0 4.337-3.554 7.978-7.915 7.978a7.955 7.955 0 0 1-7.978-7.978c0-1.81 2.529-6.017 4.054-6.888 1.157-.569 2.464-1.004 3.903-1.004z",
    stroke: "#ffbca6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 261.113c1.372 0 2.745.413 3.835 1.066 1.505.848 3.838 4.71 3.838 6.519 0 4.272-3.467 7.673-7.674 7.673a7.63 7.63 0 0 1-7.674-7.673c0-1.875 2.311-5.8 3.903-6.67 1.154-.57 2.397-.938 3.77-.938z",
    stroke: "#ffb9a6",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 261.33c1.286 0 2.593.413 3.77 1.067 1.505.937 3.619 4.426 3.619 6.3 0 4.121-3.336 7.456-7.39 7.456a7.452 7.452 0 0 1-7.456-7.455c0-1.941 2.158-5.493 3.837-6.452a7.342 7.342 0 0 1 3.619-.937z",
    stroke: "#ffb9a2",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 261.615c1.286 0 2.528.346 3.618.999 1.504.938 3.552 4.12 3.552 6.084 0 3.989-3.182 7.238-7.171 7.238-3.99 0-7.172-3.25-7.172-7.238 0-1.941 2.026-5.275 3.618-6.235 1.003-.569 2.245-.848 3.554-.848m0 .218c1.22 0 2.464.413 3.466.998 1.592.938 3.4 3.905 3.4 5.867 0 3.837-3.118 6.954-6.888 6.954a6.958 6.958 0 0 1-6.954-6.954c0-2.027 1.874-5.057 3.554-5.928 1.003-.636 2.092-.937 3.4-.937z",
    stroke: "#ffb8a0",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 262.05a6.215 6.215 0 0 1 3.4 1c1.591.939 3.247 3.62 3.247 5.648 0 3.772-3.03 6.736-6.67 6.736-3.77 0-6.67-2.964-6.736-6.736 0-2.027 1.721-4.84 3.4-5.8 1.003-.501 2.093-.847 3.335-.847z",
    stroke: "#ffb59e",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 262.33c1.154 0 2.309.284 3.247.937 1.657 1.005 3.117 3.404 3.117 5.43 0 3.62-2.811 6.454-6.388 6.454-3.552 0-6.451-2.813-6.451-6.453 0-2.093 1.504-4.556 3.248-5.582.936-.502 1.94-.786 3.182-.786z",
    stroke: "#ffb59c",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 262.553c1.067 0 2.244.345 3.116.847 1.722 1.003 3.03 3.183 3.03 5.276 0 3.466-2.747 6.235-6.147 6.235-3.401 0-6.235-2.747-6.235-6.148 0-2.158 1.374-4.426 3.183-5.43.85-.502 1.874-.78 3.03-.78z",
    stroke: "#ffb39c",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 274.671a5.838 5.838 0 0 0 5.862-5.864c0-3.336-2.593-5.931-5.863-5.931-3.336 0-5.93 2.595-5.93 5.93 0 3.249 2.594 5.865 5.93 5.865",
    stroke: "#ffb399",
    strokeWidth: 0.23187
  }), /*#__PURE__*/React.createElement("path", {
    d: "M501.624 274.736c3.247 0 5.95-2.681 5.95-5.93 0-3.247-2.681-5.93-5.951-5.93-3.25 0-5.93 2.66-5.93 5.93 0 3.249 2.66 5.93 5.93 5.93",
    stroke: "#fff",
    strokeWidth: 0.17345999999999998
  }))), _path817 || (_path817 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 274.736c3.247 0 5.95-2.681 5.95-5.93 0-3.247-2.681-5.93-5.951-5.93-3.25 0-5.93 2.66-5.93 5.93 0 3.249 2.66 5.93 5.93 5.93",
    fill: "#fff"
  })), _path818 || (_path818 = /*#__PURE__*/React.createElement("path", {
    d: "m502.93 262.92.633-3.119m-1.287 3.03.35-3.18m-1.003 3.18v-3.248m-.567 3.248-.283-3.18m-.37 3.27-.656-3.12m.066 3.338-1.004-3.12m.438 3.337-1.286-2.963m.762 3.18-1.656-2.745m1.09 3.095-1.876-2.593m1.44 3.03-2.246-2.465m1.722 2.9-2.377-2.159m2.028 2.682-2.594-1.94m2.224 2.378-2.812-1.593m2.506 2.159-2.964-1.286m2.747 1.874-3.03-1.003m2.833 1.57-3.117-.632m3.03 1.286-3.183-.35m3.183 1.004h-3.248m3.248.589-3.183.348m3.27.305-3.117.634m3.313-.045-3.117 1.003m3.335-.436-2.964 1.285m3.27-.697-3.466 2.094m3.75-1.592-6.955 4.991m7.39-4.49-7.543 6.584m7.914-6.147-6.148 6.887m6.65-6.517-4.622 6.3m5.144-5.865-4.84 8.482m5.407-8.263-2.68 6.147m3.269-5.864-2.748 8.48m3.314-8.327-1.155 5.71m1.81-5.645-.85 8.763m2.092-8.763.349 3.183m.305-3.248 1.875 8.262m-1.286-8.415 1.591 4.84m-1.025-5.058 3.772 8.11m-3.182-8.393 4.054 6.889m-3.553-7.26 5.799 7.608m-5.298-7.956 5.08 5.864m-4.645-6.3 7.544 6.8m-7.173-7.325 4.121 2.966m-3.75-3.467 2.812 1.592m-2.529-2.18 2.966 1.286m-2.747-1.852 3.03 1.001m-2.812-1.59 3.117.633m-3.052-1.287 3.182.349m-3.094-1.004h3.182m-3.27-.566 3.182-.283m-3.247-.305 3.117-.72m-3.335.065 3.117-1.003m-3.27.415 2.9-1.286m-3.184.719 2.813-1.592m-3.183 1.09 2.594-1.872m-2.943 1.349 2.377-2.159m-2.813 1.724 2.093-2.378m-2.615 1.94 1.874-2.53m-2.377 2.25 1.592-2.814m-2.18 2.528 1.286-2.963m-1.852 2.746 1.003-3.03m-2.9-4.884v-2.461m-2.747 2.745-.502-2.377m-2.202 3.248-1.003-2.243m-1.438 3.705-1.504-2.03m-.61 3.905-1.875-1.658m.218 3.99-2.18-1.288m1.003 3.816-2.377-.786m1.723 3.555-2.442-.197m2.442 3.03-2.442.284m3.095 2.529-2.462.72m27.052 1.896 2.18 1.22m-1.002-3.836 2.31.784m-1.743-3.53 2.441.282m-2.441-3.118 2.441-.194m-3.008-2.553 2.376-.784m-3.553-1.83 2.18-1.22m-3.837-1.028 1.875-1.742m-3.902-.15 1.373-2.032m-3.837.593 1.003-2.311m-3.771 1.35.501-2.377",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path819 || (_path819 = /*#__PURE__*/React.createElement("path", {
    d: "M505.111 271.553s-.85-.414-1.373-.414c-.502 0-2.66-.13-3.62.13-.501.132-.85.567-.85.567s.567.568 1.744.72c1.22.066 1.94 0 2.594-.196.72-.195 1.505-.785 1.505-.785z",
    fill: "#e60000",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path820 || (_path820 = /*#__PURE__*/React.createElement("path", {
    d: "M499.377 270.68s.065-1.655 1.22-3.683c0 0-.348.568-.566 1.068 0 0-.632.35-1.003-.13-.413-.349-.195-.502.066-1.156.282-.414.197-.85.567-1.155.282-.283.567-.349 1.373-.349.785 0 1.286.066 1.94 1.003.567.784.938 1.504 1.221 1.94.633 1.068.633 2.311.633 2.311l.195 1.003s-.85-.415-1.374-.415c-.5 0-2.659-.131-3.618.131-.5.132-.85.567-.85.567s-.348-.784.13-1.155z",
    fill: "#e60000",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path821 || (_path821 = /*#__PURE__*/React.createElement("path", {
    d: "M499.377 270.68s.633-.347 2.747-.347c2.529.065 2.594.195 2.748.414",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path822 || (_path822 = /*#__PURE__*/React.createElement("path", {
    d: "M501.557 279.968v-8.699s.283-.282.938 0v8.633s.196 6.672-.501 6.585c-.852 0-.415-1.504-.415-6.52z",
    fill: "#fc0",
    stroke: "#000",
    strokeWidth: 0.17345999999999998
  })), _path823 || (_path823 = /*#__PURE__*/React.createElement("path", {
    d: "M467.245 295.055c.414.064 1.439-.721 1.722-.939.414-.196.632-.85.937-1.221.349-.349 1.374-.85 1.81-1.154 2.027-1.222 2.963-1.941 4.337-3.838 1.94-2.594 4.12-4.773 6.955-6.3.85-.501 2.245-.349 3.182.065.283.131.72.415 1.004.72 1.154.938 2.81 1.591 4.708 2.158 1.875.567 2.31 1.81 3.77 3.118a9.793 9.793 0 0 0 2.465 1.591c.066.065.283.35.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.901 3.77.217.196.284.634.501.786.938.937 1.875 1.874 3.03 2.462 1.221.567 2.246 1.374 3.336 2.028-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.66-.066l3.184-5.428",
    fill: "#090"
  })), _path824 || (_path824 = /*#__PURE__*/React.createElement("path", {
    d: "M481.96 282.28c.566-.066.282-.197.784.13m-1.788.523c.567-.065.785-.414 1.221.065m-1.743.305c.195 0 .414-.282 1.22.196m-1.788.524c.501-.13.785-.065 1.287.066m-2.006.435c.567-.195.85.197 1.504.066m-2.245.675c.414 0 .501-.13.85 0 .437.066.349 0 .785.066m-2.42.654c.414 0 .566-.066.938 0 .501.065.348.065.85 0m-2.224.653c.85-.064 1.068-.064 1.656.132m-2.833 1.395c.719-.197 1.068-.197 1.656.066m-13.406 12.055c2.31-.349 5.08.065 7.39-.283m4.73-12.557c.567-.197.415-.131 1.004-.066.632.065.85.13 1.002.065m-2.943 1.374c.567-.349 1.286-.13 1.875 0m-.35.588c-.631-.13-1.285 0-1.94 0m1.418.72c-.632-.195-1.374-.283-2.093-.131m-.872.633c.784 0 1.569-.197 2.464.064m-3.184.59c.85-.284 1.744-.067 2.682.065m-3.553.435c.937-.065 1.808-.065 2.747-.065.13 0 .414-.13.567.065m-.262.525c-1.374.282-2.748.064-4.208.13m3.401.588c-.414 0-1.155.196-1.788.13-.065 0-.195-.13-.348-.13-.72 0-1.44 0-2.093.196m-.349.524c.283-.131.653-.197.938-.066.85.066 1.722 0 2.529.197.195.065.413.13.72.13m-4.688.11c.632 0 1.22-.066 1.875.065.784.13 1.59.348 2.376.348h-.065m-4.775.022c.654 0 1.286.13 1.962.283.85.13 1.81-.065 2.595.13m-5.342.023c.85.35 1.81.066 2.747.196.85.13 1.656.13 2.529.284m-5.865.24c1.287 0 2.682 0 4.055.196.349.065 1.004.282 1.504.13m-6.06.263c1.287.195 2.682 0 3.99.348a8.546 8.546 0 0 0 1.875.196h-.131m-6.257.458c.066-.065.283-.13.35-.13 1.067 0 2.092.13 3.182.065.85-.065 1.81-.132 2.593.13h-.065m-6.562.589c2.094-.196 4.273.065 6.366 0m-6.736.655c2.245.194 4.491 0 6.671.194m-7.02.459c1.004.196 1.94-.065 2.9.13.72.131 1.373.196 2.092.131.633-.195 1.221 0 1.81-.065m9.09-9.265h.197m-.415.283c.066 0 .197-.13.197 0m-.501.37h.501m-.633.285h.567m-1.003.37c.35 0 .633.066 1.003.066h-.065m-1.22.436c.348-.131.783 0 1.154-.131h-.065m-1.613.719h1.592-.066m-1.81.37c.567 0 1.156-.065 1.657.066m-2.027.502c.632-.065 1.374 0 2.005.065m-2.377.523c.415-.065.786.196 1.222.283.283.066.567 0 .85-.065m-2.201.218a7.089 7.089 0 0 0 1.96.283m-2.331.218c.567 0 1.068.131 1.591.283.283.066.502 0 .72 0m-3.03.524c.719-.282 1.504-.065 2.245.13.196.066.502 0 .784 0h-.065m-3.03.37c.785-.194 1.656-.194 2.376.132h.414m-3.313.523c1.068.197 2.18-.13 3.183.132m-3.466.304c.85.349 1.809 0 2.68.283.284.066.634.066.939-.065m-4.186.436a2.239 2.239 0 0 1 1.155-.13c1.003.283 1.874.13 2.812.283m-4.49.501c.195 0 .414.13.632.066 1.286-.195 2.594 0 3.836-.066m-4.752.502c1.004.349 2.027 0 3.183.283.349.13.937.196 1.373 0m-4.927.458c1.505.065 3.03-.065 4.84.13M482.83 291c.13 0 .283.13.414.13m-.632.37c.197-.064.349-.13.567-.064m-.698.501c.283 0 .502-.065.786.066m-1.004.523c.284 0 .72 0 1.004.065m-1.309.501c.414-.13.85.066 1.286-.065m-1.35.502c.413.13.849 0 1.307.065v-.065m-1.526.653c.349 0 .785-.065 1.155.066.13.065.283 0 .414-.065m-1.635.588c.567-.196 1.068.13 1.657 0m-1.875.72c.567 0 1.156.065 1.81 0m-2.028.589c.196-.066.502-.283.785-.131.35.13.785.065 1.22.13m-2.158.654c.72-.282 1.44.131 2.159-.196m-2.224.85a2.577 2.577 0 0 1 1.003 0c.414.131.85.065 1.286 0m-2.506.633c.784-.197 1.743 0 2.594-.066l-.065.065m-3.052.59c1.067-.066 2.245-.198 3.335-.198m-3.183.851c1.155-.196 2.464-.13 3.684-.13m-3.903.784c1.221.196 1.44-.066 2.682-.066.196 0 1.22-.195 1.44-.282h.718m-4.84.719c1.81-.132 3.772.13 5.647-.283m-13.777.064h1.504m5.69.219c.196.065.413-.067.5.065m6.606-.218c1.505-.13 3.03.283 4.557 0m-5.341-.5c1.003-.284 1.874-.067 2.81.13.067 0 .067.13.132.195.85.131 1.657 0 2.442-.065m-10.77-.349h-1.002m-5.102-.218c-.631.065-1.286.065-2.026.13m14.801-14.343h.284m-.13.436c.065 0 .195 0 .348-.066m-.282.72c0-.066.064-.131.064-.131h.414m-.326.567c.195-.13.413-.065.718-.065m.066.435c-.196 0-.414.066-.633.131m.283.589c.198-.13.416-.13.633-.13m.305.5h-.937m.283.502c.35 0 .654.065.938-.13m.24.697c-.349 0-.72 0-1.003.13m.196.61c.348.066.785 0 1.156-.196m.088.414c-.35.132-.721.197-1.07.283m.196.59c.415-.197 1.003 0 1.44-.13m.153.566c-.35 0-.786-.066-1.156 0-.131.065-.197.131-.349.131m.262.959c.282-.131.566-.35.937-.284 0-.196.196 0 .348-.13.066-.065.197 0 .35 0m.261.633c-.501-.067-1.068.064-1.656.13m.13.72c.633-.198 1.286-.198 1.962-.35m-1.896 1.156c.719-.132 1.439-.132 2.158-.415m.523.48c-.785.13-1.656 0-2.377.349m.132.74c.13.066.195.132.348.132.72-.349 1.504-.567 2.246-.502m.24.59c-.72.413-1.593.194-2.463.282-.066 0-.132.066-.284.131m.283.545c.938-.13 1.81-.196 2.747-.349m.588.632c-.719.066-1.439-.065-2.158.066-.348.066-.655.197-1.003.283m.11.589c.13 0 .283.065.349-.066.937-.501 2.005-.348 3.03-.348m.327.566c-.85 0-1.723-.195-2.594.066-.284.132-.567.282-.938.282m.262.655c.5-.065.937-.282 1.373-.349.937-.13 1.874-.065 2.9-.065m0 .501c-.567-.13-1.156-.13-1.657 0-.85.196-1.592.415-2.465.415m.502.457c.655-.065 1.286-.282 1.94-.413.568-.132 1.069-.067 1.657-.067m-3.597.85c1.004-.13 2.028 0 3.03-.282.35-.131.72.064 1.07 0m.042-.392c1.744.13 3.4-.197 5.08.13m-4.73.392c.195.066.348-.13.5-.13 1.374 0 2.748.064 4.208.13m-.501-3.553h.195m-.108.437c.13.065.349-.197.5 0m-.37.5h.851m-.633.72c.284-.349.72 0 1.003-.197m-.784.85c.349-.282.937.066 1.286-.282m-1.198.784c.566-.13 1.154.066 1.656-.282m-1.439.805c.85-.348 1.809.196 2.594-.413m-2.529.85c1.069-.35 2.18 0 3.248-.066m.676 0a79.516 79.516 0 0 1 5.581 0m-6.387-.675c1.656.13 4.12 0 6.17.13",
    fill: "none",
    stroke: "#007200",
    strokeWidth: 0.17345999999999998
  })), _path825 || (_path825 = /*#__PURE__*/React.createElement("path", {
    d: "M467.245 295.055c.414.064 1.439-.721 1.722-.939.414-.196.632-.85.937-1.221.349-.349 1.374-.85 1.81-1.154 2.027-1.222 2.963-1.941 4.337-3.838 1.94-2.594 4.12-4.773 6.955-6.3.85-.501 2.245-.349 3.182.065.283.131.72.415 1.004.72 1.154.938 2.81 1.591 4.708 2.158 1.875.567 2.31 1.81 3.77 3.118a9.793 9.793 0 0 0 2.465 1.591c.066.065.283.35.348.414.785.633 1.722 1.156 2.465 1.723 1.373 1.22 2.593 2.462 3.901 3.77.217.196.284.634.501.786.938.937 1.875 1.874 3.03 2.462 1.221.567 2.246 1.374 3.336 2.028-11.249.415-21.539-.283-32.853.066h-2.092c-.785-.066-1.286 0-2.159 0-3.4 0-6.67 0-10.66-.066",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path826 || (_path826 = /*#__PURE__*/React.createElement("path", {
    d: "M511.433 300.22c-.938-.566-1.876-1.22-2.9-1.722-1.155-.567-2.093-1.504-3.029-2.464-.197-.13-.285-.566-.503-.785-1.286-1.286-2.528-2.528-3.901-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.373 9.373 0 0 1-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.312v-.066c.501-.282 1.003-.632 1.505-.937.719-.348 1.874-.283 2.68.13.284.067.568.284.851.502.938.785 2.31 1.374 3.902 1.875 1.592.414 1.94 1.439 3.183 2.53.567.5 1.22 1.001 1.94 1.286.066.065.195.282.283.414.72.501 1.505.85 2.094 1.437a107.562 107.562 0 0 1 3.247 3.118c.13.131.197.502.35.655.85.784 1.656 1.591 2.593 2.026.938.502 1.81 1.156 2.747 1.657-2.529.131-4.992.131-7.543.131h-.065",
    fill: "#090"
  })), _path827 || (_path827 = /*#__PURE__*/React.createElement("path", {
    d: "M495.322 287.075c.131 0 1.221-.197 1.352-.197m-1.003.48c.348 0 1.156 0 1.44-.195m-.85.719 1.002-.197h.413m-.98.48c.13-.065 1.505 0 1.743-.065m.349.349c-.283 0-1.35.065-1.503.194m.937.612c.13-.131.937-.283 1.22-.283m.654.501c-.348 0-1.068.066-1.439.066m.72.587c.35-.065 1.004-.13 1.22-.282m.742.566c-.414 0-.937.065-1.439.065m.633.524c.501 0 1.155 0 1.504-.065m.545.282c-.284.132-.938.197-1.286.284m.632.59c.348-.198 1.003-.066 1.504-.198m.523.48c-.5 0-.937 0-1.286.066-.065 0-.13.065-.349.065m3.161 1.025c-.72-.065-1.22.065-1.81.13m.567.676c.567-.283 1.286-.195 1.962-.35m-.501 2.094c.131.065.785-.065.938-.065 1.003-.13 1.155-.349 2.092-.283m.523.414c-1.22.196-1.656.196-2.594.348-.13 0-.414.066-.501.066m.545.457c.937-.195 2.245-.13 3.183-.283m1.025.502c-.72.13-1.658 0-2.378.13-.282.066-.936.13-1.285.197m.915.61c.066 0 .284 0 .349-.066.72-.501 1.94-.348 3.03-.348m.764.48c-1.068 0-1.505 0-2.311.066-.283.064-.72.194-1.069.194m.829.61c1.003-.194 2.813-.348 1.722-.281 1.004-.067 1.156-.067 2.311-.067m.305.349c-.719-.065-1.439-.065-1.874.065-.414.132-.284.197-1.723.284m.567.306c.72-.066.784 0 1.44-.197.5-.13 1.155-.066 1.787-.066m-2.856.567c1.068-.13 1.155-.13 2.245-.065.349 0 .567 0 .937-.065m-19.663-13.299c.283-.13.415-.195.85-.13-.065-.197.196 0 .349-.13 0-.067.196 0 .349 0m-2.05-.241c.284-.13.502-.13.938-.065-.131-.196.283 0 .283-.13.066-.066.283 0 .501 0m6.693 7.302c.283-.131.283-.196.72-.131-.13-.196.414 0 .501-.13 0-.066.501 0 .653 0m-.064 1.918c.632-.13 1.504-.13 2.092-.414m1.025.72c-.785.13-2.028.065-2.594.348m-9.658-10.158c-.784-.065-.85.194-1.439.194",
    fill: "none",
    stroke: "#007200",
    strokeWidth: 0.17345999999999998
  })), _path828 || (_path828 = /*#__PURE__*/React.createElement("path", {
    d: "M511.433 300.22c-.938-.566-1.876-1.22-2.9-1.722-1.155-.567-2.093-1.504-3.029-2.464-.197-.13-.285-.566-.503-.785-1.286-1.286-2.528-2.528-3.901-3.77-.72-.568-1.657-1.07-2.464-1.723-.065-.065-.283-.349-.349-.414a9.03 9.03 0 0 1-2.463-1.59c-.938-.851-1.44-1.658-2.224-2.312v-.066c.501-.282 1.003-.632 1.505-.937.719-.348 1.874-.283 2.68.13.284.067.568.284.851.502.938.785 2.31 1.374 3.902 1.875 1.592.414 1.94 1.439 3.183 2.53.567.5 1.22 1.001 1.94 1.286.066.065.195.282.283.414.72.501 1.505.85 2.094 1.437a107.562 107.562 0 0 1 3.247 3.118c.13.131.197.502.35.655.85.784 1.656 1.591 2.593 2.026.938.502 1.81 1.156 2.747 1.657-2.529.131-4.992.131-7.543.131h-.065z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path829 || (_path829 = /*#__PURE__*/React.createElement("path", {
    d: "M501.405 286.487c.348.065.72.195 1.068.349 1.591.413 1.94 1.437 3.183 2.528.567.501 1.22 1.003 1.94 1.285.065.067.195.285.283.415.72.502 1.505.85 2.092 1.44a106.914 106.914 0 0 1 3.249 3.116c.13.131.196.502.349.654.85.785 1.656 1.592 2.594 2.029.85.413 1.592.936 2.31 1.437 2.094 0 4.122-.065 6.3-.13-.87-.502-1.59-1.068-2.527-1.505-.85-.413-1.592-1.155-2.312-1.874-.13-.065-.196-.415-.349-.567a89.284 89.284 0 0 0-2.964-2.812c-.567-.502-1.22-.85-1.875-1.374-.065 0-.195-.283-.283-.283-.633-.349-1.221-.72-1.81-1.22-1.068-1.004-1.439-1.875-2.899-2.311-1.373-.415-2.594-1.004-3.554-1.657-.195-.196-.501-.415-.719-.502-.785-.349-1.81-.5-2.463-.13-.567.348-1.155.72-1.656 1.155",
    fill: "#090"
  })), _path830 || (_path830 = /*#__PURE__*/React.createElement("path", {
    d: "M503.89 287.51c.065 0 .938-.13 1.068-.13m-.785.502c.502-.13.938 0 1.22-.197m-.783.633.85-.131c.13-.066.282-.066.414-.066m-.829.546c.132-.132 1.22-.066 1.505-.132m.304.349c-.195 0-1.22.13-1.439.196m.567.546c.132-.131 1.221-.284 1.504-.197m.611.392c-.349 0-1.286.067-1.59.067m.5.457c.349 0 1.439-.066 1.592-.196m.567.545c-.35 0-.938 0-1.352.064m.414.458c.436 0 1.308 0 1.591-.13m.524.262c-.283.13-1.07.282-1.352.349m.698.457c.349-.195 1.003-.065 1.439-.195m.435.479c-.349 0-.784 0-1.068.065-.13 0-.196.13-.348.066m2.876.959c-.632-.065-1.154.065-1.656.13m.502.61c.566-.194 1.22-.194 1.874-.282m-.37 1.94c.13.065.567-.131.632-.131 1.004-.065 1.068-.283 2.027-.283m.48.413c-1.069.197-1.504.284-2.398.284-.066 0-.415.065-.501.13m.479.393c.85-.13 2.092-.13 2.965-.196m.96.414c-.655.065-1.44 0-2.159.13-.282.067-.937.067-1.22.132m.85.61c.13 0 .196 0 .348-.065.633-.437 1.809-.349 2.812-.349m.611.414c-.938 0-1.374.065-2.093.13-.415.066-1.004.197-1.068.197m.632.458c.937-.131 2.812-.283 1.81-.197.937-.065 1.154-.065 2.18-.065m.218.414c-.655-.13-1.222-.13-1.658 0-.348.066-.5.197-1.874.284m.48.283c.632-.065 1.003-.065 1.591-.196.436-.13 1.09-.065 1.656-.065m-2.594.567c.85-.066 1.003-.197 2.028-.132.349 0 .5-.065.85-.065m-18.051-12.295c.196-.065.131-.131.502-.131.283-.065.5.066.567-.065 0 0 .196-.065.349-.065m-2.071-.022c.282-.13.349-.283.719-.197.349-.065.501 0 .567-.13h.415m6.365 6.714c.195-.131.065-.196.5-.131-.13-.13.35 0 .415-.065.066-.066.436-.066.654-.066m-.044 1.788c.567-.13 1.374-.13 1.876-.349m.937.634c-.72.13-1.592 0-2.159.282m-9.068-9.286c-.72-.066-1.286.282-1.723.566",
    fill: "none",
    stroke: "#007200",
    strokeWidth: 0.17345999999999998
  })), _path831 || (_path831 = /*#__PURE__*/React.createElement("path", {
    d: "M501.405 286.487c.348.065.72.195 1.068.349 1.591.413 1.94 1.437 3.183 2.528.567.501 1.22 1.003 1.94 1.285.065.067.195.285.283.415.72.502 1.505.85 2.092 1.44a106.914 106.914 0 0 1 3.249 3.116c.13.131.196.502.349.654.85.785 1.656 1.592 2.594 2.029.85.413 1.592.936 2.31 1.437 2.094 0 4.122-.065 6.3-.13-.87-.502-1.59-1.068-2.527-1.505-.85-.413-1.592-1.155-2.312-1.874-.13-.065-.196-.415-.349-.567a89.284 89.284 0 0 0-2.964-2.812c-.567-.502-1.22-.85-1.875-1.374-.065 0-.195-.283-.283-.283-.633-.349-1.221-.72-1.81-1.22-1.068-1.004-1.439-1.875-2.899-2.311-1.373-.415-2.594-1.004-3.554-1.657-.195-.196-.501-.415-.719-.502-.785-.349-1.81-.5-2.463-.13-.567.348-1.155.72-1.656 1.155z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path832 || (_path832 = /*#__PURE__*/React.createElement("path", {
    d: "M511.716 288.884c.282.349.567.72 1.003 1.069.566.5 1.156.85 1.809 1.22.066 0 .196.283.283.283.633.503 1.286.852 1.875 1.374 1.004.938 1.94 1.81 2.965 2.812.131.131.196.501.348.567.72.72 1.44 1.439 2.312 1.875.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065-.632-.414-1.223-.85-2.026-1.221-.721-.35-1.223-.938-1.876-1.504-.133-.065-.133-.283-.284-.501-.782-.785-1.591-1.505-2.377-2.246-.413-.414-1-.72-1.502-1.069-.066-.065-.195-.195-.195-.282-.57-.197-1.004-.567-1.506-.938-.85-.785-1.068-1.59-2.246-1.874-1.22-.415-2.245-.786-2.899-1.374-.197-.13-.414-.349-.633-.414-.566-.197-1.372-.349-1.94-.065-.718.414-1.373.85-2.026 1.438",
    fill: "#090"
  })), _path833 || (_path833 = /*#__PURE__*/React.createElement("path", {
    d: "M512.588 289.756c.065 0 1.069-.13 1.069-.13m-.786.348c.414-.065.938 0 1.156-.13m-.72.5.785-.13c.065-.065.197 0 .349 0m-.85.414c.13-.13 1.22-.13 1.374-.13m.239.282c-.131-.064-1.003.066-1.068.131m.545.37c.13-.065.785-.13 1.003-.13m.458.283c-.197 0-1.004.066-1.221.066m.414.37c.282 0 1.003-.064 1.22-.195m.458.48h-1.068m.262.37c.349 0 1.003 0 1.307-.066m.37.197c-.194.13-.85.195-1.067.195m.349.393c.283-.131 1.003 0 1.285-.066m.437.285c-.349 0-.72 0-.937.065h-.283m2.245.806c-.436-.066-1.004.131-1.44.131m.502.37c.35-.13 1.004-.13 1.505-.196m-.502 1.44c.065.064.633 0 .72 0 .719-.066.85-.283 1.503-.196m.394.326c-.786.065-1.157.13-1.81.13-.066 0-.35.065-.502.065m.35.328c.632-.13 1.808-.065 2.46-.13m.681.348c-.502.065-1.158 0-1.66.065-.348.066-1.003.132-1.003.132m.48.458c.13 0 .72-.132.72-.132.85-.065 1.156-.13 1.96-.195m.502.326c-.782 0-1.066.065-1.657.13-.346 0-1.002.197-1.067.197m.61.393c.568-.132 2.159-.283 1.506-.283.72 0 .847 0 1.59-.066m.263.349c-.436-.065-.938-.065-1.29 0-.195.065-.435.13-1.524.194m.413.241c.503-.065.787 0 1.223-.13.413-.13.937-.065 1.284-.065m-2.071.479c.653-.13.876-.196 1.724-.13.129 0 .347 0 .631-.066m-14.037-9.374c.194-.066.282-.196.566-.13.195-.066.348 0 .348-.066.066-.066.197-.066.35-.066m-1.635-.043c.195-.065.282-.196.567-.196h.435c0-.066.197-.066.283-.066m4.73 5.124c.198-.067.198-.067.568-.067-.13-.065.282 0 .349-.065h.414m.065 1.374c.415-.066 1.003-.066 1.44-.284m.74.502c-.567.065-1.374 0-1.809.195m-6.91-7.084c-.502-.066-.633.13-1.004.349",
    fill: "none",
    stroke: "#007200",
    strokeWidth: 0.17345999999999998
  })), _path834 || (_path834 = /*#__PURE__*/React.createElement("path", {
    d: "M511.716 288.884c.282.349.567.72 1.003 1.069.566.5 1.156.85 1.809 1.22.066 0 .196.283.283.283.633.503 1.286.852 1.875 1.374 1.004.938 1.94 1.81 2.965 2.812.131.131.196.501.348.567.72.72 1.44 1.439 2.312 1.875.565.283 1.067.632 1.658.937h-.066c2.46 0 4.927 0 7.389-.065-.632-.414-1.223-.85-2.026-1.221-.721-.35-1.223-.938-1.876-1.504-.133-.065-.133-.283-.284-.501-.782-.785-1.591-1.505-2.377-2.246-.413-.414-1-.72-1.502-1.069-.066-.065-.195-.195-.195-.282-.57-.197-1.004-.567-1.506-.938-.85-.785-1.068-1.59-2.246-1.874-1.22-.415-2.245-.786-2.899-1.374-.197-.13-.414-.349-.633-.414-.566-.197-1.372-.349-1.94-.065-.718.414-1.373.85-2.026 1.438z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path835 || (_path835 = /*#__PURE__*/React.createElement("path", {
    d: "M530.856 298.628c-.412-.348-.915-.501-1.484-.806-.72-.349-1.217-.937-1.875-1.504-.13-.065-.13-.283-.28-.502-.786-.785-1.59-1.504-2.376-2.245-.414-.414-1.005-.72-1.508-1.068-.061-.065-.195-.195-.195-.283-.565-.196-1.001-.567-1.503-.937-.719-.72-1.003-1.287-1.81-1.723h.066a6.865 6.865 0 0 1 1.22-.785c.502-.282 1.156-.13 1.725.065.062.066.28.197.497.35.57.5 1.373.85 2.468 1.155.936.283 1.154.938 1.936 1.591.351.35.786.633 1.222.85.067 0 .134.196.194.196.42.283.938.567 1.29.938.72.633 1.374 1.286 2.027 1.94.133.13.133.349.284.414.502.414 1.003.938 1.59 1.22.631.35 1.155.722 1.724 1.07-1.724.064-3.465.064-5.212.064",
    fill: "#090"
  })), _path836 || (_path836 = /*#__PURE__*/React.createElement("path", {
    d: "M520.5 290.126c.067 0 .938-.13 1.004-.13m-.72.414c.284-.065.85-.065 1.003-.195m-.72.413.851-.13h.283m-.698.566c.067-.065 1.004-.195 1.157-.195m.305.194c-.195-.064-1.068.132-1.221.197m.48.306c.065-.066.847-.197 1.07-.131m.48.283c-.2 0-.938 0-1.223.13m.414.241c.194 0 1.004-.065 1.155-.197m.435.416c-.194 0-.847.064-1.222.13m.503.305c.284 0 1.004 0 1.221-.132m.308.197c-.196.13-.938.13-1.155.197m.563.391c.134-.13.854-.065 1.155-.13m.374.262c-.35 0-.636 0-.854.065-.062.066-.279.066-.346.066m2.137.675c-.419-.066-.937.131-1.289.131m.352.37c.346-.13.999-.13 1.501-.196m-.48 1.374c.068 0 .57-.065.636-.065.715-.065.849-.197 1.435-.132m.307.263c-.72.13-1.066.13-1.658.195h-.413m.263.393c.563-.065 1.657-.13 2.243-.196m.743.326c-.503 0-1.156 0-1.59.066-.353.066-.939.066-.939.131m.48.392c.062 0 .63-.13.63-.13.721-.066 1.006-.131 1.81-.197m.479.327c-.72 0-.999 0-1.5.065-.353.066-.855.283-1.006.283m.547.284c.565-.13 2.026-.282 1.434-.196.57-.065.72-.065 1.44-.065m.24.26c-.436-.064-.937-.13-1.221 0-.196.067-.413.132-1.374.198m.351.174c.413 0 .782 0 1.156-.13.346-.067.787 0 1.222 0m-2.032.435c.636-.065.855-.13 1.658-.13h.57m-12.951-8.743c.197-.065.197-.13.501-.13h.437s.13-.066.282-.066m-1.525 0c.197-.13.197-.196.502-.13.195-.066.348 0 .414-.066 0 0 .13-.065.283-.065m4.316 4.752c.134-.065.284-.065.502-.065-.067-.131.285 0 .346-.066h.441m-.134 1.221c.413-.065 1.072-.065 1.44-.196m.742.415c-.569.065-1.44-.067-1.875.13m-6.17-6.518c-.502-.065-.633.13-.938.349",
    fill: "none",
    stroke: "#007200",
    strokeWidth: 0.17345999999999998
  })), _path837 || (_path837 = /*#__PURE__*/React.createElement("path", {
    d: "M530.856 298.628c-.412-.348-.915-.501-1.484-.806-.72-.349-1.217-.937-1.875-1.504-.13-.065-.13-.283-.28-.502-.786-.785-1.59-1.504-2.376-2.245-.414-.414-1.005-.72-1.508-1.068-.061-.065-.195-.195-.195-.283-.565-.196-1.001-.567-1.503-.937-.719-.72-1.003-1.287-1.81-1.723h.066a6.865 6.865 0 0 1 1.22-.785c.502-.282 1.156-.13 1.725.065.062.066.28.197.497.35.57.5 1.373.85 2.468 1.155.936.283 1.154.938 1.936 1.591.351.35.786.633 1.222.85.067 0 .134.196.194.196.42.283.938.567 1.29.938.72.633 1.374 1.286 2.027 1.94.133.13.133.349.284.414.502.414 1.003.938 1.59 1.22.631.35 1.155.722 1.724 1.07-1.724.064-3.465.064-5.212.064z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.34691999999999995
  })), _path838 || (_path838 = /*#__PURE__*/React.createElement("path", {
    d: "m510.61 273.443 2.26 1.092.09-.185c-.3-.267-.317-.354-.162-.813l-.2-.097-.242.5-1.61-.777zm2.294-.823c.412.106.795-.135.914-.594.128-.497-.051-.85-.636-1.02l-.078.302c.402.129.53.341.453.64-.071.274-.32.429-.58.362-.192-.05-.327-.206-.395-.453l-.097-.362c-.157-.581-.349-.788-.876-.953l-.418 1.618.299.077.33-1.279c.19.082.289.225.387.568l.096.39c.094.387.303.627.601.704zm-.55-2.313c.28.015.482-.115.636-.397.141.267.264.359.5.372.393.022.686-.27.71-.715.026-.442-.232-.768-.625-.79-.233-.014-.365.064-.538.31-.122-.295-.309-.447-.584-.462-.46-.026-.783.303-.811.798-.028.495.257.858.712.884zm1.147-.343c-.233-.014-.379-.196-.364-.457.015-.262.18-.426.417-.413.24.014.386.196.371.457-.015.265-.18.426-.424.413zm-1.132.024c-.297-.016-.469-.239-.451-.557.017-.304.216-.505.51-.489.293.017.465.24.447.55-.017.311-.213.513-.506.496zm-.72-2.273 2.485-.346-.028-.203c-.398-.056-.46-.119-.586-.587l-.22.03.076.55-1.77.247zm-.515-2.352.26-.128-.667-1.368.796-.388.616 1.263.26-.127-.615-1.263.741-.362.64 1.311.26-.127-.783-1.607-2.32 1.131zm-.085-2.948c.613-.514.732-1.132.31-1.633l-.64-.762-1.975 1.66.64.762c.419.498 1.05.49 1.665-.027zm-.214-.25c-.499.42-.938.437-1.265.046l-.392-.466 1.531-1.286.392.466c.328.39.238.817-.266 1.24zm-3.236-1.458.147-.25-1.313-.77.447-.764 1.213.71.147-.25-1.213-.71.417-.712 1.259.738.146-.25-1.542-.905-1.305 2.227zm-2.024-1.156.022-.079c-.095-.116-.096-.212-.003-.543.112-.41.086-.55-.148-.744.318-.054.48-.195.563-.477.125-.428-.075-.74-.561-.883l-1.142-.333-.723 2.478.316.092.312-1.067.815.238c.279.081.372.256.28.56l-.069.22c-.048.152-.06.31-.046.426zm.091-1.895c-.085.292-.273.381-.61.283l-.764-.223.249-.853.764.223c.354.103.443.292.361.57zm-2.54.49c.012-.31-.122-.503-.446-.643a.584.584 0 0 0 .379-.549c.014-.375-.25-.665-.739-.684l-1.047-.04-.1 2.578 1.164.045c.463.018.772-.282.789-.706zm-.398-1.159c-.01.262-.168.405-.532.39l-.637-.024.032-.82.636.024c.365.014.511.168.5.43zm.069 1.15c-.01.248-.17.437-.48.425l-.804-.031.035-.888.803.031c.31.012.455.213.446.464zm-2.171.678-.575-2.515-.445.101-.231 2.36-1.246-2.022-.446.102.576 2.516.303-.07-.482-2.108 1.197 1.945.338-.077.225-2.27.482 2.108zm-2.796.733-.137-.256-1.342.718-.417-.78 1.24-.663-.138-.256-1.24.662-.388-.727 1.286-.688-.137-.256-1.576.843 1.216 2.276zm-2.124 1.258-1.577-2.043-.26.201 1.577 2.043zm-2.282-1.142-.21-.199-1.392 1.472.211.199.584-.617 1.664 1.573.227-.24-1.665-1.573zm-1.453 2.327c-.418-.246-.798-.137-1.057.302l-.54.918 2.223 1.31.167-.284-.942-.555.411-.699c.216-.366.107-.774-.262-.992zm-.186.289c.244.144.295.391.135.663l-.349.592-.78-.46.348-.592c.16-.272.402-.347.646-.203zm.588 2.711-.278-.085-.444 1.457-.846-.258.41-1.345-.278-.084-.41 1.344-.789-.24.425-1.396-.277-.084-.521 1.71 2.468.752zm-1.35 2.207c-.318-.02-.563.164-.68.509l-.212.636c-.1.306-.209.413-.407.4-.261-.015-.442-.256-.421-.603.025-.41.226-.631.562-.611l.018-.311c-.505-.03-.82.302-.855.895-.034.566.256.934.722.962.315.02.523-.135.631-.469l.209-.63c.104-.32.244-.46.445-.448.283.017.436.24.41.685-.03.487-.288.713-.656.69l-.019.312c.608.036.926-.356.963-.964.039-.653-.25-1.026-.71-1.053zm-.069 3.582c-.48.124-.713.524-.592.99a.737.737 0 0 0 .263.412l-.652.065-.261-1.01-.298.076.323 1.255 1.319-.147-.072-.277c-.204-.098-.292-.2-.34-.388-.085-.325.071-.585.431-.678.35-.09.6.061.686.39.068.264-.024.46-.28.602l.078.302c.457-.224.579-.548.467-.98-.126-.49-.558-.744-1.072-.612zm1.584 2.223-2.26 1.092.089.185c.395-.07.474-.029.737.379l.201-.097-.242-.5 1.61-.778z",
    fill: "#e60000"
  })), _path839 || (_path839 = /*#__PURE__*/React.createElement("path", {
    d: "m545.964 311.534-44.319-73.99-44.166 73.99Z",
    fill: "none",
    stroke: "#000",
    strokeWidth: 0.406215
  })), _path840 || (_path840 = /*#__PURE__*/React.createElement("path", {
    d: "M475.66 329.74c.718-.352-.132-1.597-.132-1.597l2.682-.563c-1.309-.57-3.27-.413-3.27-.413-.501.413-.415.937-.501 1.283-.066.413-.066 1.004.194 1.29.285.194 1.026 0 1.026 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.406215
  })), _path841 || (_path841 = /*#__PURE__*/React.createElement("path", {
    d: "M475.507 328.12s.85 1.223.13 1.597l4.71-.854s-.72-.502-2.16-1.283zM527.675 329.74c-.72-.352.128-1.597.128-1.597l-2.679-.563c1.284-.57 3.25-.413 3.25-.413.5.413.412.937.5 1.283.062.413.062 1.004-.2 1.29-.28.194-1 0-1 0z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.406215
  })), _path842 || (_path842 = /*#__PURE__*/React.createElement("path", {
    d: "M527.825 328.12s-.847 1.223-.128 1.597l-4.71-.854s.72-.502 2.16-1.283z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.406215
  })), _path843 || (_path843 = /*#__PURE__*/React.createElement("path", {
    d: "M501.624 335.538c1.503 0 3.116 0 9.852-1.658 6.737-1.59 12.337-5.715 13.626-6.3 1.284-.57 3.248-.413 3.248-.413-.72-.721-2.813-2.685-5.713-2.685-2.964 0-1.721 0-4.272 1.071-2.464 1-7.674 4.203-16.459 4.203h-.13c-8.851 0-14.28-3.182-16.83-4.203-2.442-1.071-1.373-1.071-4.274-1.071-2.964 0-4.991 1.942-5.71 2.684 0 0 1.94-.134 3.27.414 1.285.563 6.888 4.71 13.625 6.3 6.735 1.658 8.415 1.658 9.787 1.658z",
    fill: "#fff",
    stroke: "#000",
    strokeWidth: 0.406215
  })), _path844 || (_path844 = /*#__PURE__*/React.createElement("path", {
    d: "m520.228 329.213-1.28-2.677.555-.265q.6-.287.918-.32.454-.05.834.183.38.231.603.697.193.402.164.791-.027.388-.236.667-.207.278-.707.517zm.135-.376.31-.148q.554-.265.736-.437.255-.242.306-.58.05-.339-.126-.708-.185-.388-.504-.573-.319-.185-.702-.127-.288.044-.865.32l-.189.09zm-3.065-1.435 2.54 2.064-.286.14-.846-.675-1.15.558.01 1.08-.298.145-.035-3.28zm.242.582.01 1.19.913-.444zm-2.972.962-.113-.266 1.497-.637.113.265-.609.26 1.049 2.464-.278.118-1.049-2.464zm-2.02.437.555-.201q.464-.168.643-.19.269-.033.492.099.223.13.322.402.082.228.037.44-.044.21-.211.372-.168.159-.518.288l1.473.934-.345.125-1.47-.935-.16.058.469 1.297-.279.1zm.377.172.343.948.48-.17q.28-.1.393-.201.116-.102.148-.245.033-.145-.02-.289-.05-.14-.167-.226-.118-.089-.259-.093-.14-.005-.427.099zm-2.314.394 1.636-.463.08.282-1.35.382.252.892 1.339-.378.079.279-1.34.379.317 1.12 1.34-.38.079.282-1.624.46zm-2.122.458.572-.122q.345-.073.548-.03.203.042.345.189.145.146.189.353.04.194-.02.374-.061.177-.223.315.243.029.387.107.144.077.243.21.1.132.136.304.075.349-.13.646-.204.295-.634.386l-.797.17zm.344.223.198.93.165-.036q.302-.064.432-.15.13-.087.188-.225.056-.14.025-.288-.042-.199-.206-.281-.163-.086-.466-.021zm.26 1.221.236 1.113.36-.076q.317-.068.452-.16.134-.095.195-.246.062-.152.03-.305-.041-.194-.198-.31-.157-.118-.39-.124-.155-.004-.522.074zm-1.527-1.266.29-.057.573 2.91-.29.058zm-1.79.334.294-.053.479 2.637 1.12-.204.052.282-1.415.257zm-3.633 3.425-.232-2.957.064-.005 2.144 2.109-.178-2.264.292-.023.232 2.957-.066.006-2.126-2.082.176 2.235zm-1.902-3.125q.672.053 1.089.537.416.484.364 1.14-.051.649-.54 1.065-.485.417-1.135.365-.657-.052-1.074-.538-.416-.486-.366-1.125.034-.426.268-.774.236-.348.608-.524.372-.18.786-.146zm-.009.29q-.327-.026-.634.122-.307.147-.495.424-.188.276-.216.632-.042.527.293.92.337.39.852.431.344.027.648-.116.307-.144.493-.42.188-.277.216-.63.028-.353-.115-.65-.14-.297-.424-.492-.284-.194-.618-.22zm-2.13-.5.293.047-.468 2.929-.293-.047zm-3.43 2.392.547-2.916.063.012 1.52 2.596.419-2.232.287.054-.547 2.916-.066-.013-1.508-2.564-.414 2.203zm-1.993-3.461.29.064-.39 1.748q-.07.311-.075.39-.017.177.036.31.053.132.2.247.145.114.31.15.144.032.29 0 .145-.03.258-.12.113-.088.188-.232.054-.104.13-.446l.39-1.748.29.064-.39 1.748q-.086.388-.217.61-.127.222-.395.349-.266.126-.589.054-.35-.078-.563-.3-.213-.224-.236-.518-.015-.181.083-.622zm-3.824 1.324.287-.062q.094.55.424.663.141.048.288.025.147-.024.25-.113.102-.089.144-.213.048-.14-.001-.309-.068-.232-.328-.614-.26-.385-.306-.533-.081-.25-.003-.48.063-.183.202-.304.14-.121.327-.153.19-.033.377.03.199.068.337.226.14.156.243.486l-.288.095q-.087-.264-.177-.369-.088-.104-.22-.15-.17-.057-.313.009-.142.066-.194.217-.03.092-.022.19.009.1.076.235.037.073.267.405.273.393.337.649t-.009.468q-.104.305-.413.451-.308.147-.64.034-.256-.087-.418-.294-.161-.208-.227-.589zm-.719-2.983q.62.264.861.856.242.591-.016 1.196-.255.6-.85.84-.593.24-1.192-.015-.607-.259-.848-.852-.24-.593.01-1.183.168-.394.5-.649.334-.254.743-.304.41-.051.792.111zm-.1.273q-.303-.129-.641-.086-.338.042-.604.245-.266.202-.406.53-.206.487-.013.966.195.477.67.68.317.134.652.095.337-.039.6-.242.266-.203.405-.53.139-.324.098-.65-.038-.328-.246-.602-.207-.275-.516-.406zm-1.97-1.14.266.128-1.293 2.67-.267-.129zm-4.006 1.307 1.323-2.655.55.274q.596.297.818.527.318.328.369.77.052.443-.179.905-.199.398-.523.615-.323.218-.67.225-.347.007-.843-.24zm.38-.124.306.153q.55.274.798.312.348.052.646-.116.298-.169.48-.535.192-.384.142-.75-.05-.365-.332-.631-.21-.2-.783-.485l-.188-.094z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSv);
export default __webpack_public_path__ + "static/media/sv.c3ff7d65c50eac2a8512f002270e63f5.svg";
export { ForwardRef as ReactComponent };